import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import axios from 'axios';
import { clusterApiUrl, Connection as Connection$1, PublicKey, Transaction as Transaction$1, TransactionInstruction, SYSVAR_CLOCK_PUBKEY, SYSVAR_RENT_PUBKEY, SystemProgram, Keypair } from '@solana/web3.js';
import { Buffer as Buffer$1 } from 'buffer';
import { BinaryReader, BinaryWriter, serialize as _serialize, deserializeUnchecked, deserialize as deserialize$3 } from 'borsh';
import bs58 from 'bs58';
import { sha256 } from 'crypto-hash';
import BN from 'bn.js';
import { TOKEN_PROGRAM_ID, AccountLayout, u64, MintLayout, Token, ASSOCIATED_TOKEN_PROGRAM_ID, NATIVE_MINT } from '@solana/spl-token';
var Currency;

(function (Currency) {
  Currency["USD"] = "usd";
  Currency["EUR"] = "eur";
  Currency["AR"] = "ar";
  Currency["SOL"] = "sol";
})(Currency || (Currency = {}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var Coingecko = /*#__PURE__*/function () {
  function Coingecko() {
    _classCallCheck(this, Coingecko);
  }

  _createClass(Coingecko, [{
    key: "getRate",
    value: function getRate(from, to) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var fromArray, toArray, fromIds, toIds, url, response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fromArray = typeof from === 'string' ? [from] : from;
                toArray = typeof to === 'string' ? [to] : to;
                fromIds = fromArray.map(function (currency) {
                  return Coingecko.translateCurrency(currency);
                }).join(',');
                toIds = toArray.map(function (currency) {
                  return Coingecko.translateCurrency(currency);
                }).join(',');
                url = "https://api.coingecko.com/api/v3/simple/price?ids=".concat(fromIds, "&vs_currencies=").concat(toIds);
                _context.next = 7;
                return axios(url);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return response.data;

              case 10:
                data = _context.sent;
                return _context.abrupt("return", fromArray.reduce(function (previousPairs, fromCurrency) {
                  return [].concat(_toConsumableArray(previousPairs), _toConsumableArray(toArray.map(function (toCurrency) {
                    return {
                      from: fromCurrency,
                      to: toCurrency,
                      rate: data[Coingecko.translateCurrency(fromCurrency)][Coingecko.translateCurrency(toCurrency)]
                    };
                  })));
                }, []));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }], [{
    key: "translateCurrency",
    value: function translateCurrency(currency) {
      switch (currency) {
        case Currency.AR:
          return 'arweave';

        case Currency.SOL:
          return 'solana';

        case Currency.USD:
          return 'usd';

        case Currency.EUR:
          return 'eur';

        default:
          throw new Error('Invalid currency supplied to Coingecko conversion rate provider');
      }
    }
  }]);

  return Coingecko;
}();
/* eslint-env browser */


var browser = typeof self == 'object' ? self.FormData : window.FormData;
var ARWEAVE_URL = 'https://arweave.net';
var LAMPORT_MULTIPLIER = Math.pow(10, 9);
var WINSTON_MULTIPLIER = Math.pow(10, 12);

var ArweaveStorage = /*#__PURE__*/function () {
  function ArweaveStorage(_ref) {
    var endpoint = _ref.endpoint,
        env = _ref.env;

    _classCallCheck(this, ArweaveStorage);

    this.endpoint = endpoint;
    this.env = env;
  }

  _createClass(ArweaveStorage, [{
    key: "getAssetCostToStore",
    value: function getAssetCostToStore(files, arweaveRate, solanaRate) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var buffers, totalBytes, txnFeeInWinstons, byteCostInWinstons, totalArCost, arMultiplier;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                buffers = Array.from(files.values());
                totalBytes = buffers.reduce(function (sum, f) {
                  return sum += f.byteLength;
                }, 0);
                _context2.t0 = parseInt;
                _context2.next = 5;
                return axios("".concat(ARWEAVE_URL, "/price/0"));

              case 5:
                _context2.next = 7;
                return _context2.sent.data;

              case 7:
                _context2.t1 = _context2.sent;
                txnFeeInWinstons = (0, _context2.t0)(_context2.t1);
                _context2.t2 = parseInt;
                _context2.next = 12;
                return axios("".concat(ARWEAVE_URL, "/price/").concat(totalBytes.toString()));

              case 12:
                _context2.next = 14;
                return _context2.sent.data;

              case 14:
                _context2.t3 = _context2.sent;
                byteCostInWinstons = (0, _context2.t2)(_context2.t3);
                totalArCost = (txnFeeInWinstons * buffers.length + byteCostInWinstons) / WINSTON_MULTIPLIER;
                arMultiplier = arweaveRate / solanaRate;
                return _context2.abrupt("return", LAMPORT_MULTIPLIER * totalArCost * arMultiplier * 1.1);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "upload",
    value: function upload(files, mintKey, txid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var fileEntries, tags, body, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fileEntries = Array.from(files.entries());
                tags = fileEntries.reduce(function (acc, _ref2) {
                  var _ref3 = _slicedToArray(_ref2, 1),
                      fileName = _ref3[0];

                  acc[fileName] = [{
                    name: 'mint',
                    value: mintKey
                  }];
                  return acc;
                }, {});
                body = new browser();
                body.append('tags', JSON.stringify(tags));
                body.append('transaction', txid);
                body.append('env', this.env);
                fileEntries.map(function (_ref4) {
                  var _ref5 = _slicedToArray(_ref4, 2),
                      file = _ref5[1];

                  body.append('file[]', file);
                });
                _context3.next = 9;
                return axios.post(this.endpoint, body);

              case 9:
                response = _context3.sent;

                if (!response.data.error) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(new Error(response.data.error)));

              case 12:
                return _context3.abrupt("return", response.data);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);

  return ArweaveStorage;
}();

var ChainId;

(function (ChainId) {
  ChainId[ChainId["MainnetBeta"] = 101] = "MainnetBeta";
  ChainId[ChainId["Testnet"] = 102] = "Testnet";
  ChainId[ChainId["Devnet"] = 103] = "Devnet";
})(ChainId || (ChainId = {}));

var ENV = {
  devnet: {
    endpoint: clusterApiUrl('devnet'),
    ChainId: ChainId.Devnet
  },
  'mainnet-beta': {
    endpoint: 'https://api.metaplex.solana.com/',
    ChainId: ChainId.MainnetBeta
  },
  'mainnet-beta (Solana)': {
    endpoint: 'https://api.mainnet-beta.solana.com',
    ChainId: ChainId.MainnetBeta
  },
  'mainnet-beta (Serum)': {
    endpoint: 'https://solana-api.projectserum.com/',
    ChainId: ChainId.MainnetBeta
  },
  testnet: {
    endpoint: clusterApiUrl('testnet'),
    ChainId: ChainId.Testnet
  }
};

var Connection = /*#__PURE__*/function (_Connection$) {
  _inherits(Connection, _Connection$);

  var _super = _createSuper(Connection);

  function Connection() {
    var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'mainnet-beta';
    var commitment = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, Connection);

    if (endpoint in ENV) endpoint = ENV[endpoint].endpoint;
    return _super.call(this, endpoint, commitment);
  }

  return Connection;
}(Connection$1);

var NodeWallet = /*#__PURE__*/function () {
  function NodeWallet(payer) {
    _classCallCheck(this, NodeWallet);

    this.payer = payer;
  }

  _createClass(NodeWallet, [{
    key: "signTransaction",
    value: function signTransaction(tx) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                tx.partialSign(this.payer);
                return _context4.abrupt("return", tx);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(txs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", txs.map(function (tx) {
                  tx.partialSign(_this.payer);
                  return tx;
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this.payer.publicKey;
    }
  }]);

  return NodeWallet;
}();

var Account = /*#__PURE__*/function () {
  function Account(pubkey, info) {
    _classCallCheck(this, Account);

    this.pubkey = new PublicKey(pubkey);
    this.info = info;
  }

  _createClass(Account, [{
    key: "assertOwner",
    value: function assertOwner(pubkey) {
      var _a;

      return (_a = this.info) === null || _a === void 0 ? void 0 : _a.owner.equals(new PublicKey(pubkey));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _a, _b, _c, _d, _e;

      return {
        pubkey: this.pubkey.toString(),
        info: {
          executable: !!((_a = this.info) === null || _a === void 0 ? void 0 : _a.executable),
          owner: ((_b = this.info) === null || _b === void 0 ? void 0 : _b.owner) ? new PublicKey((_c = this.info) === null || _c === void 0 ? void 0 : _c.owner) : null,
          lamports: (_d = this.info) === null || _d === void 0 ? void 0 : _d.lamports,
          data: (_e = this.info) === null || _e === void 0 ? void 0 : _e.data.toJSON()
        },
        data: this.data
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this.toJSON());
    }
  }], [{
    key: "from",
    value: function from(account) {
      return new this(account.pubkey, account.info);
    }
  }, {
    key: "load",
    value: function load(connection, pubkey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var info;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Account.getInfo(connection, pubkey);

              case 2:
                info = _context6.sent;
                return _context6.abrupt("return", new this(pubkey, info));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(data) {
      throw new Error("method 'isCompatible' is not implemented");
    }
  }, {
    key: "getInfo",
    value: function getInfo(connection, pubkey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var info;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return connection.getAccountInfo(new PublicKey(pubkey));

              case 2:
                info = _context7.sent;

                if (info) {
                  _context7.next = 5;
                  break;
                }

                throw new Error("Unable to find account: ".concat(pubkey));

              case 5:
                return _context7.abrupt("return", Object.assign(Object.assign({}, info), {
                  data: Buffer$1.from(info === null || info === void 0 ? void 0 : info.data)
                }));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }, {
    key: "getInfos",
    value: function getInfos(connection, pubkeys) {
      var commitment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'recent';
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var BATCH_SIZE, promises, i, results;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                BATCH_SIZE = 99;
                promises = [];

                for (i = 0; i < pubkeys.length; i += BATCH_SIZE) {
                  promises.push(Account.getMultipleAccounts(connection, pubkeys.slice(i, Math.min(pubkeys.length, i + BATCH_SIZE)), commitment));
                }

                results = new Map();
                _context8.next = 6;
                return Promise.all(promises);

              case 6:
                _context8.sent.forEach(function (result) {
                  var _a;

                  return _toConsumableArray((_a = result === null || result === void 0 ? void 0 : result.entries()) !== null && _a !== void 0 ? _a : []).forEach(function (_ref6) {
                    var _ref7 = _slicedToArray(_ref6, 2),
                        k = _ref7[0],
                        v = _ref7[1];

                    return results.set(k, v);
                  });
                });

                return _context8.abrupt("return", results);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }, {
    key: "getMultipleAccounts",
    value: function getMultipleAccounts(connection, pubkeys, commitment) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var args, unsafeRes, infos;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                args = connection._buildArgs([pubkeys.map(function (k) {
                  return k.toString();
                })], commitment, 'base64');
                _context9.next = 3;
                return connection._rpcRequest('getMultipleAccounts', args);

              case 3:
                unsafeRes = _context9.sent;

                if (!unsafeRes.error) {
                  _context9.next = 6;
                  break;
                }

                throw new Error('failed to get info about accounts ' + unsafeRes.error.message);

              case 6:
                if (unsafeRes.result.value) {
                  _context9.next = 8;
                  break;
                }

                return _context9.abrupt("return");

              case 8:
                infos = unsafeRes.result.value.filter(Boolean).map(function (info) {
                  return Object.assign(Object.assign({}, info), {
                    data: Buffer$1.from(info.data[0], 'base64')
                  });
                });
                return _context9.abrupt("return", infos.reduce(function (acc, info, index) {
                  acc.set(pubkeys[index], info);
                  return acc;
                }, new Map()));

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    }
  }]);

  return Account;
}();

var extendBorsh = function extendBorsh() {
  BinaryReader.prototype.readPubkey = function () {
    var reader = this;
    var array = reader.readFixedArray(32);
    return new PublicKey(array);
  };

  BinaryWriter.prototype.writePubkey = function (value) {
    var writer = this;
    writer.writeFixedArray(value.toBuffer());
  };

  BinaryReader.prototype.readPubkeyAsString = function () {
    var reader = this;
    var array = reader.readFixedArray(32);
    return bs58.encode(array);
  };

  BinaryWriter.prototype.writePubkeyAsString = function (value) {
    var writer = this;
    writer.writeFixedArray(bs58.decode(value));
  };
};

extendBorsh();

var Data = /*#__PURE__*/function () {
  function Data() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Data);

    Object.assign(this, args);
  }

  _createClass(Data, null, [{
    key: "struct",
    value: function struct(fields) {
      return _struct(this, fields);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Buffer.from(_serialize(this.SCHEMA, new this(args)));
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return deserializeUnchecked(this.SCHEMA, this, data);
    }
  }]);

  return Data;
}();

var _struct = function _struct(type, fields) {
  return new Map([[type, {
    kind: 'struct',
    fields: fields
  }]]);
};

var borsh = /*#__PURE__*/Object.freeze({
  __proto__: null,
  extendBorsh: extendBorsh,
  Data: Data,
  struct: _struct,
  deserialize: deserialize$3,
  deserializeUnchecked: deserializeUnchecked,
  serialize: _serialize
});

var getFileHash = function getFileHash(file) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.t0 = Buffer$1;
            _context10.next = 3;
            return sha256(file.toString());

          case 3:
            _context10.t1 = _context10.sent;
            return _context10.abrupt("return", _context10.t0.from.call(_context10.t0, _context10.t1));

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};

var crypto = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFileHash: getFileHash
});

var lookup = function lookup(url) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var _yield$axios$get, data;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return axios.get(url);

          case 3:
            _yield$axios$get = _context11.sent;
            data = _yield$axios$get.data;
            return _context11.abrupt("return", data);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            throw new Error("unable to get metadata json from url ".concat(url));

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 8]]);
  }));
};

var metadata = /*#__PURE__*/Object.freeze({
  __proto__: null,
  lookup: lookup
});
var TupleNumericType;

(function (TupleNumericType) {
  TupleNumericType[TupleNumericType["U8"] = 1] = "U8";
  TupleNumericType[TupleNumericType["U16"] = 2] = "U16";
  TupleNumericType[TupleNumericType["U32"] = 4] = "U32";
  TupleNumericType[TupleNumericType["U64"] = 8] = "U64";
})(TupleNumericType || (TupleNumericType = {}));

var getBNFromData = function getBNFromData(data, offset, dataType) {
  switch (dataType) {
    case TupleNumericType.U8:
      return new BN(data[offset], 'le');

    case TupleNumericType.U16:
      return new BN(data.slice(offset, offset + 2), 'le');

    case TupleNumericType.U32:
      return new BN(data.slice(offset, offset + 4), 'le');

    case TupleNumericType.U64:
      return new BN(data.slice(offset, offset + 8), 'le');
  }
};

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Borsh: borsh,
  Crypto: crypto,
  metadata: metadata,

  get TupleNumericType() {
    return TupleNumericType;
  },

  getBNFromData: getBNFromData
});
var ErrorCode;

(function (ErrorCode) {
  ErrorCode[ErrorCode["ERROR_INVALID_OWNER"] = 0] = "ERROR_INVALID_OWNER";
  ErrorCode[ErrorCode["ERROR_INVALID_ACCOUNT_DATA"] = 1] = "ERROR_INVALID_ACCOUNT_DATA";
  ErrorCode[ErrorCode["ERROR_DEPRECATED_ACCOUNT_DATA"] = 2] = "ERROR_DEPRECATED_ACCOUNT_DATA";
})(ErrorCode || (ErrorCode = {}));

var MetaplexError = /*#__PURE__*/function (_Error) {
  _inherits(MetaplexError, _Error);

  var _super2 = _createSuper(MetaplexError);

  function MetaplexError(errorCode, message) {
    var _this2;

    _classCallCheck(this, MetaplexError);

    _this2 = _super2.call(this, message);
    _this2.errorCode = errorCode;
    return _this2;
  }

  return MetaplexError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ERROR_INVALID_OWNER = function ERROR_INVALID_OWNER() {
  return new MetaplexError(ErrorCode.ERROR_INVALID_OWNER, 'Invalid owner');
};

var ERROR_INVALID_ACCOUNT_DATA = function ERROR_INVALID_ACCOUNT_DATA() {
  return new MetaplexError(ErrorCode.ERROR_INVALID_ACCOUNT_DATA, 'Invalid data');
};

var ERROR_DEPRECATED_ACCOUNT_DATA = function ERROR_DEPRECATED_ACCOUNT_DATA() {
  return new MetaplexError(ErrorCode.ERROR_DEPRECATED_ACCOUNT_DATA, 'Account data is deprecated');
};

var errors = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get ErrorCode() {
    return ErrorCode;
  },

  MetaplexError: MetaplexError,
  ERROR_INVALID_OWNER: ERROR_INVALID_OWNER,
  ERROR_INVALID_ACCOUNT_DATA: ERROR_INVALID_ACCOUNT_DATA,
  ERROR_DEPRECATED_ACCOUNT_DATA: ERROR_DEPRECATED_ACCOUNT_DATA
});

var Transaction = /*#__PURE__*/function (_Transaction$) {
  _inherits(Transaction, _Transaction$);

  var _super3 = _createSuper(Transaction);

  function Transaction(options) {
    _classCallCheck(this, Transaction);

    return _super3.call(this, options);
  }

  _createClass(Transaction, null, [{
    key: "fromCombined",
    value: function fromCombined(transactions) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var combinedTransaction = new Transaction(options);
      transactions.forEach(function (transaction) {
        return transaction.instructions.forEach(function (instruction) {
          combinedTransaction.add(instruction);
        });
      });
      return combinedTransaction;
    }
  }]);

  return Transaction;
}(Transaction$1);

var sendTransaction = function sendTransaction(_ref8) {
  var connection = _ref8.connection,
      wallet = _ref8.wallet,
      txs = _ref8.txs,
      _ref8$signers = _ref8.signers,
      signers = _ref8$signers === void 0 ? [] : _ref8$signers,
      options = _ref8.options;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var tx, _tx;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            tx = Transaction.fromCombined(txs, {
              feePayer: wallet.publicKey
            });
            _context12.next = 3;
            return connection.getRecentBlockhash();

          case 3:
            tx.recentBlockhash = _context12.sent.blockhash;

            if (signers.length) {
              (_tx = tx).partialSign.apply(_tx, _toConsumableArray(signers));
            }

            _context12.next = 7;
            return wallet.signTransaction(tx);

          case 7:
            tx = _context12.sent;
            return _context12.abrupt("return", connection.sendRawTransaction(tx.serialize(), options));

          case 9:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
};

var Program = /*#__PURE__*/function () {
  function Program() {
    _classCallCheck(this, Program);
  }

  _createClass(Program, null, [{
    key: "findProgramAddress",
    value: function findProgramAddress(seeds) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return PublicKey.findProgramAddress(seeds, this.PUBKEY);

              case 2:
                return _context13.abrupt("return", _context13.sent[0]);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getProgramAccounts",
    value: function getProgramAccounts(connection, configOrCommitment) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var extra, commitment, args, unsafeRes;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                extra = {};

                if (configOrCommitment) {
                  if (typeof configOrCommitment === 'string') {
                    commitment = configOrCommitment;
                  } else {
                    commitment = configOrCommitment.commitment;

                    if (configOrCommitment.dataSlice) {
                      extra.dataSlice = configOrCommitment.dataSlice;
                    }

                    if (configOrCommitment.filters) {
                      extra.filters = configOrCommitment.filters;
                    }
                  }
                }

                args = connection._buildArgs([this.PUBKEY.toBase58()], commitment, 'base64', extra);
                _context14.next = 5;
                return connection._rpcRequest('getProgramAccounts', args);

              case 5:
                unsafeRes = _context14.sent;
                return _context14.abrupt("return", unsafeRes.result.map(function (_ref9) {
                  var _ref9$account = _ref9.account,
                      data = _ref9$account.data,
                      executable = _ref9$account.executable,
                      lamports = _ref9$account.lamports,
                      owner = _ref9$account.owner,
                      pubkey = _ref9.pubkey;
                  return {
                    account: {
                      data: Buffer$1.from(data[0], 'base64'),
                      executable: executable,
                      lamports: lamports,
                      owner: new PublicKey(owner)
                    },
                    pubkey: new PublicKey(pubkey)
                  };
                }).map(function (_ref10) {
                  var pubkey = _ref10.pubkey,
                      account = _ref10.account;
                  return new Account(pubkey, account);
                }));

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }]);

  return Program;
}();

var config = {
  arweaveWallet: 'HvwC9QSAzvGXhhVrgPmauVwFWcYZhne3hVot9EbHuFTm',
  programs: {
    auction: 'auctxRXPeJoc4817jDhf4HbjnhEcr1cCXenosMhK5R8',
    metadata: 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s',
    metaplex: 'p1exdMJcjVao65QdewkaZRUnU6VPSXhus9n2GzWfh98',
    vault: 'vau1zxA2LbssAUEF7Gpw91zMM1LvXrvpzJtmZ58rPsn',
    packs: 'BNRmGgciUJuyznkYHnmitA9an1BcDDiU9JmjEQwvBYVR',
    memo: 'MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr',
    token: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA'
  },
  maxCreatorLimit: 5
};
var MetaplexKey;

(function (MetaplexKey) {
  MetaplexKey[MetaplexKey["Uninitialized"] = 0] = "Uninitialized";
  MetaplexKey[MetaplexKey["OriginalAuthorityLookupV1"] = 1] = "OriginalAuthorityLookupV1";
  MetaplexKey[MetaplexKey["BidRedemptionTicketV1"] = 2] = "BidRedemptionTicketV1";
  MetaplexKey[MetaplexKey["StoreV1"] = 3] = "StoreV1";
  MetaplexKey[MetaplexKey["WhitelistedCreatorV1"] = 4] = "WhitelistedCreatorV1";
  MetaplexKey[MetaplexKey["PayoutTicketV1"] = 5] = "PayoutTicketV1";
  MetaplexKey[MetaplexKey["SafetyDepositValidationTicketV1"] = 6] = "SafetyDepositValidationTicketV1";
  MetaplexKey[MetaplexKey["AuctionManagerV1"] = 7] = "AuctionManagerV1";
  MetaplexKey[MetaplexKey["PrizeTrackingTicketV1"] = 8] = "PrizeTrackingTicketV1";
  MetaplexKey[MetaplexKey["SafetyDepositConfigV1"] = 9] = "SafetyDepositConfigV1";
  MetaplexKey[MetaplexKey["AuctionManagerV2"] = 10] = "AuctionManagerV2";
  MetaplexKey[MetaplexKey["BidRedemptionTicketV2"] = 11] = "BidRedemptionTicketV2";
  MetaplexKey[MetaplexKey["AuctionWinnerTokenTypeTrackerV1"] = 12] = "AuctionWinnerTokenTypeTrackerV1";
})(MetaplexKey || (MetaplexKey = {}));

var MetaplexProgram = /*#__PURE__*/function (_Program) {
  _inherits(MetaplexProgram, _Program);

  var _super4 = _createSuper(MetaplexProgram);

  function MetaplexProgram() {
    _classCallCheck(this, MetaplexProgram);

    return _super4.apply(this, arguments);
  }

  return MetaplexProgram;
}(Program);

MetaplexProgram.PREFIX = 'metaplex';
MetaplexProgram.TOTALS = 'totals';
MetaplexProgram.PUBKEY = new PublicKey(config.programs.metaplex);
var WINNER_INDEX_OFFSETS = [2, 10];

var BidRedemptionTicket = /*#__PURE__*/function (_Account) {
  _inherits(BidRedemptionTicket, _Account);

  var _super5 = _createSuper(BidRedemptionTicket);

  function BidRedemptionTicket(pubkey, info) {
    var _this3;

    _classCallCheck(this, BidRedemptionTicket);

    _this3 = _super5.call(this, pubkey, info);

    if (!_this3.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (BidRedemptionTicket.isBidRedemptionTicketV1(_this3.info.data)) {
      throw ERROR_DEPRECATED_ACCOUNT_DATA();
    } else if (BidRedemptionTicket.isBidRedemptionTicketV2(_this3.info.data)) {
      var data = _this3.info.data.toJSON().data;

      var winnerIndex = data[1] !== 0 && new BN(data.slice(1, 9), 'le');
      var offset = WINNER_INDEX_OFFSETS[+!!winnerIndex];
      _this3.data = {
        key: MetaplexKey.BidRedemptionTicketV2,
        winnerIndex: winnerIndex,
        data: data,
        auctionManager: bs58.encode(data.slice(offset, offset + 32))
      };
    } else {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    return _this3;
  }

  _createClass(BidRedemptionTicket, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return BidRedemptionTicket.isBidRedemptionTicketV1(data) || BidRedemptionTicket.isBidRedemptionTicketV2(data);
    }
  }, {
    key: "isBidRedemptionTicketV1",
    value: function isBidRedemptionTicketV1(data) {
      return data[0] === MetaplexKey.BidRedemptionTicketV1;
    }
  }, {
    key: "isBidRedemptionTicketV2",
    value: function isBidRedemptionTicketV2(data) {
      return data[0] === MetaplexKey.BidRedemptionTicketV2;
    }
  }]);

  return BidRedemptionTicket;
}(Account);

var AuctionProgram = /*#__PURE__*/function (_Program2) {
  _inherits(AuctionProgram, _Program2);

  var _super6 = _createSuper(AuctionProgram);

  function AuctionProgram() {
    _classCallCheck(this, AuctionProgram);

    return _super6.apply(this, arguments);
  }

  return AuctionProgram;
}(Program);

AuctionProgram.PREFIX = 'auction';
AuctionProgram.EXTENDED = 'extended';
AuctionProgram.PUBKEY = new PublicKey(config.programs.auction);

var _a$C;

var BidderMetadataData = /*#__PURE__*/function (_Data) {
  _inherits(BidderMetadataData, _Data);

  var _super7 = _createSuper(BidderMetadataData);

  function BidderMetadataData() {
    _classCallCheck(this, BidderMetadataData);

    return _super7.apply(this, arguments);
  }

  return BidderMetadataData;
}(Data);

_a$C = BidderMetadataData;
BidderMetadataData.SCHEMA = _a$C.struct([['bidderPubkey', 'pubkeyAsString'], ['auctionPubkey', 'pubkeyAsString'], ['lastBid', 'u64'], ['lastBidTimestamp', 'u64'], ['cancelled', 'u8']]);

var BidderMetadata = /*#__PURE__*/function (_Account2) {
  _inherits(BidderMetadata, _Account2);

  var _super8 = _createSuper(BidderMetadata);

  function BidderMetadata(key, info) {
    var _this4;

    _classCallCheck(this, BidderMetadata);

    _this4 = _super8.call(this, key, info);

    if (!_this4.assertOwner(AuctionProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!BidderMetadata.isCompatible(_this4.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this4.data = BidderMetadataData.deserialize(_this4.info.data);
    return _this4;
  }

  _createClass(BidderMetadata, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data.length === BidderMetadata.DATA_SIZE;
    }
  }, {
    key: "getPDA",
    value: function getPDA(auction, bidder) {
      return AuctionProgram.findProgramAddress([Buffer$1.from(AuctionProgram.PREFIX), AuctionProgram.PUBKEY.toBuffer(), new PublicKey(auction).toBuffer(), new PublicKey(bidder).toBuffer(), Buffer$1.from('metadata')]);
    }
  }]);

  return BidderMetadata;
}(Account);

BidderMetadata.DATA_SIZE = 32 + 32 + 8 + 8 + 1;

var _a$B;

var BidderPotData = /*#__PURE__*/function (_Data2) {
  _inherits(BidderPotData, _Data2);

  var _super9 = _createSuper(BidderPotData);

  function BidderPotData() {
    _classCallCheck(this, BidderPotData);

    return _super9.apply(this, arguments);
  }

  return BidderPotData;
}(Data);

_a$B = BidderPotData;
BidderPotData.SCHEMA = _a$B.struct([['bidderPot', 'pubkeyAsString'], ['bidderAct', 'pubkeyAsString'], ['auctionAct', 'pubkeyAsString'], ['emptied', 'u8']]);

var BidderPot = /*#__PURE__*/function (_Account3) {
  _inherits(BidderPot, _Account3);

  var _super10 = _createSuper(BidderPot);

  function BidderPot(key, info) {
    var _this5;

    _classCallCheck(this, BidderPot);

    _this5 = _super10.call(this, key, info);

    if (!_this5.assertOwner(AuctionProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!BidderPot.isCompatible(_this5.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this5.data = BidderPotData.deserialize(_this5.info.data);
    return _this5;
  }

  _createClass(BidderPot, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data.length === BidderPot.DATA_SIZE;
    }
  }, {
    key: "getPDA",
    value: function getPDA(auction, bidder) {
      return AuctionProgram.findProgramAddress([Buffer$1.from(AuctionProgram.PREFIX), AuctionProgram.PUBKEY.toBuffer(), new PublicKey(auction).toBuffer(), new PublicKey(bidder).toBuffer()]);
    }
  }]);

  return BidderPot;
}(Account);

BidderPot.DATA_SIZE = 32 + 32 + 32 + 1;

var _a$A, _b$6, _c$2, _d;

var AuctionState;

(function (AuctionState) {
  AuctionState[AuctionState["Created"] = 0] = "Created";
  AuctionState[AuctionState["Started"] = 1] = "Started";
  AuctionState[AuctionState["Ended"] = 2] = "Ended";
})(AuctionState || (AuctionState = {}));

var BidStateType;

(function (BidStateType) {
  BidStateType[BidStateType["EnglishAuction"] = 0] = "EnglishAuction";
  BidStateType[BidStateType["OpenEdition"] = 1] = "OpenEdition";
})(BidStateType || (BidStateType = {}));

var PriceFloorType;

(function (PriceFloorType) {
  PriceFloorType[PriceFloorType["None"] = 0] = "None";
  PriceFloorType[PriceFloorType["Minimum"] = 1] = "Minimum";
  PriceFloorType[PriceFloorType["BlindedPrice"] = 2] = "BlindedPrice";
})(PriceFloorType || (PriceFloorType = {}));

var Bid = /*#__PURE__*/function (_Data3) {
  _inherits(Bid, _Data3);

  var _super11 = _createSuper(Bid);

  function Bid() {
    _classCallCheck(this, Bid);

    return _super11.apply(this, arguments);
  }

  return Bid;
}(Data);

_a$A = Bid;
Bid.SCHEMA = _a$A.struct([['key', 'pubkeyAsString'], ['amount', 'u64']]);

var BidState = /*#__PURE__*/function (_Data4) {
  _inherits(BidState, _Data4);

  var _super12 = _createSuper(BidState);

  function BidState() {
    _classCallCheck(this, BidState);

    return _super12.apply(this, arguments);
  }

  _createClass(BidState, [{
    key: "getWinnerAt",
    value: function getWinnerAt(winnerIndex) {
      var convertedIndex = this.bids.length - winnerIndex - 1;

      if (convertedIndex >= 0 && convertedIndex < this.bids.length) {
        return this.bids[convertedIndex].key;
      } else {
        return null;
      }
    }
  }, {
    key: "getAmountAt",
    value: function getAmountAt(winnerIndex) {
      var convertedIndex = this.bids.length - winnerIndex - 1;

      if (convertedIndex >= 0 && convertedIndex < this.bids.length) {
        return this.bids[convertedIndex].amount;
      } else {
        return null;
      }
    }
  }, {
    key: "getWinnerIndex",
    value: function getWinnerIndex(bidder) {
      if (!this.bids) return null;
      var index = this.bids.findIndex(function (b) {
        return b.key === bidder;
      });

      if (index !== -1) {
        var zeroBased = this.bids.length - index - 1;
        return zeroBased < this.max.toNumber() ? zeroBased : null;
      } else return null;
    }
  }]);

  return BidState;
}(Data);

_b$6 = BidState;
BidState.SCHEMA = new Map([].concat(_toConsumableArray(Bid.SCHEMA), _toConsumableArray(_b$6.struct([['type', 'u8'], ['bids', [Bid]], ['max', 'u64']]))));

var PriceFloor = /*#__PURE__*/function (_Data5) {
  _inherits(PriceFloor, _Data5);

  var _super13 = _createSuper(PriceFloor);

  function PriceFloor(args) {
    var _this6;

    _classCallCheck(this, PriceFloor);

    _this6 = _super13.call(this);
    _this6.type = args.type;
    _this6.hash = args.hash || new Uint8Array(32);

    if (_this6.type === PriceFloorType.Minimum) {
      if (args.minPrice) {
        _this6.hash.set(args.minPrice.toArrayLike(Buffer$1, 'le', 8), 0);
      } else {
        _this6.minPrice = new BN((args.hash || new Uint8Array(0)).slice(0, 8), 'le');
      }
    }

    return _this6;
  }

  return PriceFloor;
}(Data);

_c$2 = PriceFloor;
PriceFloor.SCHEMA = _c$2.struct([['type', 'u8'], ['hash', [32]]]);

var AuctionData = /*#__PURE__*/function (_Data6) {
  _inherits(AuctionData, _Data6);

  var _super14 = _createSuper(AuctionData);

  function AuctionData() {
    _classCallCheck(this, AuctionData);

    return _super14.apply(this, arguments);
  }

  return AuctionData;
}(Data);

_d = AuctionData;
AuctionData.SCHEMA = new Map([].concat(_toConsumableArray(BidState.SCHEMA), _toConsumableArray(PriceFloor.SCHEMA), _toConsumableArray(_d.struct([['authority', 'pubkeyAsString'], ['tokenMint', 'pubkeyAsString'], ['lastBid', {
  kind: 'option',
  type: 'u64'
}], ['endedAt', {
  kind: 'option',
  type: 'u64'
}], ['endAuctionAt', {
  kind: 'option',
  type: 'u64'
}], ['auctionGap', {
  kind: 'option',
  type: 'u64'
}], ['priceFloor', PriceFloor], ['state', 'u8'], ['bidState', BidState]]))));

var Auction = /*#__PURE__*/function (_Account4) {
  _inherits(Auction, _Account4);

  var _super15 = _createSuper(Auction);

  function Auction(pubkey, info) {
    var _this7;

    _classCallCheck(this, Auction);

    _this7 = _super15.call(this, pubkey, info);

    if (!_this7.assertOwner(AuctionProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    _this7.data = AuctionData.deserialize(_this7.info.data);
    return _this7;
  }

  _createClass(Auction, [{
    key: "getBidderPots",
    value: function getBidderPots(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return AuctionProgram.getProgramAccounts(connection, {
                  filters: [{
                    dataSize: BidderPot.DATA_SIZE
                  }, {
                    memcmp: {
                      offset: 32 + 32,
                      bytes: this.pubkey.toBase58()
                    }
                  }]
                });

              case 2:
                return _context15.abrupt("return", _context15.sent.map(function (account) {
                  return BidderPot.from(account);
                }));

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "getBidderMetadata",
    value: function getBidderMetadata(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return AuctionProgram.getProgramAccounts(connection, {
                  filters: [{
                    dataSize: BidderMetadata.DATA_SIZE
                  }, {
                    memcmp: {
                      offset: 32,
                      bytes: this.pubkey.toBase58()
                    }
                  }]
                });

              case 2:
                return _context16.abrupt("return", _context16.sent.map(function (account) {
                  return BidderMetadata.from(account);
                }));

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }], [{
    key: "getPDA",
    value: function getPDA(vault) {
      return AuctionProgram.findProgramAddress([Buffer$1.from(AuctionProgram.PREFIX), AuctionProgram.PUBKEY.toBuffer(), new PublicKey(vault).toBuffer()]);
    }
  }, {
    key: "findMany",
    value: function findMany(connection) {
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return AuctionProgram.getProgramAccounts(connection, {
                  filters: [filters.authority && {
                    memcmp: {
                      offset: 0,
                      bytes: new PublicKey(filters.authority).toBase58()
                    }
                  }].filter(Boolean)
                });

              case 2:
                return _context17.abrupt("return", _context17.sent.map(function (account) {
                  try {
                    return Auction.from(account);
                  } catch (err) {}
                }).filter(Boolean));

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));
    }
  }]);

  return Auction;
}(Account);

Auction.EXTENDED_DATA_SIZE = 8 + 9 + 2 + 200;

var _a$z;

var AuctionDataExtended = /*#__PURE__*/function (_Data7) {
  _inherits(AuctionDataExtended, _Data7);

  var _super16 = _createSuper(AuctionDataExtended);

  function AuctionDataExtended() {
    _classCallCheck(this, AuctionDataExtended);

    return _super16.apply(this, arguments);
  }

  return AuctionDataExtended;
}(Data);

_a$z = AuctionDataExtended;
AuctionDataExtended.SCHEMA = _a$z.struct([['totalUncancelledBids', 'u64'], ['tickSize', {
  kind: 'option',
  type: 'u64'
}], ['gapTickSizePercentage', {
  kind: 'option',
  type: 'u8'
}], ['instantSalePrice', {
  kind: 'option',
  type: 'u64'
}], ['name', {
  kind: 'option',
  type: [32]
}]]);

var AuctionExtended = /*#__PURE__*/function (_Account5) {
  _inherits(AuctionExtended, _Account5);

  var _super17 = _createSuper(AuctionExtended);

  function AuctionExtended(pubkey, info) {
    var _this8;

    _classCallCheck(this, AuctionExtended);

    _this8 = _super17.call(this, pubkey, info);

    if (!_this8.assertOwner(AuctionProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!AuctionExtended.isCompatible(_this8.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this8.data = AuctionDataExtended.deserialize(_this8.info.data);
    return _this8;
  }

  _createClass(AuctionExtended, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data.length === AuctionExtended.DATA_SIZE;
    }
  }, {
    key: "getPDA",
    value: function getPDA(vault) {
      return AuctionProgram.findProgramAddress([Buffer$1.from(AuctionProgram.PREFIX), AuctionProgram.PUBKEY.toBuffer(), new PublicKey(vault).toBuffer(), Buffer$1.from(AuctionProgram.EXTENDED)]);
    }
  }]);

  return AuctionExtended;
}(Account);

AuctionExtended.DATA_SIZE = 8 + 9 + 2 + 200;

var _a$y;

var CancelBidArgs = /*#__PURE__*/function (_Data8) {
  _inherits(CancelBidArgs, _Data8);

  var _super18 = _createSuper(CancelBidArgs);

  function CancelBidArgs() {
    var _this9;

    _classCallCheck(this, CancelBidArgs);

    _this9 = _super18.apply(this, arguments);
    _this9.instruction = 0;
    return _this9;
  }

  return CancelBidArgs;
}(Data);

_a$y = CancelBidArgs;
CancelBidArgs.SCHEMA = _a$y.struct([['instruction', 'u8'], ['resource', 'pubkeyAsString']]);

var CancelBid = /*#__PURE__*/function (_Transaction) {
  _inherits(CancelBid, _Transaction);

  var _super19 = _createSuper(CancelBid);

  function CancelBid(options, params) {
    var _this10;

    _classCallCheck(this, CancelBid);

    _this10 = _super19.call(this, options);
    var auction = params.auction,
        auctionExtended = params.auctionExtended,
        bidderPot = params.bidderPot,
        bidderMeta = params.bidderMeta,
        bidder = params.bidder,
        bidderToken = params.bidderToken,
        bidderPotToken = params.bidderPotToken,
        tokenMint = params.tokenMint,
        resource = params.resource;
    var data = CancelBidArgs.serialize({
      resource: resource.toString()
    });

    _this10.add(new TransactionInstruction({
      keys: [{
        pubkey: bidder,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: bidderToken,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderPot,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderPotToken,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderMeta,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: tokenMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }],
      programId: AuctionProgram.PUBKEY,
      data: data
    }));

    return _this10;
  }

  return CancelBid;
}(Transaction);

var _a$x, _b$5;

var WinnerLimitType;

(function (WinnerLimitType) {
  WinnerLimitType[WinnerLimitType["Unlimited"] = 0] = "Unlimited";
  WinnerLimitType[WinnerLimitType["Capped"] = 1] = "Capped";
})(WinnerLimitType || (WinnerLimitType = {}));

var WinnerLimit = /*#__PURE__*/function (_Data9) {
  _inherits(WinnerLimit, _Data9);

  var _super20 = _createSuper(WinnerLimit);

  function WinnerLimit() {
    _classCallCheck(this, WinnerLimit);

    return _super20.apply(this, arguments);
  }

  return WinnerLimit;
}(Data);

_a$x = WinnerLimit;
WinnerLimit.SCHEMA = _a$x.struct([['type', 'u8'], ['usize', 'u64']]);

var CreateAuctionArgs = /*#__PURE__*/function (_Data10) {
  _inherits(CreateAuctionArgs, _Data10);

  var _super21 = _createSuper(CreateAuctionArgs);

  function CreateAuctionArgs() {
    var _this11;

    _classCallCheck(this, CreateAuctionArgs);

    _this11 = _super21.apply(this, arguments);
    _this11.instruction = 1;
    return _this11;
  }

  return CreateAuctionArgs;
}(Data);

_b$5 = CreateAuctionArgs;
CreateAuctionArgs.SCHEMA = new Map([].concat(_toConsumableArray(WinnerLimit.SCHEMA), _toConsumableArray(PriceFloor.SCHEMA), _toConsumableArray(_b$5.struct([['instruction', 'u8'], ['winners', WinnerLimit], ['endAuctionAt', {
  kind: 'option',
  type: 'u64'
}], ['auctionGap', {
  kind: 'option',
  type: 'u64'
}], ['tokenMint', 'pubkeyAsString'], ['authority', 'pubkeyAsString'], ['resource', 'pubkeyAsString'], ['priceFloor', PriceFloor], ['tickSize', {
  kind: 'option',
  type: 'u64'
}], ['gapTickSizePercentage', {
  kind: 'option',
  type: 'u8'
}]]))));

var CreateAuction = /*#__PURE__*/function (_Transaction2) {
  _inherits(CreateAuction, _Transaction2);

  var _super22 = _createSuper(CreateAuction);

  function CreateAuction(options, params) {
    var _this12;

    _classCallCheck(this, CreateAuction);

    _this12 = _super22.call(this, options);
    var args = params.args,
        auction = params.auction,
        auctionExtended = params.auctionExtended,
        creator = params.creator;
    var data = CreateAuctionArgs.serialize(args);

    _this12.add(new TransactionInstruction({
      keys: [{
        pubkey: creator,
        isSigner: true,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }],
      programId: AuctionProgram.PUBKEY,
      data: data
    }));

    return _this12;
  }

  return CreateAuction;
}(Transaction);

var _a$w;

var CreateAuctionV2Args = /*#__PURE__*/function (_Data11) {
  _inherits(CreateAuctionV2Args, _Data11);

  var _super23 = _createSuper(CreateAuctionV2Args);

  function CreateAuctionV2Args() {
    var _this13;

    _classCallCheck(this, CreateAuctionV2Args);

    _this13 = _super23.apply(this, arguments);
    _this13.instruction = 7;
    return _this13;
  }

  return CreateAuctionV2Args;
}(Data);

_a$w = CreateAuctionV2Args;
CreateAuctionV2Args.SCHEMA = new Map([].concat(_toConsumableArray(WinnerLimit.SCHEMA), _toConsumableArray(PriceFloor.SCHEMA), _toConsumableArray(_a$w.struct([['instruction', 'u8'], ['winners', WinnerLimit], ['endAuctionAt', {
  kind: 'option',
  type: 'u64'
}], ['auctionGap', {
  kind: 'option',
  type: 'u64'
}], ['tokenMint', 'pubkeyAsString'], ['authority', 'pubkeyAsString'], ['resource', 'pubkeyAsString'], ['priceFloor', PriceFloor], ['tickSize', {
  kind: 'option',
  type: 'u64'
}], ['gapTickSizePercentage', {
  kind: 'option',
  type: 'u8'
}], ['instantSalePrice', {
  kind: 'option',
  type: 'u64'
}], ['name', {
  kind: 'option',
  type: [32]
}]]))));

var CreateAuctionV2 = /*#__PURE__*/function (_Transaction3) {
  _inherits(CreateAuctionV2, _Transaction3);

  var _super24 = _createSuper(CreateAuctionV2);

  function CreateAuctionV2(options, params) {
    var _this14;

    _classCallCheck(this, CreateAuctionV2);

    _this14 = _super24.call(this, options);
    var args = params.args,
        auction = params.auction,
        auctionExtended = params.auctionExtended,
        creator = params.creator;
    var data = CreateAuctionV2Args.serialize(args);

    _this14.add(new TransactionInstruction({
      keys: [{
        pubkey: creator,
        isSigner: true,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }],
      programId: AuctionProgram.PUBKEY,
      data: data
    }));

    return _this14;
  }

  return CreateAuctionV2;
}(Transaction);

var _a$v;

var PlaceBidArgs = /*#__PURE__*/function (_Data12) {
  _inherits(PlaceBidArgs, _Data12);

  var _super25 = _createSuper(PlaceBidArgs);

  function PlaceBidArgs() {
    var _this15;

    _classCallCheck(this, PlaceBidArgs);

    _this15 = _super25.apply(this, arguments);
    _this15.instruction = 6;
    return _this15;
  }

  return PlaceBidArgs;
}(Data);

_a$v = PlaceBidArgs;
PlaceBidArgs.SCHEMA = _a$v.struct([['instruction', 'u8'], ['amount', 'u64'], ['resource', 'pubkeyAsString']]);

var PlaceBid = /*#__PURE__*/function (_Transaction4) {
  _inherits(PlaceBid, _Transaction4);

  var _super26 = _createSuper(PlaceBid);

  function PlaceBid(options, params) {
    var _this16;

    _classCallCheck(this, PlaceBid);

    _this16 = _super26.call(this, options);
    var feePayer = options.feePayer;
    var auction = params.auction,
        auctionExtended = params.auctionExtended,
        bidderPot = params.bidderPot,
        bidderMeta = params.bidderMeta,
        bidder = params.bidder,
        bidderToken = params.bidderToken,
        bidderPotToken = params.bidderPotToken,
        tokenMint = params.tokenMint,
        transferAuthority = params.transferAuthority,
        resource = params.resource,
        amount = params.amount;
    var data = PlaceBidArgs.serialize({
      resource: resource.toString(),
      amount: amount
    });

    _this16.add(new TransactionInstruction({
      keys: [{
        pubkey: bidder,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: bidderToken,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderPot,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderPotToken,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderMeta,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: tokenMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: transferAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }],
      programId: AuctionProgram.PUBKEY,
      data: data
    }));

    return _this16;
  }

  return PlaceBid;
}(Transaction);

var _a$u;

var SetAuctionAuthorityArgs = /*#__PURE__*/function (_Data13) {
  _inherits(SetAuctionAuthorityArgs, _Data13);

  var _super27 = _createSuper(SetAuctionAuthorityArgs);

  function SetAuctionAuthorityArgs() {
    var _this17;

    _classCallCheck(this, SetAuctionAuthorityArgs);

    _this17 = _super27.apply(this, arguments);
    _this17.instruction = 5;
    return _this17;
  }

  return SetAuctionAuthorityArgs;
}(Data);

_a$u = SetAuctionAuthorityArgs;
SetAuctionAuthorityArgs.SCHEMA = _a$u.struct([['instruction', 'u8']]);

var SetAuctionAuthority = /*#__PURE__*/function (_Transaction5) {
  _inherits(SetAuctionAuthority, _Transaction5);

  var _super28 = _createSuper(SetAuctionAuthority);

  function SetAuctionAuthority(options, params) {
    var _this18;

    _classCallCheck(this, SetAuctionAuthority);

    _this18 = _super28.call(this, options);
    var auction = params.auction,
        currentAuthority = params.currentAuthority,
        newAuthority = params.newAuthority;
    var data = SetAuctionAuthorityArgs.serialize();

    _this18.add(new TransactionInstruction({
      keys: [{
        pubkey: auction,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: currentAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: newAuthority,
        isSigner: false,
        isWritable: false
      }],
      programId: AuctionProgram.PUBKEY,
      data: data
    }));

    return _this18;
  }

  return SetAuctionAuthority;
}(Transaction);

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get AuctionState() {
    return AuctionState;
  },

  get BidStateType() {
    return BidStateType;
  },

  get PriceFloorType() {
    return PriceFloorType;
  },

  Bid: Bid,
  BidState: BidState,
  PriceFloor: PriceFloor,
  AuctionData: AuctionData,
  Auction: Auction,
  AuctionDataExtended: AuctionDataExtended,
  AuctionExtended: AuctionExtended,
  BidderMetadataData: BidderMetadataData,
  BidderMetadata: BidderMetadata,
  BidderPotData: BidderPotData,
  BidderPot: BidderPot,
  AuctionProgram: AuctionProgram,
  CancelBidArgs: CancelBidArgs,
  CancelBid: CancelBid,

  get WinnerLimitType() {
    return WinnerLimitType;
  },

  WinnerLimit: WinnerLimit,
  CreateAuctionArgs: CreateAuctionArgs,
  CreateAuction: CreateAuction,
  CreateAuctionV2Args: CreateAuctionV2Args,
  CreateAuctionV2: CreateAuctionV2,
  PlaceBidArgs: PlaceBidArgs,
  PlaceBid: PlaceBid,
  SetAuctionAuthorityArgs: SetAuctionAuthorityArgs,
  SetAuctionAuthority: SetAuctionAuthority
});

var _a$t, _b$4;

var AuctionManagerStatus;

(function (AuctionManagerStatus) {
  AuctionManagerStatus[AuctionManagerStatus["Initialized"] = 0] = "Initialized";
  AuctionManagerStatus[AuctionManagerStatus["Validated"] = 1] = "Validated";
  AuctionManagerStatus[AuctionManagerStatus["Running"] = 2] = "Running";
  AuctionManagerStatus[AuctionManagerStatus["Disbursing"] = 3] = "Disbursing";
  AuctionManagerStatus[AuctionManagerStatus["Finished"] = 4] = "Finished";
})(AuctionManagerStatus || (AuctionManagerStatus = {}));

var AuctionManagerStateV2 = /*#__PURE__*/function (_Data14) {
  _inherits(AuctionManagerStateV2, _Data14);

  var _super29 = _createSuper(AuctionManagerStateV2);

  function AuctionManagerStateV2() {
    var _this19;

    _classCallCheck(this, AuctionManagerStateV2);

    _this19 = _super29.apply(this, arguments);
    _this19.status = AuctionManagerStatus.Initialized;
    _this19.safetyConfigItemsValidated = new BN(0);
    _this19.bidsPushedToAcceptPayment = new BN(0);
    _this19.hasParticipation = false;
    return _this19;
  }

  return AuctionManagerStateV2;
}(Data);

_a$t = AuctionManagerStateV2;
AuctionManagerStateV2.SCHEMA = _a$t.struct([['status', 'u8'], ['safetyConfigItemsValidated', 'u64'], ['bidsPushedToAcceptPayment', 'u64'], ['hasParticipation', 'u8']]);

var AuctionManagerV2Data = /*#__PURE__*/function (_Data15) {
  _inherits(AuctionManagerV2Data, _Data15);

  var _super30 = _createSuper(AuctionManagerV2Data);

  function AuctionManagerV2Data(args) {
    var _this20;

    _classCallCheck(this, AuctionManagerV2Data);

    _this20 = _super30.call(this, args);
    _this20.key = MetaplexKey.AuctionManagerV2;
    return _this20;
  }

  return AuctionManagerV2Data;
}(Data);

_b$4 = AuctionManagerV2Data;
AuctionManagerV2Data.SCHEMA = new Map([].concat(_toConsumableArray(AuctionManagerStateV2.SCHEMA), _toConsumableArray(_b$4.struct([['key', 'u8'], ['store', 'pubkeyAsString'], ['authority', 'pubkeyAsString'], ['auction', 'pubkeyAsString'], ['vault', 'pubkeyAsString'], ['acceptPayment', 'pubkeyAsString'], ['state', AuctionManagerStateV2]]))));

var AuctionManager = /*#__PURE__*/function (_Account6) {
  _inherits(AuctionManager, _Account6);

  var _super31 = _createSuper(AuctionManager);

  function AuctionManager(pubkey, info) {
    var _this21;

    _classCallCheck(this, AuctionManager);

    _this21 = _super31.call(this, pubkey, info);

    if (!_this21.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (AuctionManager.isAuctionManagerV1(_this21.info.data)) {
      throw ERROR_DEPRECATED_ACCOUNT_DATA();
    } else if (AuctionManager.isAuctionManagerV2(_this21.info.data)) {
      _this21.data = AuctionManagerV2Data.deserialize(_this21.info.data);
    } else {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    return _this21;
  }

  _createClass(AuctionManager, [{
    key: "getAuction",
    value: function getAuction(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", Auction.load(connection, this.data.auction));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "getBidRedemptionTickets",
    value: function getBidRedemptionTickets(connection) {
      var haveWinnerIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return MetaplexProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([MetaplexKey.BidRedemptionTicketV2]))
                    }
                  }, {
                    memcmp: {
                      offset: WINNER_INDEX_OFFSETS[+haveWinnerIndex],
                      bytes: this.pubkey.toBase58()
                    }
                  }]
                });

              case 2:
                return _context19.abrupt("return", _context19.sent.map(function (account) {
                  return BidRedemptionTicket.from(account);
                }));

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }], [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return AuctionManager.isAuctionManagerV1(data) || AuctionManager.isAuctionManagerV2(data);
    }
  }, {
    key: "isAuctionManagerV1",
    value: function isAuctionManagerV1(data) {
      return data[0] === MetaplexKey.AuctionManagerV1;
    }
  }, {
    key: "isAuctionManagerV2",
    value: function isAuctionManagerV2(data) {
      return data[0] === MetaplexKey.AuctionManagerV2;
    }
  }, {
    key: "getPDA",
    value: function getPDA(auction) {
      return MetaplexProgram.findProgramAddress([Buffer$1.from(MetaplexProgram.PREFIX), new PublicKey(auction).toBuffer()]);
    }
  }, {
    key: "findMany",
    value: function findMany(connection) {
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return MetaplexProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([MetaplexKey.AuctionManagerV2]))
                    }
                  }, filters.store && {
                    memcmp: {
                      offset: 1,
                      bytes: new PublicKey(filters.store).toBase58()
                    }
                  }, filters.authority && {
                    memcmp: {
                      offset: 33,
                      bytes: new PublicKey(filters.authority).toBase58()
                    }
                  }].filter(Boolean)
                });

              case 2:
                return _context20.abrupt("return", _context20.sent.map(function (account) {
                  return AuctionManager.from(account);
                }));

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));
    }
  }]);

  return AuctionManager;
}(Account);

var _a$s;

var PayoutTicketData = /*#__PURE__*/function (_Data16) {
  _inherits(PayoutTicketData, _Data16);

  var _super32 = _createSuper(PayoutTicketData);

  function PayoutTicketData(args) {
    var _this22;

    _classCallCheck(this, PayoutTicketData);

    _this22 = _super32.call(this, args);
    _this22.key = MetaplexKey.PayoutTicketV1;
    return _this22;
  }

  return PayoutTicketData;
}(Data);

_a$s = PayoutTicketData;
PayoutTicketData.SCHEMA = _a$s.struct([['key', 'u8'], ['recipient', 'pubkeyAsString'], ['amountPaid', 'u64']]);

var PayoutTicket = /*#__PURE__*/function (_Account7) {
  _inherits(PayoutTicket, _Account7);

  var _super33 = _createSuper(PayoutTicket);

  function PayoutTicket(pubkey, info) {
    var _this23;

    _classCallCheck(this, PayoutTicket);

    _this23 = _super33.call(this, pubkey, info);

    if (!_this23.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!PayoutTicket.isCompatible(_this23.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this23.data = PayoutTicketData.deserialize(_this23.info.data);
    return _this23;
  }

  _createClass(PayoutTicket, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetaplexKey.PayoutTicketV1;
    }
  }, {
    key: "getPayoutTicketsByRecipient",
    value: function getPayoutTicketsByRecipient(connection, recipient) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return MetaplexProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([MetaplexKey.PayoutTicketV1]))
                    }
                  }, {
                    memcmp: {
                      offset: 1,
                      bytes: new PublicKey(recipient).toBase58()
                    }
                  }]
                });

              case 2:
                return _context21.abrupt("return", _context21.sent.map(function (account) {
                  return PayoutTicket.from(account);
                }));

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));
    }
  }]);

  return PayoutTicket;
}(Account);

var _a$r;

var PrizeTrackingTicketData = /*#__PURE__*/function (_Data17) {
  _inherits(PrizeTrackingTicketData, _Data17);

  var _super34 = _createSuper(PrizeTrackingTicketData);

  function PrizeTrackingTicketData(args) {
    var _this24;

    _classCallCheck(this, PrizeTrackingTicketData);

    _this24 = _super34.call(this, args);
    _this24.key = MetaplexKey.PrizeTrackingTicketV1;
    _this24.key = MetaplexKey.PrizeTrackingTicketV1;
    return _this24;
  }

  return PrizeTrackingTicketData;
}(Data);

_a$r = PrizeTrackingTicketData;
PrizeTrackingTicketData.SCHEMA = _a$r.struct([['key', 'u8'], ['metadata', 'pubkeyAsString'], ['supplySnapshot', 'u64'], ['expectedRedemptions', 'u64'], ['redemptions', 'u64']]);

var PrizeTrackingTicket = /*#__PURE__*/function (_Account8) {
  _inherits(PrizeTrackingTicket, _Account8);

  var _super35 = _createSuper(PrizeTrackingTicket);

  function PrizeTrackingTicket(pubkey, info) {
    var _this25;

    _classCallCheck(this, PrizeTrackingTicket);

    _this25 = _super35.call(this, pubkey, info);

    if (!_this25.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!PrizeTrackingTicket.isCompatible(_this25.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this25.data = PrizeTrackingTicketData.deserialize(_this25.info.data);
    return _this25;
  }

  _createClass(PrizeTrackingTicket, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetaplexKey.PrizeTrackingTicketV1;
    }
  }, {
    key: "getPDA",
    value: function getPDA(auctionManager, mint) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", MetaplexProgram.findProgramAddress([Buffer$1.from(MetaplexProgram.PREFIX), MetaplexProgram.PUBKEY.toBuffer(), new PublicKey(auctionManager).toBuffer(), new PublicKey(mint).toBuffer()]));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));
    }
  }]);

  return PrizeTrackingTicket;
}(Account);

var WinningConfigType;

(function (WinningConfigType) {
  WinningConfigType[WinningConfigType["TokenOnlyTransfer"] = 0] = "TokenOnlyTransfer";
  WinningConfigType[WinningConfigType["FullRightsTransfer"] = 1] = "FullRightsTransfer";
  WinningConfigType[WinningConfigType["PrintingV1"] = 2] = "PrintingV1";
  WinningConfigType[WinningConfigType["PrintingV2"] = 3] = "PrintingV2";
  WinningConfigType[WinningConfigType["Participation"] = 4] = "Participation";
})(WinningConfigType || (WinningConfigType = {}));

var WinningConstraint;

(function (WinningConstraint) {
  WinningConstraint[WinningConstraint["NoParticipationPrize"] = 0] = "NoParticipationPrize";
  WinningConstraint[WinningConstraint["ParticipationPrizeGiven"] = 1] = "ParticipationPrizeGiven";
})(WinningConstraint || (WinningConstraint = {}));

var NonWinningConstraint;

(function (NonWinningConstraint) {
  NonWinningConstraint[NonWinningConstraint["NoParticipationPrize"] = 0] = "NoParticipationPrize";
  NonWinningConstraint[NonWinningConstraint["GivenForFixedPrice"] = 1] = "GivenForFixedPrice";
  NonWinningConstraint[NonWinningConstraint["GivenForBidPrice"] = 2] = "GivenForBidPrice";
})(NonWinningConstraint || (NonWinningConstraint = {}));

var SafetyDepositConfig = /*#__PURE__*/function (_Account9) {
  _inherits(SafetyDepositConfig, _Account9);

  var _super36 = _createSuper(SafetyDepositConfig);

  function SafetyDepositConfig(pubkey, info) {
    var _this26;

    _classCallCheck(this, SafetyDepositConfig);

    _this26 = _super36.call(this, pubkey, info);

    if (!_this26.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!SafetyDepositConfig.isCompatible(_this26.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this26.data = deserialize$2(_this26.info.data);
    return _this26;
  }

  _createClass(SafetyDepositConfig, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetaplexKey.SafetyDepositConfigV1;
    }
  }, {
    key: "getPDA",
    value: function getPDA(auctionManager, safetyDeposit) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", MetaplexProgram.findProgramAddress([Buffer$1.from(MetaplexProgram.PREFIX), MetaplexProgram.PUBKEY.toBuffer(), new PublicKey(auctionManager).toBuffer(), new PublicKey(safetyDeposit).toBuffer()]));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));
    }
  }]);

  return SafetyDepositConfig;
}(Account);

var deserialize$2 = function deserialize$2(buffer) {
  var data = {
    key: MetaplexKey.SafetyDepositConfigV1,
    auctionManager: bs58.encode(buffer.slice(1, 33)),
    order: new BN(buffer.slice(33, 41), 'le'),
    winningConfigType: buffer[41],
    amountType: buffer[42],
    lengthType: buffer[43],
    amountRanges: [],
    participationConfig: null,
    participationState: null
  };
  var lengthOfArray = new BN(buffer.slice(44, 48), 'le');
  var offset = 48;

  for (var i = 0; i < lengthOfArray.toNumber(); i++) {
    var amount = getBNFromData(buffer, offset, data.amountType);
    offset += data.amountType;
    var length = getBNFromData(buffer, offset, data.lengthType);
    offset += data.lengthType;
    data.amountRanges.push({
      amount: amount,
      length: length
    });
  }

  if (buffer[offset] == 0) {
    offset += 1;
    data.participationConfig = null;
  } else {
    var winnerConstraint = buffer[offset + 1];
    var nonWinningConstraint = buffer[offset + 2];
    var fixedPrice = null;
    offset += 3;

    if (buffer[offset] == 1) {
      fixedPrice = new BN(buffer.slice(offset + 1, offset + 9), 'le');
      offset += 9;
    } else {
      offset += 1;
    }

    data.participationConfig = {
      winnerConstraint: winnerConstraint,
      nonWinningConstraint: nonWinningConstraint,
      fixedPrice: fixedPrice
    };
  }

  if (buffer[offset] == 0) {
    offset += 1;
    data.participationState = null;
  } else {
    var collectedToAcceptPayment = new BN(buffer.slice(offset + 1, offset + 9), 'le');
    offset += 9;
    data.participationState = {
      collectedToAcceptPayment: collectedToAcceptPayment
    };
  }

  return data;
};

var _a$q;

var WhitelistedCreatorData = /*#__PURE__*/function (_Data18) {
  _inherits(WhitelistedCreatorData, _Data18);

  var _super37 = _createSuper(WhitelistedCreatorData);

  function WhitelistedCreatorData(args) {
    var _this27;

    _classCallCheck(this, WhitelistedCreatorData);

    _this27 = _super37.call(this, args);
    _this27.key = MetaplexKey.WhitelistedCreatorV1;
    _this27.activated = true;
    _this27.key = MetaplexKey.WhitelistedCreatorV1;
    return _this27;
  }

  return WhitelistedCreatorData;
}(Data);

_a$q = WhitelistedCreatorData;
WhitelistedCreatorData.SCHEMA = _a$q.struct([['key', 'u8'], ['address', 'pubkeyAsString'], ['activated', 'u8']]);

var WhitelistedCreator = /*#__PURE__*/function (_Account10) {
  _inherits(WhitelistedCreator, _Account10);

  var _super38 = _createSuper(WhitelistedCreator);

  function WhitelistedCreator(pubkey, info) {
    var _this28;

    _classCallCheck(this, WhitelistedCreator);

    _this28 = _super38.call(this, pubkey, info);

    if (!_this28.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!WhitelistedCreator.isCompatible(_this28.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this28.data = WhitelistedCreatorData.deserialize(_this28.info.data);
    return _this28;
  }

  _createClass(WhitelistedCreator, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetaplexKey.WhitelistedCreatorV1;
    }
  }, {
    key: "getPDA",
    value: function getPDA(store, creator) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", MetaplexProgram.findProgramAddress([Buffer$1.from(MetaplexProgram.PREFIX), MetaplexProgram.PUBKEY.toBuffer(), new PublicKey(store).toBuffer(), new PublicKey(creator).toBuffer()]));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));
    }
  }]);

  return WhitelistedCreator;
}(Account);

var _a$p;

var StoreData = /*#__PURE__*/function (_Data19) {
  _inherits(StoreData, _Data19);

  var _super39 = _createSuper(StoreData);

  function StoreData(args) {
    var _this29;

    _classCallCheck(this, StoreData);

    _this29 = _super39.call(this, args);
    _this29.key = MetaplexKey.StoreV1;
    _this29.public = true;
    _this29.key = MetaplexKey.StoreV1;
    return _this29;
  }

  return StoreData;
}(Data);

_a$p = StoreData;
StoreData.SCHEMA = _a$p.struct([['key', 'u8'], ['public', 'u8'], ['auctionProgram', 'pubkeyAsString'], ['tokenVaultProgram', 'pubkeyAsString'], ['tokenMetadataProgram', 'pubkeyAsString'], ['tokenProgram', 'pubkeyAsString']]);

var Store = /*#__PURE__*/function (_Account11) {
  _inherits(Store, _Account11);

  var _super40 = _createSuper(Store);

  function Store(pubkey, info) {
    var _this30;

    _classCallCheck(this, Store);

    _this30 = _super40.call(this, pubkey, info);

    if (!_this30.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!Store.isCompatible(_this30.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this30.data = StoreData.deserialize(_this30.info.data);
    return _this30;
  }

  _createClass(Store, [{
    key: "getWhitelistedCreators",
    value: function getWhitelistedCreators(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return MetaplexProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([MetaplexKey.WhitelistedCreatorV1]))
                    }
                  }]
                });

              case 2:
                return _context25.abrupt("return", _context25.sent.map(function (account) {
                  return WhitelistedCreator.from(account);
                }));

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));
    }
  }, {
    key: "getAuctionManagers",
    value: function getAuctionManagers(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return MetaplexProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([MetaplexKey.AuctionManagerV2]))
                    }
                  }, {
                    memcmp: {
                      offset: 1,
                      bytes: this.pubkey.toBase58()
                    }
                  }]
                });

              case 2:
                return _context26.abrupt("return", _context26.sent.map(function (account) {
                  return AuctionManager.from(account);
                }));

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
  }], [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetaplexKey.StoreV1;
    }
  }, {
    key: "getPDA",
    value: function getPDA(owner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", MetaplexProgram.findProgramAddress([Buffer$1.from(MetaplexProgram.PREFIX), MetaplexProgram.PUBKEY.toBuffer(), new PublicKey(owner).toBuffer()]));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));
    }
  }]);

  return Store;
}(Account);

var AuctionWinnerTokenTypeTracker = /*#__PURE__*/function (_Account12) {
  _inherits(AuctionWinnerTokenTypeTracker, _Account12);

  var _super41 = _createSuper(AuctionWinnerTokenTypeTracker);

  function AuctionWinnerTokenTypeTracker(pubkey, info) {
    var _this31;

    _classCallCheck(this, AuctionWinnerTokenTypeTracker);

    _this31 = _super41.call(this, pubkey, info);

    if (!_this31.assertOwner(MetaplexProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!AuctionWinnerTokenTypeTracker.isCompatible(_this31.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this31.data = deserialize$1(_this31.info.data);
    return _this31;
  }

  _createClass(AuctionWinnerTokenTypeTracker, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetaplexKey.AuctionWinnerTokenTypeTrackerV1;
    }
  }, {
    key: "getPDA",
    value: function getPDA(auctionManager) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", MetaplexProgram.findProgramAddress([Buffer$1.from(MetaplexProgram.PREFIX), MetaplexProgram.PUBKEY.toBuffer(), new PublicKey(auctionManager).toBuffer(), Buffer$1.from(MetaplexProgram.TOTALS)]));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));
    }
  }]);

  return AuctionWinnerTokenTypeTracker;
}(Account);

var deserialize$1 = function deserialize$1(buffer) {
  var data = {
    key: MetaplexKey.SafetyDepositConfigV1,
    amountType: buffer[1],
    lengthType: buffer[2],
    amountRanges: []
  };
  var lengthOfArray = new BN(buffer.slice(3, 7), 'le');
  var offset = 7;

  for (var i = 0; i < lengthOfArray.toNumber(); i++) {
    var amount = getBNFromData(buffer, offset, data.amountType);
    offset += data.amountType;
    var length = getBNFromData(buffer, offset, data.lengthType);
    offset += data.lengthType;
    data.amountRanges.push({
      amount: amount,
      length: length
    });
  }

  return data;
};

var VaultKey;

(function (VaultKey) {
  VaultKey[VaultKey["Uninitialized"] = 0] = "Uninitialized";
  VaultKey[VaultKey["VaultV1"] = 3] = "VaultV1";
  VaultKey[VaultKey["SafetyDepositBoxV1"] = 1] = "SafetyDepositBoxV1";
  VaultKey[VaultKey["ExternalPriceAccountV1"] = 2] = "ExternalPriceAccountV1";
})(VaultKey || (VaultKey = {}));

var VaultInstructions;

(function (VaultInstructions) {
  VaultInstructions[VaultInstructions["InitVault"] = 0] = "InitVault";
  VaultInstructions[VaultInstructions["AddTokenToInactiveVault"] = 1] = "AddTokenToInactiveVault";
  VaultInstructions[VaultInstructions["ActivateVault"] = 2] = "ActivateVault";
  VaultInstructions[VaultInstructions["CombineVault"] = 3] = "CombineVault";
  VaultInstructions[VaultInstructions["RedeemShares"] = 4] = "RedeemShares";
  VaultInstructions[VaultInstructions["WithdrawTokenFromSafetyDepositBox"] = 5] = "WithdrawTokenFromSafetyDepositBox";
  VaultInstructions[VaultInstructions["MintFractionalShares"] = 6] = "MintFractionalShares";
  VaultInstructions[VaultInstructions["WithdrawSharesFromTreasury"] = 7] = "WithdrawSharesFromTreasury";
  VaultInstructions[VaultInstructions["AddSharesToTreasury"] = 8] = "AddSharesToTreasury";
  VaultInstructions[VaultInstructions["UpdateExternalPriceAccount"] = 9] = "UpdateExternalPriceAccount";
  VaultInstructions[VaultInstructions["SetVaultAuthority"] = 10] = "SetVaultAuthority";
})(VaultInstructions || (VaultInstructions = {}));

var VaultProgram = /*#__PURE__*/function (_Program3) {
  _inherits(VaultProgram, _Program3);

  var _super42 = _createSuper(VaultProgram);

  function VaultProgram() {
    _classCallCheck(this, VaultProgram);

    return _super42.apply(this, arguments);
  }

  return VaultProgram;
}(Program);

VaultProgram.PREFIX = 'vault';
VaultProgram.PUBKEY = new PublicKey(config.programs.vault);

var _a$o;

var SafetyDepositBoxData = /*#__PURE__*/function (_Data20) {
  _inherits(SafetyDepositBoxData, _Data20);

  var _super43 = _createSuper(SafetyDepositBoxData);

  function SafetyDepositBoxData(args) {
    var _this32;

    _classCallCheck(this, SafetyDepositBoxData);

    _this32 = _super43.call(this, args);
    _this32.key = VaultKey.SafetyDepositBoxV1;
    return _this32;
  }

  return SafetyDepositBoxData;
}(Data);

_a$o = SafetyDepositBoxData;
SafetyDepositBoxData.SCHEMA = _a$o.struct([['key', 'u8'], ['vault', 'pubkeyAsString'], ['tokenMint', 'pubkeyAsString'], ['store', 'pubkeyAsString'], ['order', 'u8']]);

var SafetyDepositBox = /*#__PURE__*/function (_Account13) {
  _inherits(SafetyDepositBox, _Account13);

  var _super44 = _createSuper(SafetyDepositBox);

  function SafetyDepositBox(key, info) {
    var _this33;

    _classCallCheck(this, SafetyDepositBox);

    _this33 = _super44.call(this, key, info);

    if (!_this33.assertOwner(VaultProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!SafetyDepositBox.isCompatible(_this33.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this33.data = SafetyDepositBoxData.deserialize(_this33.info.data);
    return _this33;
  }

  _createClass(SafetyDepositBox, null, [{
    key: "getPDA",
    value: function getPDA(vault, mint) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", VaultProgram.findProgramAddress([Buffer$1.from(VaultProgram.PREFIX), new PublicKey(vault).toBuffer(), new PublicKey(mint).toBuffer()]));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === VaultKey.SafetyDepositBoxV1;
    }
  }]);

  return SafetyDepositBox;
}(Account);

var _a$n, _b$3, _c$1;

var AmountArgs = /*#__PURE__*/function (_Data21) {
  _inherits(AmountArgs, _Data21);

  var _super45 = _createSuper(AmountArgs);

  function AmountArgs() {
    _classCallCheck(this, AmountArgs);

    return _super45.apply(this, arguments);
  }

  return AmountArgs;
}(Data);

_a$n = AmountArgs;
AmountArgs.SCHEMA = _a$n.struct([['instruction', 'u8'], ['amount', 'u64']]);

var NumberOfShareArgs = /*#__PURE__*/function (_Data22) {
  _inherits(NumberOfShareArgs, _Data22);

  var _super46 = _createSuper(NumberOfShareArgs);

  function NumberOfShareArgs() {
    _classCallCheck(this, NumberOfShareArgs);

    return _super46.apply(this, arguments);
  }

  return NumberOfShareArgs;
}(Data);

_b$3 = NumberOfShareArgs;
NumberOfShareArgs.SCHEMA = _b$3.struct([['instruction', 'u8'], ['numberOfShares', 'u64']]);
var VaultState;

(function (VaultState) {
  VaultState[VaultState["Inactive"] = 0] = "Inactive";
  VaultState[VaultState["Active"] = 1] = "Active";
  VaultState[VaultState["Combined"] = 2] = "Combined";
  VaultState[VaultState["Deactivated"] = 3] = "Deactivated";
})(VaultState || (VaultState = {}));

var VaultData = /*#__PURE__*/function (_Data23) {
  _inherits(VaultData, _Data23);

  var _super47 = _createSuper(VaultData);

  function VaultData(args) {
    var _this34;

    _classCallCheck(this, VaultData);

    _this34 = _super47.call(this, args);
    _this34.key = VaultKey.VaultV1;
    return _this34;
  }

  return VaultData;
}(Data);

_c$1 = VaultData;
VaultData.SCHEMA = _c$1.struct([['key', 'u8'], ['tokenProgram', 'pubkeyAsString'], ['fractionMint', 'pubkeyAsString'], ['authority', 'pubkeyAsString'], ['fractionTreasury', 'pubkeyAsString'], ['redeemTreasury', 'pubkeyAsString'], ['allowFurtherShareCreation', 'u8'], ['pricingLookupAddress', 'pubkeyAsString'], ['tokenTypeCount', 'u8'], ['state', 'u8'], ['lockedPricePerShare', 'u64']]);

var Vault = /*#__PURE__*/function (_Account14) {
  _inherits(Vault, _Account14);

  var _super48 = _createSuper(Vault);

  function Vault(pubkey, info) {
    var _this35;

    _classCallCheck(this, Vault);

    _this35 = _super48.call(this, pubkey, info);

    if (!_this35.assertOwner(VaultProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!Vault.isCompatible(_this35.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this35.data = VaultData.deserialize(_this35.info.data);
    return _this35;
  }

  _createClass(Vault, [{
    key: "getSafetyDepositBoxes",
    value: function getSafetyDepositBoxes(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return VaultProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([VaultKey.SafetyDepositBoxV1]))
                    }
                  }, {
                    memcmp: {
                      offset: 1,
                      bytes: this.pubkey.toBase58()
                    }
                  }]
                });

              case 2:
                return _context30.abrupt("return", _context30.sent.map(function (account) {
                  return SafetyDepositBox.from(account);
                }));

              case 3:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
  }], [{
    key: "getPDA",
    value: function getPDA(pubkey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", VaultProgram.findProgramAddress([Buffer$1.from(VaultProgram.PREFIX), VaultProgram.PUBKEY.toBuffer(), new PublicKey(pubkey).toBuffer()]));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === VaultKey.VaultV1;
    }
  }]);

  return Vault;
}(Account);

Vault.MAX_VAULT_SIZE = 1 + 32 + 32 + 32 + 32 + 1 + 32 + 1 + 32 + 1 + 1 + 8;
Vault.MAX_EXTERNAL_ACCOUNT_SIZE = 1 + 8 + 32 + 1;

var _a$m;

var ExternalPriceAccountData = /*#__PURE__*/function (_Data24) {
  _inherits(ExternalPriceAccountData, _Data24);

  var _super49 = _createSuper(ExternalPriceAccountData);

  function ExternalPriceAccountData(args) {
    var _this36;

    _classCallCheck(this, ExternalPriceAccountData);

    _this36 = _super49.call(this, args);
    _this36.key = VaultKey.ExternalPriceAccountV1;
    return _this36;
  }

  return ExternalPriceAccountData;
}(Data);

_a$m = ExternalPriceAccountData;
ExternalPriceAccountData.SCHEMA = _a$m.struct([['key', 'u8'], ['pricePerShare', 'u64'], ['priceMint', 'pubkeyAsString'], ['allowedToCombine', 'u8']]);

var ExternalPriceAccount = /*#__PURE__*/function (_Account15) {
  _inherits(ExternalPriceAccount, _Account15);

  var _super50 = _createSuper(ExternalPriceAccount);

  function ExternalPriceAccount(key, info) {
    var _this37;

    _classCallCheck(this, ExternalPriceAccount);

    _this37 = _super50.call(this, key, info);

    if (!_this37.assertOwner(VaultProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!ExternalPriceAccount.isCompatible(_this37.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this37.data = ExternalPriceAccountData.deserialize(_this37.info.data);
    return _this37;
  }

  _createClass(ExternalPriceAccount, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === VaultKey.ExternalPriceAccountV1;
    }
  }]);

  return ExternalPriceAccount;
}(Account);

var ActivateVault = /*#__PURE__*/function (_Transaction6) {
  _inherits(ActivateVault, _Transaction6);

  var _super51 = _createSuper(ActivateVault);

  function ActivateVault(options, params) {
    var _this38;

    _classCallCheck(this, ActivateVault);

    _this38 = _super51.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        fractionMint = params.fractionMint,
        fractionTreasury = params.fractionTreasury,
        fractionMintAuthority = params.fractionMintAuthority,
        numberOfShares = params.numberOfShares;
    var data = NumberOfShareArgs.serialize({
      instruction: VaultInstructions.ActivateVault,
      numberOfShares: numberOfShares
    });

    _this38.add(new TransactionInstruction({
      keys: [{
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMintAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: vaultAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this38;
  }

  return ActivateVault;
}(Transaction);

var AddSharesToTreasury = /*#__PURE__*/function (_Transaction7) {
  _inherits(AddSharesToTreasury, _Transaction7);

  var _super52 = _createSuper(AddSharesToTreasury);

  function AddSharesToTreasury(options, params) {
    var _this39;

    _classCallCheck(this, AddSharesToTreasury);

    _this39 = _super52.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        source = params.source,
        transferAuthority = params.transferAuthority,
        fractionTreasury = params.fractionTreasury,
        numberOfShares = params.numberOfShares;
    var data = NumberOfShareArgs.serialize({
      instruction: VaultInstructions.AddSharesToTreasury,
      numberOfShares: numberOfShares
    });

    _this39.add(new TransactionInstruction({
      keys: [{
        pubkey: source,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: vaultAuthority,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this39;
  }

  return AddSharesToTreasury;
}(Transaction);

var AddTokenToInactiveVault = /*#__PURE__*/function (_Transaction8) {
  _inherits(AddTokenToInactiveVault, _Transaction8);

  var _super53 = _createSuper(AddTokenToInactiveVault);

  function AddTokenToInactiveVault(options, params) {
    var _this40;

    _classCallCheck(this, AddTokenToInactiveVault);

    _this40 = _super53.call(this, options);
    var feePayer = options.feePayer;
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        tokenAccount = params.tokenAccount,
        tokenStoreAccount = params.tokenStoreAccount,
        transferAuthority = params.transferAuthority,
        safetyDepositBox = params.safetyDepositBox,
        amount = params.amount;
    var data = AmountArgs.serialize({
      instruction: VaultInstructions.AddTokenToInactiveVault,
      amount: amount
    });

    _this40.add(new TransactionInstruction({
      keys: [{
        pubkey: safetyDepositBox,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: tokenAccount,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: tokenStoreAccount,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vaultAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this40;
  }

  return AddTokenToInactiveVault;
}(Transaction);

var _a$l;

var CombineVaultArgs = /*#__PURE__*/function (_Data25) {
  _inherits(CombineVaultArgs, _Data25);

  var _super54 = _createSuper(CombineVaultArgs);

  function CombineVaultArgs() {
    var _this41;

    _classCallCheck(this, CombineVaultArgs);

    _this41 = _super54.apply(this, arguments);
    _this41.instruction = VaultInstructions.CombineVault;
    return _this41;
  }

  return CombineVaultArgs;
}(Data);

_a$l = CombineVaultArgs;
CombineVaultArgs.SCHEMA = _a$l.struct([['instruction', 'u8']]);

var CombineVault = /*#__PURE__*/function (_Transaction9) {
  _inherits(CombineVault, _Transaction9);

  var _super55 = _createSuper(CombineVault);

  function CombineVault(options, params) {
    var _this42;

    _classCallCheck(this, CombineVault);

    _this42 = _super55.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        fractionMint = params.fractionMint,
        fractionTreasury = params.fractionTreasury,
        outstandingShareTokenAccount = params.outstandingShareTokenAccount,
        payingTokenAccount = params.payingTokenAccount,
        redeemTreasury = params.redeemTreasury,
        newVaultAuthority = params.newVaultAuthority,
        transferAuthority = params.transferAuthority,
        externalPriceAccount = params.externalPriceAccount,
        burnAuthority = params.burnAuthority;
    var data = CombineVaultArgs.serialize();

    _this42.add(new TransactionInstruction({
      keys: [{
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: outstandingShareTokenAccount,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: payingTokenAccount,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: redeemTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: newVaultAuthority || vaultAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: vaultAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: burnAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: externalPriceAccount,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this42;
  }

  return CombineVault;
}(Transaction);

var _a$k;

var InitVaultArgs = /*#__PURE__*/function (_Data26) {
  _inherits(InitVaultArgs, _Data26);

  var _super56 = _createSuper(InitVaultArgs);

  function InitVaultArgs() {
    var _this43;

    _classCallCheck(this, InitVaultArgs);

    _this43 = _super56.apply(this, arguments);
    _this43.instruction = VaultInstructions.InitVault;
    _this43.allowFurtherShareCreation = false;
    return _this43;
  }

  return InitVaultArgs;
}(Data);

_a$k = InitVaultArgs;
InitVaultArgs.SCHEMA = _a$k.struct([['instruction', 'u8'], ['allowFurtherShareCreation', 'u8']]);

var InitVault = /*#__PURE__*/function (_Transaction10) {
  _inherits(InitVault, _Transaction10);

  var _super57 = _createSuper(InitVault);

  function InitVault(options, params) {
    var _this44;

    _classCallCheck(this, InitVault);

    _this44 = _super57.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        fractionalMint = params.fractionalMint,
        redeemTreasury = params.redeemTreasury,
        fractionalTreasury = params.fractionalTreasury,
        pricingLookupAddress = params.pricingLookupAddress,
        allowFurtherShareCreation = params.allowFurtherShareCreation;
    var data = InitVaultArgs.serialize({
      allowFurtherShareCreation: allowFurtherShareCreation
    });

    _this44.add(new TransactionInstruction({
      keys: [{
        pubkey: fractionalMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: redeemTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionalTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vaultAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: pricingLookupAddress,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this44;
  }

  return InitVault;
}(Transaction);

var MintFractionalShares = /*#__PURE__*/function (_Transaction11) {
  _inherits(MintFractionalShares, _Transaction11);

  var _super58 = _createSuper(MintFractionalShares);

  function MintFractionalShares(options, params) {
    var _this45;

    _classCallCheck(this, MintFractionalShares);

    _this45 = _super58.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        fractionMint = params.fractionMint,
        fractionTreasury = params.fractionTreasury,
        fractionMintAuthority = params.fractionMintAuthority,
        numberOfShares = params.numberOfShares;
    var data = NumberOfShareArgs.serialize({
      instruction: VaultInstructions.MintFractionalShares,
      numberOfShares: numberOfShares
    });

    _this45.add(new TransactionInstruction({
      keys: [{
        pubkey: fractionTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: fractionMintAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: vaultAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this45;
  }

  return MintFractionalShares;
}(Transaction);

var _a$j;

var RedeemSharesArgs = /*#__PURE__*/function (_Data27) {
  _inherits(RedeemSharesArgs, _Data27);

  var _super59 = _createSuper(RedeemSharesArgs);

  function RedeemSharesArgs() {
    var _this46;

    _classCallCheck(this, RedeemSharesArgs);

    _this46 = _super59.apply(this, arguments);
    _this46.instruction = VaultInstructions.RedeemShares;
    return _this46;
  }

  return RedeemSharesArgs;
}(Data);

_a$j = RedeemSharesArgs;
RedeemSharesArgs.SCHEMA = _a$j.struct([['instruction', 'u8']]);

var RedeemShares = /*#__PURE__*/function (_Transaction12) {
  _inherits(RedeemShares, _Transaction12);

  var _super60 = _createSuper(RedeemShares);

  function RedeemShares(options, params) {
    var _this47;

    _classCallCheck(this, RedeemShares);

    _this47 = _super60.call(this, options);
    var vault = params.vault,
        burnAuthority = params.burnAuthority,
        fractionMint = params.fractionMint,
        outstandingSharesAccount = params.outstandingSharesAccount,
        proceedsAccount = params.proceedsAccount,
        redeemTreasury = params.redeemTreasury,
        transferAuthority = params.transferAuthority;
    var data = RedeemSharesArgs.serialize();

    _this47.add(new TransactionInstruction({
      keys: [{
        pubkey: outstandingSharesAccount,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: proceedsAccount,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: redeemTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: transferAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: burnAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this47;
  }

  return RedeemShares;
}(Transaction);

var _a$i;

var SetVaultAuthorityArgs = /*#__PURE__*/function (_Data28) {
  _inherits(SetVaultAuthorityArgs, _Data28);

  var _super61 = _createSuper(SetVaultAuthorityArgs);

  function SetVaultAuthorityArgs() {
    var _this48;

    _classCallCheck(this, SetVaultAuthorityArgs);

    _this48 = _super61.apply(this, arguments);
    _this48.instruction = VaultInstructions.SetVaultAuthority;
    return _this48;
  }

  return SetVaultAuthorityArgs;
}(Data);

_a$i = SetVaultAuthorityArgs;
SetVaultAuthorityArgs.SCHEMA = _a$i.struct([['instruction', 'u8']]);

var SetVaultAuthority = /*#__PURE__*/function (_Transaction13) {
  _inherits(SetVaultAuthority, _Transaction13);

  var _super62 = _createSuper(SetVaultAuthority);

  function SetVaultAuthority(options, params) {
    var _this49;

    _classCallCheck(this, SetVaultAuthority);

    _this49 = _super62.call(this, options);
    var vault = params.vault,
        currentAuthority = params.currentAuthority,
        newAuthority = params.newAuthority;
    var data = SetVaultAuthorityArgs.serialize();

    _this49.add(new TransactionInstruction({
      keys: [{
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: currentAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: newAuthority,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this49;
  }

  return SetVaultAuthority;
}(Transaction);

var _a$h;

var UpdateExternalPriceAccountArgs = /*#__PURE__*/function (_Data29) {
  _inherits(UpdateExternalPriceAccountArgs, _Data29);

  var _super63 = _createSuper(UpdateExternalPriceAccountArgs);

  function UpdateExternalPriceAccountArgs() {
    var _this50;

    _classCallCheck(this, UpdateExternalPriceAccountArgs);

    _this50 = _super63.apply(this, arguments);
    _this50.instruction = VaultInstructions.UpdateExternalPriceAccount;
    return _this50;
  }

  return UpdateExternalPriceAccountArgs;
}(Data);

_a$h = UpdateExternalPriceAccountArgs;
UpdateExternalPriceAccountArgs.SCHEMA = new Map([].concat(_toConsumableArray(ExternalPriceAccountData.SCHEMA), _toConsumableArray(_a$h.struct([['instruction', 'u8'], ['externalPriceAccount', ExternalPriceAccountData]]))));

var UpdateExternalPriceAccount = /*#__PURE__*/function (_Transaction14) {
  _inherits(UpdateExternalPriceAccount, _Transaction14);

  var _super64 = _createSuper(UpdateExternalPriceAccount);

  function UpdateExternalPriceAccount(options, params) {
    var _this51;

    _classCallCheck(this, UpdateExternalPriceAccount);

    _this51 = _super64.call(this, options);
    var externalPriceAccount = params.externalPriceAccount,
        externalPriceAccountData = params.externalPriceAccountData;
    var data = UpdateExternalPriceAccountArgs.serialize({
      externalPriceAccount: externalPriceAccountData
    });

    _this51.add(new TransactionInstruction({
      keys: [{
        pubkey: externalPriceAccount,
        isSigner: false,
        isWritable: true
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this51;
  }

  return UpdateExternalPriceAccount;
}(Transaction);

var WithdrawSharesFromTreasury = /*#__PURE__*/function (_Transaction15) {
  _inherits(WithdrawSharesFromTreasury, _Transaction15);

  var _super65 = _createSuper(WithdrawSharesFromTreasury);

  function WithdrawSharesFromTreasury(options, params) {
    var _this52;

    _classCallCheck(this, WithdrawSharesFromTreasury);

    _this52 = _super65.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        destination = params.destination,
        transferAuthority = params.transferAuthority,
        fractionTreasury = params.fractionTreasury,
        numberOfShares = params.numberOfShares;
    var data = NumberOfShareArgs.serialize({
      instruction: VaultInstructions.WithdrawSharesFromTreasury,
      numberOfShares: numberOfShares
    });

    _this52.add(new TransactionInstruction({
      keys: [{
        pubkey: destination,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionTreasury,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: vaultAuthority,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this52;
  }

  return WithdrawSharesFromTreasury;
}(Transaction);

var WithdrawTokenFromSafetyDepositBox = /*#__PURE__*/function (_Transaction16) {
  _inherits(WithdrawTokenFromSafetyDepositBox, _Transaction16);

  var _super66 = _createSuper(WithdrawTokenFromSafetyDepositBox);

  function WithdrawTokenFromSafetyDepositBox(options, params) {
    var _this53;

    _classCallCheck(this, WithdrawTokenFromSafetyDepositBox);

    _this53 = _super66.call(this, options);
    var vault = params.vault,
        vaultAuthority = params.vaultAuthority,
        store = params.store,
        destination = params.destination,
        fractionMint = params.fractionMint,
        transferAuthority = params.transferAuthority,
        safetyDepositBox = params.safetyDepositBox,
        amount = params.amount;
    var data = AmountArgs.serialize({
      instruction: VaultInstructions.WithdrawTokenFromSafetyDepositBox,
      amount: amount
    });

    _this53.add(new TransactionInstruction({
      keys: [{
        pubkey: destination,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: safetyDepositBox,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vaultAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: VaultProgram.PUBKEY,
      data: data
    }));

    return _this53;
  }

  return WithdrawTokenFromSafetyDepositBox;
}(Transaction);

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SafetyDepositBoxData: SafetyDepositBoxData,
  SafetyDepositBox: SafetyDepositBox,
  AmountArgs: AmountArgs,
  NumberOfShareArgs: NumberOfShareArgs,

  get VaultState() {
    return VaultState;
  },

  VaultData: VaultData,
  Vault: Vault,
  ExternalPriceAccountData: ExternalPriceAccountData,
  ExternalPriceAccount: ExternalPriceAccount,

  get VaultKey() {
    return VaultKey;
  },

  get VaultInstructions() {
    return VaultInstructions;
  },

  VaultProgram: VaultProgram,
  ActivateVault: ActivateVault,
  AddSharesToTreasury: AddSharesToTreasury,
  AddTokenToInactiveVault: AddTokenToInactiveVault,
  CombineVaultArgs: CombineVaultArgs,
  CombineVault: CombineVault,
  InitVaultArgs: InitVaultArgs,
  InitVault: InitVault,
  MintFractionalShares: MintFractionalShares,
  RedeemSharesArgs: RedeemSharesArgs,
  RedeemShares: RedeemShares,
  SetVaultAuthorityArgs: SetVaultAuthorityArgs,
  SetVaultAuthority: SetVaultAuthority,
  UpdateExternalPriceAccountArgs: UpdateExternalPriceAccountArgs,
  UpdateExternalPriceAccount: UpdateExternalPriceAccount,
  WithdrawSharesFromTreasury: WithdrawSharesFromTreasury,
  WithdrawTokenFromSafetyDepositBox: WithdrawTokenFromSafetyDepositBox
});
var MetadataKey;

(function (MetadataKey) {
  MetadataKey[MetadataKey["Uninitialized"] = 0] = "Uninitialized";
  MetadataKey[MetadataKey["MetadataV1"] = 4] = "MetadataV1";
  MetadataKey[MetadataKey["EditionV1"] = 1] = "EditionV1";
  MetadataKey[MetadataKey["MasterEditionV1"] = 2] = "MasterEditionV1";
  MetadataKey[MetadataKey["MasterEditionV2"] = 6] = "MasterEditionV2";
  MetadataKey[MetadataKey["EditionMarker"] = 7] = "EditionMarker";
})(MetadataKey || (MetadataKey = {}));

var MetadataProgram = /*#__PURE__*/function (_Program4) {
  _inherits(MetadataProgram, _Program4);

  var _super67 = _createSuper(MetadataProgram);

  function MetadataProgram() {
    _classCallCheck(this, MetadataProgram);

    return _super67.apply(this, arguments);
  }

  return MetadataProgram;
}(Program);

MetadataProgram.PREFIX = 'metadata';
MetadataProgram.PUBKEY = new PublicKey(config.programs.metadata);

var _a$g;

var EditionData = /*#__PURE__*/function (_Data30) {
  _inherits(EditionData, _Data30);

  var _super68 = _createSuper(EditionData);

  function EditionData(args) {
    var _this54;

    _classCallCheck(this, EditionData);

    _this54 = _super68.call(this, args);
    _this54.key = MetadataKey.EditionV1;
    return _this54;
  }

  return EditionData;
}(Data);

_a$g = EditionData;
EditionData.SCHEMA = _a$g.struct([['key', 'u8'], ['parent', 'pubkeyAsString'], ['edition', 'u64']]);

var Edition = /*#__PURE__*/function (_Account16) {
  _inherits(Edition, _Account16);

  var _super69 = _createSuper(Edition);

  function Edition(key, info) {
    var _this55;

    _classCallCheck(this, Edition);

    _this55 = _super69.call(this, key, info);

    if (!_this55.assertOwner(MetadataProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!Edition.isCompatible(_this55.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this55.data = EditionData.deserialize(_this55.info.data);
    return _this55;
  }

  _createClass(Edition, null, [{
    key: "getPDA",
    value: function getPDA(mint) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", MetadataProgram.findProgramAddress([Buffer$1.from(MetadataProgram.PREFIX), MetadataProgram.PUBKEY.toBuffer(), new PublicKey(mint).toBuffer(), Buffer$1.from(Edition.EDITION_PREFIX)]));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetadataKey.EditionV1;
    }
  }]);

  return Edition;
}(Account);

Edition.EDITION_PREFIX = 'edition';

var _a$f;

var EditionMarkerData = /*#__PURE__*/function (_Data31) {
  _inherits(EditionMarkerData, _Data31);

  var _super70 = _createSuper(EditionMarkerData);

  function EditionMarkerData(args) {
    var _this56;

    _classCallCheck(this, EditionMarkerData);

    _this56 = _super70.call(this, args);
    _this56.key = MetadataKey.EditionMarker;
    return _this56;
  }

  _createClass(EditionMarkerData, [{
    key: "editionTaken",
    value: function editionTaken(edition) {
      var editionOffset = edition % EditionMarker.DATA_SIZE;
      var indexOffset = Math.floor(editionOffset / 8);

      if (indexOffset > 30) {
        throw Error('Bad index for edition');
      }

      var positionInBitsetFromRight = 7 - editionOffset % 8;
      var mask = Math.pow(2, positionInBitsetFromRight);
      var appliedMask = this.ledger[indexOffset] & mask;
      return appliedMask != 0;
    }
  }]);

  return EditionMarkerData;
}(Data);

_a$f = EditionMarkerData;
EditionMarkerData.SCHEMA = _a$f.struct([['key', 'u8'], ['ledger', [31]]]);

var EditionMarker = /*#__PURE__*/function (_Account17) {
  _inherits(EditionMarker, _Account17);

  var _super71 = _createSuper(EditionMarker);

  function EditionMarker(key, info) {
    var _this57;

    _classCallCheck(this, EditionMarker);

    _this57 = _super71.call(this, key, info);

    if (!_this57.assertOwner(MetadataProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!EditionMarker.isCompatible(_this57.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this57.data = EditionMarkerData.deserialize(_this57.info.data);
    return _this57;
  }

  _createClass(EditionMarker, null, [{
    key: "getPDA",
    value: function getPDA(mint, edition) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var editionNumber;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                editionNumber = Math.floor(edition.toNumber() / 248);
                return _context33.abrupt("return", MetadataProgram.findProgramAddress([Buffer$1.from(MetadataProgram.PREFIX), MetadataProgram.PUBKEY.toBuffer(), new PublicKey(mint).toBuffer(), Buffer$1.from(Edition.EDITION_PREFIX), Buffer$1.from(editionNumber.toString())]));

              case 2:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetadataKey.EditionMarker;
    }
  }]);

  return EditionMarker;
}(Account);

EditionMarker.DATA_SIZE = 248;

var _a$e, _b$2;

var MasterEditionV1Data = /*#__PURE__*/function (_Data32) {
  _inherits(MasterEditionV1Data, _Data32);

  var _super72 = _createSuper(MasterEditionV1Data);

  function MasterEditionV1Data(args) {
    var _this58;

    _classCallCheck(this, MasterEditionV1Data);

    _this58 = _super72.call(this, args);
    _this58.key = MetadataKey.MasterEditionV1;
    return _this58;
  }

  return MasterEditionV1Data;
}(Data);

_a$e = MasterEditionV1Data;
MasterEditionV1Data.SCHEMA = _a$e.struct([['key', 'u8'], ['supply', 'u64'], ['maxSupply', {
  kind: 'option',
  type: 'u64'
}], ['printingMint', 'pubkeyAsString'], ['oneTimePrintingAuthorizationMint', 'pubkeyAsString']]);

var MasterEditionV2Data = /*#__PURE__*/function (_Data33) {
  _inherits(MasterEditionV2Data, _Data33);

  var _super73 = _createSuper(MasterEditionV2Data);

  function MasterEditionV2Data(args) {
    var _this59;

    _classCallCheck(this, MasterEditionV2Data);

    _this59 = _super73.call(this, args);
    _this59.key = MetadataKey.MasterEditionV2;
    return _this59;
  }

  return MasterEditionV2Data;
}(Data);

_b$2 = MasterEditionV2Data;
MasterEditionV2Data.SCHEMA = _b$2.struct([['key', 'u8'], ['supply', 'u64'], ['maxSupply', {
  kind: 'option',
  type: 'u64'
}]]);

var MasterEdition = /*#__PURE__*/function (_Account18) {
  _inherits(MasterEdition, _Account18);

  var _super74 = _createSuper(MasterEdition);

  function MasterEdition(key, info) {
    var _this60;

    _classCallCheck(this, MasterEdition);

    _this60 = _super74.call(this, key, info);

    if (!_this60.assertOwner(MetadataProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (MasterEdition.isMasterEditionV1(_this60.info.data)) {
      _this60.data = MasterEditionV1Data.deserialize(_this60.info.data);
    } else if (MasterEdition.isMasterEditionV2(_this60.info.data)) {
      _this60.data = MasterEditionV2Data.deserialize(_this60.info.data);
    } else {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    return _this60;
  }

  _createClass(MasterEdition, [{
    key: "getEditions",
    value: function getEditions(connection) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return MetadataProgram.getProgramAccounts(connection, {
                  filters: [{
                    memcmp: {
                      offset: 0,
                      bytes: bs58.encode(Buffer$1.from([MetadataKey.EditionV1]))
                    }
                  }, {
                    memcmp: {
                      offset: 1,
                      bytes: this.pubkey.toBase58()
                    }
                  }]
                });

              case 2:
                return _context34.abrupt("return", _context34.sent.map(function (account) {
                  return Edition.from(account);
                }));

              case 3:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
  }], [{
    key: "getPDA",
    value: function getPDA(mint) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                return _context35.abrupt("return", MetadataProgram.findProgramAddress([Buffer$1.from(MetadataProgram.PREFIX), MetadataProgram.PUBKEY.toBuffer(), new PublicKey(mint).toBuffer(), Buffer$1.from(MasterEdition.EDITION_PREFIX)]));

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(data) {
      return MasterEdition.isMasterEditionV1(data) || MasterEdition.isMasterEditionV2(data);
    }
  }, {
    key: "isMasterEditionV1",
    value: function isMasterEditionV1(data) {
      return data[0] === MetadataKey.MasterEditionV1;
    }
  }, {
    key: "isMasterEditionV2",
    value: function isMasterEditionV2(data) {
      return data[0] === MetadataKey.MasterEditionV2;
    }
  }]);

  return MasterEdition;
}(Account);

MasterEdition.EDITION_PREFIX = 'edition';

var TokenAccount = /*#__PURE__*/function (_Account19) {
  _inherits(TokenAccount, _Account19);

  var _super75 = _createSuper(TokenAccount);

  function TokenAccount(pubkey, info) {
    var _this61;

    _classCallCheck(this, TokenAccount);

    _this61 = _super75.call(this, pubkey, info);

    if (!_this61.assertOwner(TOKEN_PROGRAM_ID)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!TokenAccount.isCompatible(_this61.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this61.data = deserialize(_this61.info.data);
    return _this61;
  }

  _createClass(TokenAccount, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data.length === AccountLayout.span;
    }
  }, {
    key: "getTokenAccountsByOwner",
    value: function getTokenAccountsByOwner(connection, owner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return connection.getTokenAccountsByOwner(new PublicKey(owner), {
                  programId: TOKEN_PROGRAM_ID
                });

              case 2:
                return _context36.abrupt("return", _context36.sent.value.map(function (_ref11) {
                  var pubkey = _ref11.pubkey,
                      account = _ref11.account;
                  return new TokenAccount(pubkey, account);
                }));

              case 3:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36);
      }));
    }
  }]);

  return TokenAccount;
}(Account);

var deserialize = function deserialize(data) {
  var accountInfo = AccountLayout.decode(data);
  accountInfo.mint = new PublicKey(accountInfo.mint);
  accountInfo.owner = new PublicKey(accountInfo.owner);
  accountInfo.amount = u64.fromBuffer(accountInfo.amount);

  if (accountInfo.delegateOption === 0) {
    accountInfo.delegate = null;
    accountInfo.delegatedAmount = new u64(0);
  } else {
    accountInfo.delegate = new PublicKey(accountInfo.delegate);
    accountInfo.delegatedAmount = u64.fromBuffer(accountInfo.delegatedAmount);
  }

  accountInfo.isInitialized = accountInfo.state !== 0;
  accountInfo.isFrozen = accountInfo.state === 2;

  if (accountInfo.isNativeOption === 1) {
    accountInfo.rentExemptReserve = u64.fromBuffer(accountInfo.isNative);
    accountInfo.isNative = true;
  } else {
    accountInfo.rentExemptReserve = null;
    accountInfo.isNative = false;
  }

  if (accountInfo.closeAuthorityOption === 0) {
    accountInfo.closeAuthority = null;
  } else {
    accountInfo.closeAuthority = new PublicKey(accountInfo.closeAuthority);
  }

  return accountInfo;
};

var PayForFiles = /*#__PURE__*/function (_Transaction17) {
  _inherits(PayForFiles, _Transaction17);

  var _super76 = _createSuper(PayForFiles);

  function PayForFiles(options, params) {
    var _this62;

    _classCallCheck(this, PayForFiles);

    var feePayer = options.feePayer;
    var lamports = params.lamports,
        fileHashes = params.fileHashes,
        arweaveWallet = params.arweaveWallet;
    _this62 = _super76.call(this, options);

    _this62.add(SystemProgram.transfer({
      fromPubkey: feePayer,
      toPubkey: arweaveWallet !== null && arweaveWallet !== void 0 ? arweaveWallet : new PublicKey(config.arweaveWallet),
      lamports: lamports
    }));

    fileHashes.forEach(function (data) {
      _this62.add(new TransactionInstruction({
        keys: [],
        programId: new PublicKey(config.programs.memo),
        data: data
      }));
    });
    return _this62;
  }

  return PayForFiles;
}(Transaction);

var CreateMint = /*#__PURE__*/function (_Transaction18) {
  _inherits(CreateMint, _Transaction18);

  var _super77 = _createSuper(CreateMint);

  function CreateMint(options, params) {
    var _this63;

    _classCallCheck(this, CreateMint);

    var feePayer = options.feePayer;
    var newAccountPubkey = params.newAccountPubkey,
        lamports = params.lamports,
        decimals = params.decimals,
        owner = params.owner,
        freezeAuthority = params.freezeAuthority;
    _this63 = _super77.call(this, options);

    _this63.add(SystemProgram.createAccount({
      fromPubkey: feePayer,
      newAccountPubkey: newAccountPubkey,
      lamports: lamports,
      space: MintLayout.span,
      programId: TOKEN_PROGRAM_ID
    }));

    _this63.add(Token.createInitMintInstruction(TOKEN_PROGRAM_ID, newAccountPubkey, decimals !== null && decimals !== void 0 ? decimals : 0, owner !== null && owner !== void 0 ? owner : feePayer, freezeAuthority !== null && freezeAuthority !== void 0 ? freezeAuthority : feePayer));

    return _this63;
  }

  return CreateMint;
}(Transaction);

var CreateTokenAccount = /*#__PURE__*/function (_Transaction19) {
  _inherits(CreateTokenAccount, _Transaction19);

  var _super78 = _createSuper(CreateTokenAccount);

  function CreateTokenAccount(options, params) {
    var _this64;

    _classCallCheck(this, CreateTokenAccount);

    var feePayer = options.feePayer;
    var newAccountPubkey = params.newAccountPubkey,
        lamports = params.lamports,
        mint = params.mint,
        owner = params.owner;
    _this64 = _super78.call(this, options);

    _this64.add(SystemProgram.createAccount({
      fromPubkey: feePayer,
      newAccountPubkey: newAccountPubkey,
      lamports: lamports,
      space: AccountLayout.span,
      programId: TOKEN_PROGRAM_ID
    }));

    _this64.add(Token.createInitAccountInstruction(TOKEN_PROGRAM_ID, mint, newAccountPubkey, owner !== null && owner !== void 0 ? owner : feePayer));

    return _this64;
  }

  return CreateTokenAccount;
}(Transaction);

var CreateAssociatedTokenAccount = /*#__PURE__*/function (_Transaction20) {
  _inherits(CreateAssociatedTokenAccount, _Transaction20);

  var _super79 = _createSuper(CreateAssociatedTokenAccount);

  function CreateAssociatedTokenAccount(options, params) {
    var _this65;

    _classCallCheck(this, CreateAssociatedTokenAccount);

    var feePayer = options.feePayer;
    var associatedTokenAddress = params.associatedTokenAddress,
        walletAddress = params.walletAddress,
        splTokenMintAddress = params.splTokenMintAddress;
    _this65 = _super79.call(this, options);

    _this65.add(new TransactionInstruction({
      keys: [{
        pubkey: feePayer,
        isSigner: true,
        isWritable: true
      }, {
        pubkey: associatedTokenAddress,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: walletAddress !== null && walletAddress !== void 0 ? walletAddress : feePayer,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: splTokenMintAddress,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: ASSOCIATED_TOKEN_PROGRAM_ID,
      data: Buffer$1.from([])
    }));

    return _this65;
  }

  return CreateAssociatedTokenAccount;
}(Transaction);

var MintTo = /*#__PURE__*/function (_Transaction21) {
  _inherits(MintTo, _Transaction21);

  var _super80 = _createSuper(MintTo);

  function MintTo(options, params) {
    var _this66;

    _classCallCheck(this, MintTo);

    var feePayer = options.feePayer;
    var mint = params.mint,
        dest = params.dest,
        authority = params.authority,
        amount = params.amount;
    _this66 = _super80.call(this, options);

    _this66.add(Token.createMintToInstruction(TOKEN_PROGRAM_ID, mint, dest, authority !== null && authority !== void 0 ? authority : feePayer, [], new BN(amount).toNumber()));

    return _this66;
  }

  return MintTo;
}(Transaction);

var _a$d, _b$1, _c;

var Creator = /*#__PURE__*/function (_Data34) {
  _inherits(Creator, _Data34);

  var _super81 = _createSuper(Creator);

  function Creator() {
    _classCallCheck(this, Creator);

    return _super81.apply(this, arguments);
  }

  return Creator;
}(Data);

_a$d = Creator;
Creator.SCHEMA = _a$d.struct([['address', 'pubkeyAsString'], ['verified', 'u8'], ['share', 'u8']]);

var MetadataDataData = /*#__PURE__*/function (_Data35) {
  _inherits(MetadataDataData, _Data35);

  var _super82 = _createSuper(MetadataDataData);

  function MetadataDataData(args) {
    var _this67;

    _classCallCheck(this, MetadataDataData);

    _this67 = _super82.call(this, args);
    var METADATA_REPLACE = new RegExp("\0", 'g');
    _this67.name = args.name.replace(METADATA_REPLACE, '');
    _this67.uri = args.uri.replace(METADATA_REPLACE, '');
    _this67.symbol = args.symbol.replace(METADATA_REPLACE, '');
    return _this67;
  }

  return MetadataDataData;
}(Data);

_b$1 = MetadataDataData;
MetadataDataData.SCHEMA = new Map([].concat(_toConsumableArray(Creator.SCHEMA), _toConsumableArray(_b$1.struct([['name', 'string'], ['symbol', 'string'], ['uri', 'string'], ['sellerFeeBasisPoints', 'u16'], ['creators', {
  kind: 'option',
  type: [Creator]
}]]))));

var MetadataData = /*#__PURE__*/function (_Data36) {
  _inherits(MetadataData, _Data36);

  var _super83 = _createSuper(MetadataData);

  function MetadataData(args) {
    var _this68;

    _classCallCheck(this, MetadataData);

    _this68 = _super83.call(this, args);
    _this68.key = MetadataKey.MetadataV1;
    return _this68;
  }

  return MetadataData;
}(Data);

_c = MetadataData;
MetadataData.SCHEMA = new Map([].concat(_toConsumableArray(MetadataDataData.SCHEMA), _toConsumableArray(_c.struct([['key', 'u8'], ['updateAuthority', 'pubkeyAsString'], ['mint', 'pubkeyAsString'], ['data', MetadataDataData], ['primarySaleHappened', 'u8'], ['isMutable', 'u8']]))));

var Metadata = /*#__PURE__*/function (_Account20) {
  _inherits(Metadata, _Account20);

  var _super84 = _createSuper(Metadata);

  function Metadata(pubkey, info) {
    var _this69;

    _classCallCheck(this, Metadata);

    _this69 = _super84.call(this, pubkey, info);

    if (!_this69.assertOwner(MetadataProgram.PUBKEY)) {
      throw ERROR_INVALID_OWNER();
    }

    if (!Metadata.isCompatible(_this69.info.data)) {
      throw ERROR_INVALID_ACCOUNT_DATA();
    }

    _this69.data = MetadataData.deserialize(_this69.info.data);
    return _this69;
  }

  _createClass(Metadata, null, [{
    key: "isCompatible",
    value: function isCompatible(data) {
      return data[0] === MetadataKey.MetadataV1;
    }
  }, {
    key: "getPDA",
    value: function getPDA(mint) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", MetadataProgram.findProgramAddress([Buffer$1.from(MetadataProgram.PREFIX), MetadataProgram.PUBKEY.toBuffer(), new PublicKey(mint).toBuffer()]));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));
    }
  }, {
    key: "findMany",
    value: function findMany(connection) {
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var baseFilters;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                baseFilters = [{
                  memcmp: {
                    offset: 0,
                    bytes: bs58.encode(Buffer$1.from([MetadataKey.MetadataV1]))
                  }
                }, filters.updateAuthority && {
                  memcmp: {
                    offset: 1,
                    bytes: new PublicKey(filters.updateAuthority).toBase58()
                  }
                }, filters.mint && {
                  memcmp: {
                    offset: 33,
                    bytes: new PublicKey(filters.mint).toBase58()
                  }
                }].filter(Boolean);

                if (!filters.creators) {
                  _context38.next = 7;
                  break;
                }

                _context38.next = 4;
                return Promise.all(Array.from(Array(config.maxCreatorLimit).keys()).reduce(function (prev, i) {
                  return [].concat(_toConsumableArray(prev), _toConsumableArray(filters.creators.map(function (pubkey) {
                    return MetadataProgram.getProgramAccounts(connection, {
                      filters: [].concat(_toConsumableArray(baseFilters), [{
                        memcmp: {
                          offset: computeCreatorOffset(i),
                          bytes: new PublicKey(pubkey).toBase58()
                        }
                      }])
                    });
                  })));
                }, []));

              case 4:
                return _context38.abrupt("return", _context38.sent.flat().map(function (account) {
                  return Metadata.from(account);
                }));

              case 7:
                _context38.next = 9;
                return MetadataProgram.getProgramAccounts(connection, {
                  filters: baseFilters
                });

              case 9:
                return _context38.abrupt("return", _context38.sent.map(function (account) {
                  return Metadata.from(account);
                }));

              case 10:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));
    }
  }, {
    key: "findByOwner",
    value: function findByOwner(connection, owner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var accounts, accountMap, allMetadata;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return TokenAccount.getTokenAccountsByOwner(connection, owner);

              case 2:
                accounts = _context39.sent;
                accountMap = new Map(accounts.map(function (_ref12) {
                  var data = _ref12.data;
                  return [data.mint.toString(), data];
                }));
                _context39.next = 6;
                return Metadata.findMany(connection);

              case 6:
                allMetadata = _context39.sent;
                return _context39.abrupt("return", allMetadata.filter(function (metadata) {
                  var _d, _e;

                  return accountMap.has(metadata.data.mint) && (((_e = (_d = accountMap === null || accountMap === void 0 ? void 0 : accountMap.get(metadata.data.mint)) === null || _d === void 0 ? void 0 : _d.amount) === null || _e === void 0 ? void 0 : _e.toNumber()) || 0) > 0;
                }));

              case 8:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));
    }
  }, {
    key: "findByOwnerV2",
    value: function findByOwnerV2(connection, owner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var accounts, accountsWithAmount;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return TokenAccount.getTokenAccountsByOwner(connection, owner);

              case 2:
                accounts = _context40.sent;
                accountsWithAmount = accounts.map(function (_ref13) {
                  var data = _ref13.data;
                  return data;
                }).filter(function (_ref14) {
                  var amount = _ref14.amount;
                  return (amount === null || amount === void 0 ? void 0 : amount.toNumber()) > 0;
                });
                _context40.next = 6;
                return Promise.all(accountsWithAmount.map(function (_ref15) {
                  var mint = _ref15.mint;
                  return Metadata.findMany(connection, {
                    mint: mint
                  });
                }));

              case 6:
                return _context40.abrupt("return", _context40.sent.flat());

              case 7:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));
    }
  }, {
    key: "findDataByOwner",
    value: function findDataByOwner(connection, owner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var accounts, metadataPdaLookups, metadataAddresses, tokenInfo;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return TokenAccount.getTokenAccountsByOwner(connection, owner);

              case 2:
                accounts = _context41.sent;
                metadataPdaLookups = accounts.reduce(function (memo, _ref16) {
                  var data = _ref16.data;

                  var _d;

                  return ((_d = data.amount) === null || _d === void 0 ? void 0 : _d.eq(new BN(1))) ? [].concat(_toConsumableArray(memo), [Metadata.getPDA(data.mint)]) : memo;
                }, []);
                _context41.next = 6;
                return Promise.all(metadataPdaLookups);

              case 6:
                metadataAddresses = _context41.sent;
                _context41.next = 9;
                return Account.getInfos(connection, metadataAddresses);

              case 9:
                tokenInfo = _context41.sent;
                return _context41.abrupt("return", Array.from(tokenInfo.values()).map(function (m) {
                  return MetadataData.deserialize(m.data);
                }));

              case 11:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41);
      }));
    }
  }, {
    key: "getEdition",
    value: function getEdition(connection, mint) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        var pda, info, key;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return Edition.getPDA(mint);

              case 2:
                pda = _context42.sent;
                _context42.next = 5;
                return Account.getInfo(connection, pda);

              case 5:
                info = _context42.sent;
                key = info === null || info === void 0 ? void 0 : info.data[0];
                _context42.t0 = key;
                _context42.next = _context42.t0 === MetadataKey.EditionV1 ? 10 : _context42.t0 === MetadataKey.MasterEditionV1 ? 11 : _context42.t0 === MetadataKey.MasterEditionV2 ? 11 : 12;
                break;

              case 10:
                return _context42.abrupt("return", new Edition(pda, info));

              case 11:
                return _context42.abrupt("return", new MasterEdition(pda, info));

              case 12:
                return _context42.abrupt("return");

              case 13:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));
    }
  }]);

  return Metadata;
}(Account);

var MAX_NAME_LENGTH = 32;
var MAX_SYMBOL_LENGTH = 10;
var MAX_URI_LENGTH = 200;
var MAX_CREATOR_LEN = 32 + 1 + 1;

var computeCreatorOffset = function computeCreatorOffset(index) {
  return 1 + 32 + 32 + 4 + MAX_NAME_LENGTH + 4 + MAX_URI_LENGTH + 4 + MAX_SYMBOL_LENGTH + 2 + 1 + 4 + index * MAX_CREATOR_LEN;
};

var _a$c;

var CreateMetadataArgs = /*#__PURE__*/function (_Data37) {
  _inherits(CreateMetadataArgs, _Data37);

  var _super85 = _createSuper(CreateMetadataArgs);

  function CreateMetadataArgs() {
    var _this70;

    _classCallCheck(this, CreateMetadataArgs);

    _this70 = _super85.apply(this, arguments);
    _this70.instruction = 0;
    return _this70;
  }

  return CreateMetadataArgs;
}(Data);

_a$c = CreateMetadataArgs;
CreateMetadataArgs.SCHEMA = new Map([].concat(_toConsumableArray(MetadataDataData.SCHEMA), _toConsumableArray(_a$c.struct([['instruction', 'u8'], ['data', MetadataDataData], ['isMutable', 'u8']]))));

var CreateMetadata = /*#__PURE__*/function (_Transaction22) {
  _inherits(CreateMetadata, _Transaction22);

  var _super86 = _createSuper(CreateMetadata);

  function CreateMetadata(options, params) {
    var _this71;

    _classCallCheck(this, CreateMetadata);

    _this71 = _super86.call(this, options);
    var feePayer = options.feePayer;
    var metadata = params.metadata,
        metadataData = params.metadataData,
        updateAuthority = params.updateAuthority,
        mint = params.mint,
        mintAuthority = params.mintAuthority;
    var data = CreateMetadataArgs.serialize({
      data: metadataData,
      isMutable: true
    });

    _this71.add(new TransactionInstruction({
      keys: [{
        pubkey: metadata,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: mint,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: mintAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: updateAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetadataProgram.PUBKEY,
      data: data
    }));

    return _this71;
  }

  return CreateMetadata;
}(Transaction);

var _a$b;

var UpdateMetadataArgs = /*#__PURE__*/function (_Data38) {
  _inherits(UpdateMetadataArgs, _Data38);

  var _super87 = _createSuper(UpdateMetadataArgs);

  function UpdateMetadataArgs() {
    var _this72;

    _classCallCheck(this, UpdateMetadataArgs);

    _this72 = _super87.apply(this, arguments);
    _this72.instruction = 1;
    return _this72;
  }

  return UpdateMetadataArgs;
}(Data);

_a$b = UpdateMetadataArgs;
UpdateMetadataArgs.SCHEMA = new Map([].concat(_toConsumableArray(MetadataDataData.SCHEMA), _toConsumableArray(_a$b.struct([['instruction', 'u8'], ['data', {
  kind: 'option',
  type: MetadataDataData
}], ['updateAuthority', {
  kind: 'option',
  type: 'pubkeyAsString'
}], ['primarySaleHappened', {
  kind: 'option',
  type: 'u8'
}]]))));

var UpdateMetadata = /*#__PURE__*/function (_Transaction23) {
  _inherits(UpdateMetadata, _Transaction23);

  var _super88 = _createSuper(UpdateMetadata);

  function UpdateMetadata(options, params) {
    var _this73;

    _classCallCheck(this, UpdateMetadata);

    _this73 = _super88.call(this, options);
    var metadata = params.metadata,
        metadataData = params.metadataData,
        updateAuthority = params.updateAuthority,
        newUpdateAuthority = params.newUpdateAuthority,
        primarySaleHappened = params.primarySaleHappened;
    var data = UpdateMetadataArgs.serialize({
      data: metadataData,
      updateAuthority: newUpdateAuthority && newUpdateAuthority.toString(),
      primarySaleHappened: primarySaleHappened || null
    });

    _this73.add(new TransactionInstruction({
      keys: [{
        pubkey: metadata,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: updateAuthority,
        isSigner: true,
        isWritable: false
      }],
      programId: MetadataProgram.PUBKEY,
      data: data
    }));

    return _this73;
  }

  return UpdateMetadata;
}(Transaction);

var _a$a;

var CreateMasterEditionArgs = /*#__PURE__*/function (_Data39) {
  _inherits(CreateMasterEditionArgs, _Data39);

  var _super89 = _createSuper(CreateMasterEditionArgs);

  function CreateMasterEditionArgs() {
    var _this74;

    _classCallCheck(this, CreateMasterEditionArgs);

    _this74 = _super89.apply(this, arguments);
    _this74.instruction = 10;
    return _this74;
  }

  return CreateMasterEditionArgs;
}(Data);

_a$a = CreateMasterEditionArgs;
CreateMasterEditionArgs.SCHEMA = _a$a.struct([['instruction', 'u8'], ['maxSupply', {
  kind: 'option',
  type: 'u64'
}]]);

var CreateMasterEdition = /*#__PURE__*/function (_Transaction24) {
  _inherits(CreateMasterEdition, _Transaction24);

  var _super90 = _createSuper(CreateMasterEdition);

  function CreateMasterEdition(options, params) {
    var _this75;

    _classCallCheck(this, CreateMasterEdition);

    _this75 = _super90.call(this, options);
    var feePayer = options.feePayer;
    var edition = params.edition,
        metadata = params.metadata,
        updateAuthority = params.updateAuthority,
        mint = params.mint,
        mintAuthority = params.mintAuthority,
        maxSupply = params.maxSupply;
    var data = CreateMasterEditionArgs.serialize({
      maxSupply: maxSupply || null
    });

    _this75.add(new TransactionInstruction({
      keys: [{
        pubkey: edition,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: mint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: updateAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: mintAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: metadata,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetadataProgram.PUBKEY,
      data: data
    }));

    return _this75;
  }

  return CreateMasterEdition;
}(Transaction);

var _a$9;

var MintNewEditionFromMasterEditionViaTokenArgs = /*#__PURE__*/function (_Data40) {
  _inherits(MintNewEditionFromMasterEditionViaTokenArgs, _Data40);

  var _super91 = _createSuper(MintNewEditionFromMasterEditionViaTokenArgs);

  function MintNewEditionFromMasterEditionViaTokenArgs() {
    var _this76;

    _classCallCheck(this, MintNewEditionFromMasterEditionViaTokenArgs);

    _this76 = _super91.apply(this, arguments);
    _this76.instruction = 11;
    return _this76;
  }

  return MintNewEditionFromMasterEditionViaTokenArgs;
}(Data);

_a$9 = MintNewEditionFromMasterEditionViaTokenArgs;
MintNewEditionFromMasterEditionViaTokenArgs.SCHEMA = _a$9.struct([['instruction', 'u8'], ['edition', 'u64']]);

var MintNewEditionFromMasterEditionViaToken = /*#__PURE__*/function (_Transaction25) {
  _inherits(MintNewEditionFromMasterEditionViaToken, _Transaction25);

  var _super92 = _createSuper(MintNewEditionFromMasterEditionViaToken);

  function MintNewEditionFromMasterEditionViaToken(options, params) {
    var _this77;

    _classCallCheck(this, MintNewEditionFromMasterEditionViaToken);

    _this77 = _super92.call(this, options);
    var feePayer = options.feePayer;
    var edition = params.edition,
        metadata = params.metadata,
        updateAuthority = params.updateAuthority,
        masterEdition = params.masterEdition,
        masterMetadata = params.masterMetadata,
        mint = params.mint,
        editionMarker = params.editionMarker,
        mintAuthority = params.mintAuthority,
        tokenOwner = params.tokenOwner,
        tokenAccount = params.tokenAccount,
        editionValue = params.editionValue;
    var data = MintNewEditionFromMasterEditionViaTokenArgs.serialize({
      edition: editionValue
    });

    _this77.add(new TransactionInstruction({
      keys: [{
        pubkey: metadata,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: edition,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: masterEdition,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: mint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: editionMarker,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: mintAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: tokenOwner,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: tokenAccount,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: updateAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: masterMetadata,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetadataProgram.PUBKEY,
      data: data
    }));

    return _this77;
  }

  return MintNewEditionFromMasterEditionViaToken;
}(Transaction);

var _a$8;

var UpdatePrimarySaleHappenedViaTokenArgs = /*#__PURE__*/function (_Data41) {
  _inherits(UpdatePrimarySaleHappenedViaTokenArgs, _Data41);

  var _super93 = _createSuper(UpdatePrimarySaleHappenedViaTokenArgs);

  function UpdatePrimarySaleHappenedViaTokenArgs() {
    var _this78;

    _classCallCheck(this, UpdatePrimarySaleHappenedViaTokenArgs);

    _this78 = _super93.apply(this, arguments);
    _this78.instruction = 4;
    return _this78;
  }

  return UpdatePrimarySaleHappenedViaTokenArgs;
}(Data);

_a$8 = UpdatePrimarySaleHappenedViaTokenArgs;
UpdatePrimarySaleHappenedViaTokenArgs.SCHEMA = _a$8.struct([['instruction', 'u8']]);

var UpdatePrimarySaleHappenedViaToken = /*#__PURE__*/function (_Transaction26) {
  _inherits(UpdatePrimarySaleHappenedViaToken, _Transaction26);

  var _super94 = _createSuper(UpdatePrimarySaleHappenedViaToken);

  function UpdatePrimarySaleHappenedViaToken(options, params) {
    var _this79;

    _classCallCheck(this, UpdatePrimarySaleHappenedViaToken);

    _this79 = _super94.call(this, options);
    var metadata = params.metadata,
        owner = params.owner,
        tokenAccount = params.tokenAccount;
    var data = UpdatePrimarySaleHappenedViaTokenArgs.serialize();

    _this79.add(new TransactionInstruction({
      keys: [{
        pubkey: metadata,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: owner,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: tokenAccount,
        isSigner: false,
        isWritable: false
      }],
      programId: MetadataProgram.PUBKEY,
      data: data
    }));

    return _this79;
  }

  return UpdatePrimarySaleHappenedViaToken;
}(Transaction);

var _a$7;

var SignMetadataArgs = /*#__PURE__*/function (_Data42) {
  _inherits(SignMetadataArgs, _Data42);

  var _super95 = _createSuper(SignMetadataArgs);

  function SignMetadataArgs() {
    var _this80;

    _classCallCheck(this, SignMetadataArgs);

    _this80 = _super95.apply(this, arguments);
    _this80.instruction = 7;
    return _this80;
  }

  return SignMetadataArgs;
}(Data);

_a$7 = SignMetadataArgs;
SignMetadataArgs.SCHEMA = _a$7.struct([['instruction', 'u8']]);

var SignMetadata = /*#__PURE__*/function (_Transaction27) {
  _inherits(SignMetadata, _Transaction27);

  var _super96 = _createSuper(SignMetadata);

  function SignMetadata(options, params) {
    var _this81;

    _classCallCheck(this, SignMetadata);

    _this81 = _super96.call(this, options);
    var metadata = params.metadata,
        creator = params.creator;
    var data = SignMetadataArgs.serialize();

    _this81.add(new TransactionInstruction({
      keys: [{
        pubkey: metadata,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: creator,
        isSigner: true,
        isWritable: false
      }],
      programId: MetadataProgram.PUBKEY,
      data: data
    }));

    return _this81;
  }

  return SignMetadata;
}(Transaction);

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  EditionData: EditionData,
  Edition: Edition,
  EditionMarkerData: EditionMarkerData,
  EditionMarker: EditionMarker,
  MasterEditionV1Data: MasterEditionV1Data,
  MasterEditionV2Data: MasterEditionV2Data,
  MasterEdition: MasterEdition,
  Creator: Creator,
  MetadataDataData: MetadataDataData,
  MetadataData: MetadataData,
  Metadata: Metadata,
  MAX_NAME_LENGTH: MAX_NAME_LENGTH,
  MAX_SYMBOL_LENGTH: MAX_SYMBOL_LENGTH,
  MAX_URI_LENGTH: MAX_URI_LENGTH,
  MAX_CREATOR_LEN: MAX_CREATOR_LEN,
  computeCreatorOffset: computeCreatorOffset,

  get MetadataKey() {
    return MetadataKey;
  },

  MetadataProgram: MetadataProgram,
  CreateMetadataArgs: CreateMetadataArgs,
  CreateMetadata: CreateMetadata,
  UpdateMetadataArgs: UpdateMetadataArgs,
  UpdateMetadata: UpdateMetadata,
  CreateMasterEditionArgs: CreateMasterEditionArgs,
  CreateMasterEdition: CreateMasterEdition,
  MintNewEditionFromMasterEditionViaTokenArgs: MintNewEditionFromMasterEditionViaTokenArgs,
  MintNewEditionFromMasterEditionViaToken: MintNewEditionFromMasterEditionViaToken,
  UpdatePrimarySaleHappenedViaTokenArgs: UpdatePrimarySaleHappenedViaTokenArgs,
  UpdatePrimarySaleHappenedViaToken: UpdatePrimarySaleHappenedViaToken,
  SignMetadataArgs: SignMetadataArgs,
  SignMetadata: SignMetadata
});

var _a$6;

var SetStoreArgs = /*#__PURE__*/function (_Data43) {
  _inherits(SetStoreArgs, _Data43);

  var _super97 = _createSuper(SetStoreArgs);

  function SetStoreArgs() {
    var _this82;

    _classCallCheck(this, SetStoreArgs);

    _this82 = _super97.apply(this, arguments);
    _this82.instruction = 8;
    return _this82;
  }

  return SetStoreArgs;
}(Data);

_a$6 = SetStoreArgs;
SetStoreArgs.SCHEMA = _a$6.struct([['instruction', 'u8'], ['public', 'u8']]);

var SetStore = /*#__PURE__*/function (_Transaction28) {
  _inherits(SetStore, _Transaction28);

  var _super98 = _createSuper(SetStore);

  function SetStore(options, params) {
    var _this83;

    _classCallCheck(this, SetStore);

    _this83 = _super98.call(this, options);
    var feePayer = options.feePayer;
    var admin = params.admin,
        store = params.store,
        isPublic = params.isPublic;
    var data = SetStoreArgs.serialize({
      public: isPublic
    });

    _this83.add(new TransactionInstruction({
      keys: [{
        pubkey: store,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: admin,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: VaultProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: MetadataProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: AuctionProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this83;
  }

  return SetStore;
}(Transaction);

var _a$5;

var SetWhitelistedCreatorArgs = /*#__PURE__*/function (_Data44) {
  _inherits(SetWhitelistedCreatorArgs, _Data44);

  var _super99 = _createSuper(SetWhitelistedCreatorArgs);

  function SetWhitelistedCreatorArgs() {
    var _this84;

    _classCallCheck(this, SetWhitelistedCreatorArgs);

    _this84 = _super99.apply(this, arguments);
    _this84.instruction = 9;
    return _this84;
  }

  return SetWhitelistedCreatorArgs;
}(Data);

_a$5 = SetWhitelistedCreatorArgs;
SetWhitelistedCreatorArgs.SCHEMA = _a$5.struct([['instruction', 'u8'], ['activated', 'u8']]);

var SetWhitelistedCreator = /*#__PURE__*/function (_Transaction29) {
  _inherits(SetWhitelistedCreator, _Transaction29);

  var _super100 = _createSuper(SetWhitelistedCreator);

  function SetWhitelistedCreator(options, params) {
    var _this85;

    _classCallCheck(this, SetWhitelistedCreator);

    _this85 = _super100.call(this, options);
    var feePayer = options.feePayer;
    var admin = params.admin,
        whitelistedCreatorPDA = params.whitelistedCreatorPDA,
        store = params.store,
        creator = params.creator,
        activated = params.activated;
    var data = SetWhitelistedCreatorArgs.serialize({
      activated: activated
    });

    _this85.add(new TransactionInstruction({
      keys: [{
        pubkey: whitelistedCreatorPDA,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: admin,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: creator,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this85;
  }

  return SetWhitelistedCreator;
}(Transaction);

var _a$4;

var StartAuctionArgs = /*#__PURE__*/function (_Data45) {
  _inherits(StartAuctionArgs, _Data45);

  var _super101 = _createSuper(StartAuctionArgs);

  function StartAuctionArgs() {
    var _this86;

    _classCallCheck(this, StartAuctionArgs);

    _this86 = _super101.apply(this, arguments);
    _this86.instruction = 5;
    return _this86;
  }

  return StartAuctionArgs;
}(Data);

_a$4 = StartAuctionArgs;
StartAuctionArgs.SCHEMA = _a$4.struct([['instruction', 'u8']]);

var StartAuction = /*#__PURE__*/function (_Transaction30) {
  _inherits(StartAuction, _Transaction30);

  var _super102 = _createSuper(StartAuction);

  function StartAuction(options, params) {
    var _this87;

    _classCallCheck(this, StartAuction);

    _this87 = _super102.call(this, options);
    var store = params.store,
        auction = params.auction,
        auctionManager = params.auctionManager,
        auctionManagerAuthority = params.auctionManagerAuthority;
    var data = StartAuctionArgs.serialize();

    _this87.add(new TransactionInstruction({
      keys: [{
        pubkey: auctionManager,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auctionManagerAuthority,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: AuctionProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this87;
  }

  return StartAuction;
}(Transaction);

var _a$3;

var InitAuctionManagerV2Args = /*#__PURE__*/function (_Data46) {
  _inherits(InitAuctionManagerV2Args, _Data46);

  var _super103 = _createSuper(InitAuctionManagerV2Args);

  function InitAuctionManagerV2Args() {
    var _this88;

    _classCallCheck(this, InitAuctionManagerV2Args);

    _this88 = _super103.apply(this, arguments);
    _this88.instruction = 17;
    _this88.amountType = TupleNumericType.U8;
    _this88.lengthType = TupleNumericType.U8;
    _this88.maxRanges = new BN(1);
    return _this88;
  }

  return InitAuctionManagerV2Args;
}(Data);

_a$3 = InitAuctionManagerV2Args;
InitAuctionManagerV2Args.SCHEMA = _a$3.struct([['instruction', 'u8'], ['amountType', 'u8'], ['lengthType', 'u8'], ['maxRanges', 'u64']]);

var InitAuctionManagerV2 = /*#__PURE__*/function (_Transaction31) {
  _inherits(InitAuctionManagerV2, _Transaction31);

  var _super104 = _createSuper(InitAuctionManagerV2);

  function InitAuctionManagerV2(options, params) {
    var _this89;

    _classCallCheck(this, InitAuctionManagerV2);

    _this89 = _super104.call(this, options);
    var feePayer = options.feePayer;
    var store = params.store,
        vault = params.vault,
        auction = params.auction,
        auctionManager = params.auctionManager,
        auctionManagerAuthority = params.auctionManagerAuthority,
        acceptPaymentAccount = params.acceptPaymentAccount,
        tokenTracker = params.tokenTracker,
        amountType = params.amountType,
        lengthType = params.lengthType,
        maxRanges = params.maxRanges;
    var data = InitAuctionManagerV2Args.serialize({
      amountType: amountType,
      lengthType: lengthType,
      maxRanges: maxRanges
    });

    _this89.add(new TransactionInstruction({
      keys: [{
        pubkey: auctionManager,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: tokenTracker,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: auctionManagerAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: acceptPaymentAccount,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }],
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this89;
  }

  return InitAuctionManagerV2;
}(Transaction);

var _a$2;

var ClaimBidArgs = /*#__PURE__*/function (_Data47) {
  _inherits(ClaimBidArgs, _Data47);

  var _super105 = _createSuper(ClaimBidArgs);

  function ClaimBidArgs() {
    var _this90;

    _classCallCheck(this, ClaimBidArgs);

    _this90 = _super105.apply(this, arguments);
    _this90.instruction = 6;
    return _this90;
  }

  return ClaimBidArgs;
}(Data);

_a$2 = ClaimBidArgs;
ClaimBidArgs.SCHEMA = _a$2.struct([['instruction', 'u8']]);

var ClaimBid = /*#__PURE__*/function (_Transaction32) {
  _inherits(ClaimBid, _Transaction32);

  var _super106 = _createSuper(ClaimBid);

  function ClaimBid(options, params) {
    var _this91;

    _classCallCheck(this, ClaimBid);

    _this91 = _super106.call(this, options);
    var store = params.store,
        vault = params.vault,
        auction = params.auction,
        auctionExtended = params.auctionExtended,
        auctionManager = params.auctionManager,
        bidder = params.bidder,
        bidderPot = params.bidderPot,
        bidderPotToken = params.bidderPotToken,
        acceptPayment = params.acceptPayment,
        tokenMint = params.tokenMint;
    var data = ClaimBidArgs.serialize();

    _this91.add(new TransactionInstruction({
      keys: [{
        pubkey: acceptPayment,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderPotToken,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidderPot,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auctionManager,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: bidder,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: tokenMint,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: AuctionProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: false
      }],
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this91;
  }

  return ClaimBid;
}(Transaction);

var _a$1, _b;

var RedeemBidArgs = /*#__PURE__*/function (_Data48) {
  _inherits(RedeemBidArgs, _Data48);

  var _super107 = _createSuper(RedeemBidArgs);

  function RedeemBidArgs() {
    var _this92;

    _classCallCheck(this, RedeemBidArgs);

    _this92 = _super107.apply(this, arguments);
    _this92.instruction = 2;
    return _this92;
  }

  return RedeemBidArgs;
}(Data);

_a$1 = RedeemBidArgs;
RedeemBidArgs.SCHEMA = _a$1.struct([['instruction', 'u8']]);
var ProxyCallAddress;

(function (ProxyCallAddress) {
  ProxyCallAddress[ProxyCallAddress["RedeemBid"] = 0] = "RedeemBid";
  ProxyCallAddress[ProxyCallAddress["RedeemFullRightsTransferBid"] = 1] = "RedeemFullRightsTransferBid";
})(ProxyCallAddress || (ProxyCallAddress = {}));

var RedeemUnusedWinningConfigItemsAsAuctioneerArgs = /*#__PURE__*/function (_Data49) {
  _inherits(RedeemUnusedWinningConfigItemsAsAuctioneerArgs, _Data49);

  var _super108 = _createSuper(RedeemUnusedWinningConfigItemsAsAuctioneerArgs);

  function RedeemUnusedWinningConfigItemsAsAuctioneerArgs() {
    var _this93;

    _classCallCheck(this, RedeemUnusedWinningConfigItemsAsAuctioneerArgs);

    _this93 = _super108.apply(this, arguments);
    _this93.instruction = 12;
    return _this93;
  }

  return RedeemUnusedWinningConfigItemsAsAuctioneerArgs;
}(Data);

_b = RedeemUnusedWinningConfigItemsAsAuctioneerArgs;
RedeemUnusedWinningConfigItemsAsAuctioneerArgs.SCHEMA = _b.struct([['instruction', 'u8'], ['winningConfigItemIndex', 'u8'], ['proxyCall', 'u8']]);

var RedeemBid = /*#__PURE__*/function (_Transaction33) {
  _inherits(RedeemBid, _Transaction33);

  var _super109 = _createSuper(RedeemBid);

  function RedeemBid(options, params) {
    var _this94;

    _classCallCheck(this, RedeemBid);

    _this94 = _super109.call(this, options);
    var feePayer = options.feePayer;
    var store = params.store,
        vault = params.vault,
        auction = params.auction,
        auctionExtended = params.auctionExtended,
        auctionManager = params.auctionManager,
        bidRedemption = params.bidRedemption,
        bidMetadata = params.bidderMeta,
        safetyDepositTokenStore = params.safetyDepositTokenStore,
        destination = params.destination,
        safetyDeposit = params.safetyDeposit,
        fractionMint = params.fractionMint,
        bidder = params.bidder,
        isPrintingType = params.isPrintingType,
        safetyDepositConfig = params.safetyDepositConfig,
        transferAuthority = params.transferAuthority,
        masterEdition = params.masterEdition,
        reservationList = params.reservationList,
        auctioneerReclaimIndex = params.auctioneerReclaimIndex;
    var data = auctioneerReclaimIndex ? RedeemUnusedWinningConfigItemsAsAuctioneerArgs.serialize({
      winningConfigItemIndex: auctioneerReclaimIndex,
      proxyCall: ProxyCallAddress.RedeemBid
    }) : RedeemBidArgs.serialize();

    _this94.add(new TransactionInstruction({
      keys: [{
        pubkey: auctionManager,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: safetyDepositTokenStore,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: destination,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidRedemption,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: safetyDeposit,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: bidMetadata,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: bidder,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: VaultProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: MetadataProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: safetyDepositConfig,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: false
      }].concat(_toConsumableArray(isPrintingType && masterEdition && reservationList ? [{
        pubkey: masterEdition,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: reservationList,
        isSigner: false,
        isWritable: true
      }] : [])),
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this94;
  }

  return RedeemBid;
}(Transaction);

var _a;

var RedeemFullRightsTransferBidArgs = /*#__PURE__*/function (_Data50) {
  _inherits(RedeemFullRightsTransferBidArgs, _Data50);

  var _super110 = _createSuper(RedeemFullRightsTransferBidArgs);

  function RedeemFullRightsTransferBidArgs() {
    var _this95;

    _classCallCheck(this, RedeemFullRightsTransferBidArgs);

    _this95 = _super110.apply(this, arguments);
    _this95.instruction = 3;
    return _this95;
  }

  return RedeemFullRightsTransferBidArgs;
}(Data);

_a = RedeemFullRightsTransferBidArgs;
RedeemFullRightsTransferBidArgs.SCHEMA = _a.struct([['instruction', 'u8']]);

var RedeemFullRightsTransferBid = /*#__PURE__*/function (_Transaction34) {
  _inherits(RedeemFullRightsTransferBid, _Transaction34);

  var _super111 = _createSuper(RedeemFullRightsTransferBid);

  function RedeemFullRightsTransferBid(options, params) {
    var _this96;

    _classCallCheck(this, RedeemFullRightsTransferBid);

    _this96 = _super111.call(this, options);
    var feePayer = options.feePayer;
    var store = params.store,
        vault = params.vault,
        auction = params.auction,
        auctionExtended = params.auctionExtended,
        auctionManager = params.auctionManager,
        bidRedemption = params.bidRedemption,
        bidMetadata = params.bidMetadata,
        safetyDepositTokenStore = params.safetyDepositTokenStore,
        destination = params.destination,
        safetyDeposit = params.safetyDeposit,
        fractionMint = params.fractionMint,
        bidder = params.bidder,
        safetyDepositConfig = params.safetyDepositConfig,
        transferAuthority = params.transferAuthority,
        masterMetadata = params.masterMetadata,
        newAuthority = params.newAuthority,
        auctioneerReclaimIndex = params.auctioneerReclaimIndex;
    var data = auctioneerReclaimIndex ? RedeemUnusedWinningConfigItemsAsAuctioneerArgs.serialize({
      winningConfigItemIndex: auctioneerReclaimIndex,
      proxyCall: ProxyCallAddress.RedeemFullRightsTransferBid
    }) : RedeemFullRightsTransferBidArgs.serialize();

    _this96.add(new TransactionInstruction({
      keys: [{
        pubkey: auctionManager,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: safetyDepositTokenStore,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: destination,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: bidRedemption,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: safetyDeposit,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: vault,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: fractionMint,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: auction,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: bidMetadata,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: bidder,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: feePayer,
        isSigner: true,
        isWritable: false
      }, {
        pubkey: TOKEN_PROGRAM_ID,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: VaultProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: MetadataProgram.PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: store,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SystemProgram.programId,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: masterMetadata,
        isSigner: false,
        isWritable: true
      }, {
        pubkey: newAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: transferAuthority,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: safetyDepositConfig,
        isSigner: false,
        isWritable: false
      }, {
        pubkey: auctionExtended,
        isSigner: false,
        isWritable: false
      }],
      programId: MetaplexProgram.PUBKEY,
      data: data
    }));

    return _this96;
  }

  return RedeemFullRightsTransferBid;
}(Transaction);

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get AuctionManagerStatus() {
    return AuctionManagerStatus;
  },

  AuctionManagerStateV2: AuctionManagerStateV2,
  AuctionManagerV2Data: AuctionManagerV2Data,
  AuctionManager: AuctionManager,
  WINNER_INDEX_OFFSETS: WINNER_INDEX_OFFSETS,
  BidRedemptionTicket: BidRedemptionTicket,
  PayoutTicketData: PayoutTicketData,
  PayoutTicket: PayoutTicket,
  PrizeTrackingTicketData: PrizeTrackingTicketData,
  PrizeTrackingTicket: PrizeTrackingTicket,

  get WinningConfigType() {
    return WinningConfigType;
  },

  get WinningConstraint() {
    return WinningConstraint;
  },

  get NonWinningConstraint() {
    return NonWinningConstraint;
  },

  SafetyDepositConfig: SafetyDepositConfig,
  StoreData: StoreData,
  Store: Store,
  WhitelistedCreatorData: WhitelistedCreatorData,
  WhitelistedCreator: WhitelistedCreator,
  AuctionWinnerTokenTypeTracker: AuctionWinnerTokenTypeTracker,

  get MetaplexKey() {
    return MetaplexKey;
  },

  MetaplexProgram: MetaplexProgram,
  SetStoreArgs: SetStoreArgs,
  SetStore: SetStore,
  SetWhitelistedCreatorArgs: SetWhitelistedCreatorArgs,
  SetWhitelistedCreator: SetWhitelistedCreator,
  StartAuctionArgs: StartAuctionArgs,
  StartAuction: StartAuction,
  InitAuctionManagerV2Args: InitAuctionManagerV2Args,
  InitAuctionManagerV2: InitAuctionManagerV2,
  ClaimBidArgs: ClaimBidArgs,
  ClaimBid: ClaimBid,
  RedeemBidArgs: RedeemBidArgs,

  get ProxyCallAddress() {
    return ProxyCallAddress;
  },

  RedeemUnusedWinningConfigItemsAsAuctioneerArgs: RedeemUnusedWinningConfigItemsAsAuctioneerArgs,
  RedeemBid: RedeemBid,
  RedeemFullRightsTransferBidArgs: RedeemFullRightsTransferBidArgs,
  RedeemFullRightsTransferBid: RedeemFullRightsTransferBid
});

var initStore = function initStore(_ref17) {
  var connection = _ref17.connection,
      wallet = _ref17.wallet,
      _ref17$isPublic = _ref17.isPublic,
      isPublic = _ref17$isPublic === void 0 ? true : _ref17$isPublic;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
    var storeId, tx, txId;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.next = 2;
            return Store.getPDA(wallet.publicKey);

          case 2:
            storeId = _context43.sent;
            tx = new SetStore({
              feePayer: wallet.publicKey
            }, {
              admin: new PublicKey(wallet.publicKey),
              store: storeId,
              isPublic: isPublic
            });
            _context43.next = 6;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: [tx]
            });

          case 6:
            txId = _context43.sent;
            return _context43.abrupt("return", {
              storeId: storeId,
              txId: txId
            });

          case 8:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  auction: index$5,
  metadata: index$3,
  metaplex: index$2,
  vault: index$4,
  TokenAccount: TokenAccount,
  deserialize: deserialize,
  Transaction: Transaction,
  PayForFiles: PayForFiles,
  CreateMint: CreateMint,
  CreateTokenAccount: CreateTokenAccount,
  CreateAssociatedTokenAccount: CreateAssociatedTokenAccount,
  MintTo: MintTo
});

function prepareTokenAccountAndMintTx(connection, owner) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
    var mint, mintRent, createMintTx, recipient, createAssociatedTokenAccountTx, mintToTx;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            mint = Keypair.generate();
            _context44.next = 3;
            return connection.getMinimumBalanceForRentExemption(MintLayout.span);

          case 3:
            mintRent = _context44.sent;
            createMintTx = new CreateMint({
              feePayer: owner
            }, {
              newAccountPubkey: mint.publicKey,
              lamports: mintRent
            });
            _context44.next = 7;
            return Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, mint.publicKey, owner);

          case 7:
            recipient = _context44.sent;
            createAssociatedTokenAccountTx = new CreateAssociatedTokenAccount({
              feePayer: owner
            }, {
              associatedTokenAddress: recipient,
              splTokenMintAddress: mint.publicKey
            });
            mintToTx = new MintTo({
              feePayer: owner
            }, {
              mint: mint.publicKey,
              dest: recipient,
              amount: 1
            });
            return _context44.abrupt("return", {
              mint: mint,
              createMintTx: createMintTx,
              createAssociatedTokenAccountTx: createAssociatedTokenAccountTx,
              mintToTx: mintToTx
            });

          case 11:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
}

var mintNFT = function mintNFT(_ref18) {
  var connection = _ref18.connection,
      wallet = _ref18.wallet,
      uri = _ref18.uri,
      maxSupply = _ref18.maxSupply;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
    var _yield$prepareTokenAc, mint, createMintTx, createAssociatedTokenAccountTx, mintToTx, metadataPDA, editionPDA, _yield$lookup, name, symbol, seller_fee_basis_points, creators, creatorsData, metadataData, createMetadataTx, masterEditionTx, txId;

    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return prepareTokenAccountAndMintTx(connection, wallet.publicKey);

          case 2:
            _yield$prepareTokenAc = _context45.sent;
            mint = _yield$prepareTokenAc.mint;
            createMintTx = _yield$prepareTokenAc.createMintTx;
            createAssociatedTokenAccountTx = _yield$prepareTokenAc.createAssociatedTokenAccountTx;
            mintToTx = _yield$prepareTokenAc.mintToTx;
            _context45.next = 9;
            return Metadata.getPDA(mint.publicKey);

          case 9:
            metadataPDA = _context45.sent;
            _context45.next = 12;
            return MasterEdition.getPDA(mint.publicKey);

          case 12:
            editionPDA = _context45.sent;
            _context45.next = 15;
            return lookup(uri);

          case 15:
            _yield$lookup = _context45.sent;
            name = _yield$lookup.name;
            symbol = _yield$lookup.symbol;
            seller_fee_basis_points = _yield$lookup.seller_fee_basis_points;
            creators = _yield$lookup.properties.creators;
            creatorsData = creators.reduce(function (memo, _ref19) {
              var address = _ref19.address,
                  share = _ref19.share;
              var verified = address === wallet.publicKey.toString();
              var creator = new Creator({
                address: address,
                share: share,
                verified: verified
              });
              memo = [].concat(_toConsumableArray(memo), [creator]);
              return memo;
            }, []);
            metadataData = new MetadataDataData({
              name: name,
              symbol: symbol,
              uri: uri,
              sellerFeeBasisPoints: seller_fee_basis_points,
              creators: creatorsData
            });
            createMetadataTx = new CreateMetadata({
              feePayer: wallet.publicKey
            }, {
              metadata: metadataPDA,
              metadataData: metadataData,
              updateAuthority: wallet.publicKey,
              mint: mint.publicKey,
              mintAuthority: wallet.publicKey
            });
            masterEditionTx = new CreateMasterEdition({
              feePayer: wallet.publicKey
            }, {
              edition: editionPDA,
              metadata: metadataPDA,
              updateAuthority: wallet.publicKey,
              mint: mint.publicKey,
              mintAuthority: wallet.publicKey,
              maxSupply: maxSupply ? new BN(maxSupply) : null
            });
            _context45.next = 26;
            return sendTransaction({
              connection: connection,
              signers: [mint],
              txs: [createMintTx, createMetadataTx, createAssociatedTokenAccountTx, mintToTx, masterEditionTx],
              wallet: wallet
            });

          case 26:
            txId = _context45.sent;
            return _context45.abrupt("return", {
              txId: txId,
              mint: mint.publicKey,
              metadata: metadataPDA,
              edition: editionPDA
            });

          case 28:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
};

var mintEditionFromMaster = function mintEditionFromMaster() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      connection = _ref20.connection,
      wallet = _ref20.wallet,
      masterEditionMint = _ref20.masterEditionMint,
      updateAuthority = _ref20.updateAuthority;

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
    var masterPDA, masterMetaPDA, masterInfo, masterData, editionValue, _yield$prepareTokenAc2, mint, createMintTx, createAssociatedTokenAccountTx, mintToTx, tokenAccount, metadataPDA, editionMarker, editionPDA, newEditionFromMasterTx, txId;

    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.next = 2;
            return MasterEdition.getPDA(masterEditionMint);

          case 2:
            masterPDA = _context46.sent;
            _context46.next = 5;
            return Metadata.getPDA(masterEditionMint);

          case 5:
            masterMetaPDA = _context46.sent;
            _context46.next = 8;
            return Account.getInfo(connection, masterPDA);

          case 8:
            masterInfo = _context46.sent;
            masterData = new MasterEdition(masterPDA, masterInfo).data;
            editionValue = masterData.supply.add(new BN(1));
            _context46.next = 13;
            return prepareTokenAccountAndMintTx(connection, wallet.publicKey);

          case 13:
            _yield$prepareTokenAc2 = _context46.sent;
            mint = _yield$prepareTokenAc2.mint;
            createMintTx = _yield$prepareTokenAc2.createMintTx;
            createAssociatedTokenAccountTx = _yield$prepareTokenAc2.createAssociatedTokenAccountTx;
            mintToTx = _yield$prepareTokenAc2.mintToTx;
            _context46.next = 20;
            return Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, masterEditionMint, wallet.publicKey);

          case 20:
            tokenAccount = _context46.sent;
            _context46.next = 23;
            return Metadata.getPDA(mint.publicKey);

          case 23:
            metadataPDA = _context46.sent;
            _context46.next = 26;
            return EditionMarker.getPDA(masterEditionMint, editionValue);

          case 26:
            editionMarker = _context46.sent;
            _context46.next = 29;
            return Edition.getPDA(mint.publicKey);

          case 29:
            editionPDA = _context46.sent;
            newEditionFromMasterTx = new MintNewEditionFromMasterEditionViaToken({
              feePayer: wallet.publicKey
            }, {
              edition: editionPDA,
              metadata: metadataPDA,
              updateAuthority: updateAuthority !== null && updateAuthority !== void 0 ? updateAuthority : wallet.publicKey,
              mint: mint.publicKey,
              mintAuthority: wallet.publicKey,
              masterEdition: masterPDA,
              masterMetadata: masterMetaPDA,
              editionMarker: editionMarker,
              tokenOwner: wallet.publicKey,
              tokenAccount: tokenAccount,
              editionValue: editionValue
            });
            _context46.next = 33;
            return sendTransaction({
              connection: connection,
              signers: [mint],
              txs: [createMintTx, createAssociatedTokenAccountTx, mintToTx, newEditionFromMasterTx],
              wallet: wallet
            });

          case 33:
            txId = _context46.sent;
            return _context46.abrupt("return", {
              txId: txId,
              mint: mint.publicKey,
              metadata: metadataPDA,
              edition: editionPDA
            });

          case 35:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
};

var TransactionsBatch = /*#__PURE__*/function () {
  function TransactionsBatch(_ref21) {
    var _ref21$beforeTransact = _ref21.beforeTransactions,
        beforeTransactions = _ref21$beforeTransact === void 0 ? [] : _ref21$beforeTransact,
        transactions = _ref21.transactions,
        _ref21$afterTransacti = _ref21.afterTransactions,
        afterTransactions = _ref21$afterTransacti === void 0 ? [] : _ref21$afterTransacti;

    _classCallCheck(this, TransactionsBatch);

    this.signers = [];
    this.beforeTransactions = beforeTransactions;
    this.transactions = transactions;
    this.afterTransactions = afterTransactions;
  }

  _createClass(TransactionsBatch, [{
    key: "addSigner",
    value: function addSigner(signer) {
      this.signers.push(signer);
    }
  }, {
    key: "addBeforeTransaction",
    value: function addBeforeTransaction(transaction) {
      this.beforeTransactions.push(transaction);
    }
  }, {
    key: "addTransaction",
    value: function addTransaction(transaction) {
      this.transactions.push(transaction);
    }
  }, {
    key: "addAfterTransaction",
    value: function addAfterTransaction(transaction) {
      this.afterTransactions.push(transaction);
    }
  }, {
    key: "toTransactions",
    value: function toTransactions() {
      return [].concat(_toConsumableArray(this.beforeTransactions), _toConsumableArray(this.transactions), _toConsumableArray(this.afterTransactions));
    }
  }, {
    key: "toInstructions",
    value: function toInstructions() {
      return this.toTransactions().flatMap(function (t) {
        return t.instructions;
      });
    }
  }]);

  return TransactionsBatch;
}();

var closeVault = function closeVault(_ref22) {
  var connection = _ref22.connection,
      wallet = _ref22.wallet,
      vault = _ref22.vault,
      priceMint = _ref22.priceMint;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
    var accountRent, fractionMintAuthority, txBatch, txOptions, _yield$Vault$load, _yield$Vault$load$dat, fractionMint, fractionTreasury, redeemTreasury, pricingLookupAddress, fractionMintKey, fractionTreasuryKey, redeemTreasuryKey, pricingLookupAddressKey, activateVaultTx, outstandingShareAccount, outstandingShareAccountTx, payingTokenAccount, payingTokenAccountTx, transferAuthority, createApproveTx, combineVaultTx, txId;

    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.next = 2;
            return connection.getMinimumBalanceForRentExemption(AccountLayout.span);

          case 2:
            accountRent = _context47.sent;
            _context47.next = 5;
            return Vault.getPDA(vault);

          case 5:
            fractionMintAuthority = _context47.sent;
            txBatch = new TransactionsBatch({
              transactions: []
            });
            txOptions = {
              feePayer: wallet.publicKey
            };
            _context47.next = 10;
            return Vault.load(connection, vault);

          case 10:
            _yield$Vault$load = _context47.sent;
            _yield$Vault$load$dat = _yield$Vault$load.data;
            fractionMint = _yield$Vault$load$dat.fractionMint;
            fractionTreasury = _yield$Vault$load$dat.fractionTreasury;
            redeemTreasury = _yield$Vault$load$dat.redeemTreasury;
            pricingLookupAddress = _yield$Vault$load$dat.pricingLookupAddress;
            fractionMintKey = new PublicKey(fractionMint);
            fractionTreasuryKey = new PublicKey(fractionTreasury);
            redeemTreasuryKey = new PublicKey(redeemTreasury);
            pricingLookupAddressKey = new PublicKey(pricingLookupAddress);
            activateVaultTx = new ActivateVault(txOptions, {
              vault: vault,
              numberOfShares: new BN(0),
              fractionMint: fractionMintKey,
              fractionTreasury: fractionTreasuryKey,
              fractionMintAuthority: fractionMintAuthority,
              vaultAuthority: wallet.publicKey
            });
            txBatch.addTransaction(activateVaultTx);
            outstandingShareAccount = Keypair.generate();
            outstandingShareAccountTx = new CreateTokenAccount(txOptions, {
              newAccountPubkey: outstandingShareAccount.publicKey,
              lamports: accountRent,
              mint: fractionMintKey,
              owner: wallet.publicKey
            });
            txBatch.addTransaction(outstandingShareAccountTx);
            txBatch.addSigner(outstandingShareAccount);
            payingTokenAccount = Keypair.generate();
            payingTokenAccountTx = new CreateTokenAccount(txOptions, {
              newAccountPubkey: payingTokenAccount.publicKey,
              lamports: accountRent,
              mint: priceMint,
              owner: wallet.publicKey
            });
            txBatch.addTransaction(payingTokenAccountTx);
            txBatch.addSigner(payingTokenAccount);
            transferAuthority = Keypair.generate();

            createApproveTx = function createApproveTx(account) {
              return new Transaction().add(Token.createApproveInstruction(TOKEN_PROGRAM_ID, account.publicKey, transferAuthority.publicKey, wallet.publicKey, [], 0));
            };

            txBatch.addTransaction(createApproveTx(payingTokenAccount));
            txBatch.addTransaction(createApproveTx(outstandingShareAccount));
            txBatch.addSigner(transferAuthority);
            combineVaultTx = new CombineVault(txOptions, {
              vault: vault,
              outstandingShareTokenAccount: outstandingShareAccount.publicKey,
              payingTokenAccount: payingTokenAccount.publicKey,
              fractionMint: fractionMintKey,
              fractionTreasury: fractionTreasuryKey,
              redeemTreasury: redeemTreasuryKey,
              burnAuthority: fractionMintAuthority,
              externalPriceAccount: pricingLookupAddressKey,
              transferAuthority: transferAuthority.publicKey,
              vaultAuthority: wallet.publicKey,
              newVaultAuthority: wallet.publicKey
            });
            txBatch.addTransaction(combineVaultTx);
            _context47.next = 39;
            return sendTransaction({
              connection: connection,
              signers: txBatch.signers,
              txs: txBatch.transactions,
              wallet: wallet
            });

          case 39:
            txId = _context47.sent;
            return _context47.abrupt("return", {
              txId: txId
            });

          case 41:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47);
  }));
};

var createVault = function createVault(_ref23) {
  var connection = _ref23.connection,
      wallet = _ref23.wallet,
      _ref23$priceMint = _ref23.priceMint,
      priceMint = _ref23$priceMint === void 0 ? NATIVE_MINT : _ref23$priceMint,
      externalPriceAccount = _ref23.externalPriceAccount;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
    var accountRent, mintRent, vaultRent, vault, vaultAuthority, txBatch, fractionMint, fractionMintTx, redeemTreasury, redeemTreasuryTx, fractionTreasury, fractionTreasuryTx, uninitializedVaultTx, initVaultTx, txId;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            _context48.next = 2;
            return connection.getMinimumBalanceForRentExemption(AccountLayout.span);

          case 2:
            accountRent = _context48.sent;
            _context48.next = 5;
            return connection.getMinimumBalanceForRentExemption(MintLayout.span);

          case 5:
            mintRent = _context48.sent;
            _context48.next = 8;
            return connection.getMinimumBalanceForRentExemption(Vault.MAX_VAULT_SIZE);

          case 8:
            vaultRent = _context48.sent;
            vault = Keypair.generate();
            _context48.next = 12;
            return Vault.getPDA(vault.publicKey);

          case 12:
            vaultAuthority = _context48.sent;
            txBatch = new TransactionsBatch({
              transactions: []
            });
            fractionMint = Keypair.generate();
            fractionMintTx = new CreateMint({
              feePayer: wallet.publicKey
            }, {
              newAccountPubkey: fractionMint.publicKey,
              lamports: mintRent,
              owner: vaultAuthority,
              freezeAuthority: vaultAuthority
            });
            txBatch.addTransaction(fractionMintTx);
            txBatch.addSigner(fractionMint);
            redeemTreasury = Keypair.generate();
            redeemTreasuryTx = new CreateTokenAccount({
              feePayer: wallet.publicKey
            }, {
              newAccountPubkey: redeemTreasury.publicKey,
              lamports: accountRent,
              mint: priceMint,
              owner: vaultAuthority
            });
            txBatch.addTransaction(redeemTreasuryTx);
            txBatch.addSigner(redeemTreasury);
            fractionTreasury = Keypair.generate();
            fractionTreasuryTx = new CreateTokenAccount({
              feePayer: wallet.publicKey
            }, {
              newAccountPubkey: fractionTreasury.publicKey,
              lamports: accountRent,
              mint: fractionMint.publicKey,
              owner: vaultAuthority
            });
            txBatch.addTransaction(fractionTreasuryTx);
            txBatch.addSigner(fractionTreasury);
            uninitializedVaultTx = new Transaction().add(SystemProgram.createAccount({
              fromPubkey: wallet.publicKey,
              newAccountPubkey: vault.publicKey,
              lamports: vaultRent,
              space: Vault.MAX_VAULT_SIZE,
              programId: VaultProgram.PUBKEY
            }));
            txBatch.addTransaction(uninitializedVaultTx);
            txBatch.addSigner(vault);
            initVaultTx = new InitVault({
              feePayer: wallet.publicKey
            }, {
              vault: vault.publicKey,
              vaultAuthority: wallet.publicKey,
              fractionalTreasury: fractionTreasury.publicKey,
              pricingLookupAddress: externalPriceAccount,
              redeemTreasury: redeemTreasury.publicKey,
              fractionalMint: fractionMint.publicKey,
              allowFurtherShareCreation: true
            });
            txBatch.addTransaction(initVaultTx);
            _context48.next = 33;
            return sendTransaction({
              connection: connection,
              signers: txBatch.signers,
              txs: txBatch.transactions,
              wallet: wallet
            });

          case 33:
            txId = _context48.sent;
            return _context48.abrupt("return", {
              txId: txId,
              vault: vault.publicKey,
              fractionMint: fractionMint.publicKey,
              redeemTreasury: redeemTreasury.publicKey,
              fractionTreasury: fractionTreasury.publicKey
            });

          case 35:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }));
};

var createExternalPriceAccount = function createExternalPriceAccount(_ref24) {
  var connection = _ref24.connection,
      wallet = _ref24.wallet;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
    var txBatch, txOptions, epaRentExempt, externalPriceAccount, externalPriceAccountData, uninitializedEPA, updateEPA, txId;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            txBatch = new TransactionsBatch({
              transactions: []
            });
            txOptions = {
              feePayer: wallet.publicKey
            };
            _context49.next = 4;
            return connection.getMinimumBalanceForRentExemption(Vault.MAX_EXTERNAL_ACCOUNT_SIZE);

          case 4:
            epaRentExempt = _context49.sent;
            externalPriceAccount = Keypair.generate();
            externalPriceAccountData = new ExternalPriceAccountData({
              pricePerShare: new BN(0),
              priceMint: NATIVE_MINT.toBase58(),
              allowedToCombine: true
            });
            uninitializedEPA = new Transaction().add(SystemProgram.createAccount({
              fromPubkey: wallet.publicKey,
              newAccountPubkey: externalPriceAccount.publicKey,
              lamports: epaRentExempt,
              space: Vault.MAX_EXTERNAL_ACCOUNT_SIZE,
              programId: VaultProgram.PUBKEY
            }));
            txBatch.addTransaction(uninitializedEPA);
            txBatch.addSigner(externalPriceAccount);
            updateEPA = new UpdateExternalPriceAccount(txOptions, {
              externalPriceAccount: externalPriceAccount.publicKey,
              externalPriceAccountData: externalPriceAccountData
            });
            txBatch.addTransaction(updateEPA);
            _context49.next = 14;
            return sendTransaction({
              connection: connection,
              signers: txBatch.signers,
              txs: txBatch.transactions,
              wallet: wallet
            });

          case 14:
            txId = _context49.sent;
            return _context49.abrupt("return", {
              txId: txId,
              externalPriceAccount: externalPriceAccount.publicKey,
              priceMint: NATIVE_MINT
            });

          case 16:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }));
};

var createMetadata = function createMetadata() {
  var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      connection = _ref25.connection,
      wallet = _ref25.wallet,
      editionMint = _ref25.editionMint,
      metadataData = _ref25.metadataData,
      updateAuthority = _ref25.updateAuthority;

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
    var metadata, createMetadataTx;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.next = 2;
            return Metadata.getPDA(editionMint);

          case 2:
            metadata = _context50.sent;
            createMetadataTx = new CreateMetadata({
              feePayer: wallet.publicKey
            }, {
              metadata: metadata,
              metadataData: metadataData,
              updateAuthority: updateAuthority !== null && updateAuthority !== void 0 ? updateAuthority : wallet.publicKey,
              mint: editionMint,
              mintAuthority: wallet.publicKey
            });
            return _context50.abrupt("return", sendTransaction({
              connection: connection,
              signers: [],
              txs: [createMetadataTx],
              wallet: wallet
            }));

          case 5:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50);
  }));
};

var createMasterEdition = function createMasterEdition() {
  var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      connection = _ref26.connection,
      wallet = _ref26.wallet,
      editionMint = _ref26.editionMint,
      updateAuthority = _ref26.updateAuthority,
      maxSupply = _ref26.maxSupply;

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
    var metadata, edition, createMetadataTx;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            _context51.next = 2;
            return Metadata.getPDA(editionMint);

          case 2:
            metadata = _context51.sent;
            _context51.next = 5;
            return MasterEdition.getPDA(editionMint);

          case 5:
            edition = _context51.sent;
            createMetadataTx = new CreateMasterEdition({
              feePayer: wallet.publicKey
            }, {
              edition: edition,
              metadata: metadata,
              updateAuthority: updateAuthority !== null && updateAuthority !== void 0 ? updateAuthority : wallet.publicKey,
              mint: editionMint,
              mintAuthority: wallet.publicKey,
              maxSupply: maxSupply
            });
            return _context51.abrupt("return", sendTransaction({
              connection: connection,
              signers: [],
              txs: [createMetadataTx],
              wallet: wallet
            }));

          case 8:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51);
  }));
};

var signMetadata = function signMetadata() {
  var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      connection = _ref27.connection,
      wallet = _ref27.wallet,
      editionMint = _ref27.editionMint,
      signer = _ref27.signer;

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
    var metadata, signTx;
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            _context52.next = 2;
            return Metadata.getPDA(editionMint);

          case 2:
            metadata = _context52.sent;
            signTx = new SignMetadata({
              feePayer: wallet.publicKey
            }, {
              metadata: metadata,
              creator: signer ? signer.publicKey : wallet.publicKey
            });
            _context52.next = 6;
            return sendTransaction({
              connection: connection,
              signers: signer ? [signer] : [],
              txs: [signTx],
              wallet: wallet
            });

          case 6:
            return _context52.abrupt("return", _context52.sent);

          case 7:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52);
  }));
};

var updateMetadata = function updateMetadata() {
  var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      connection = _ref28.connection,
      wallet = _ref28.wallet,
      editionMint = _ref28.editionMint,
      newMetadataData = _ref28.newMetadataData,
      newUpdateAuthority = _ref28.newUpdateAuthority,
      primarySaleHappened = _ref28.primarySaleHappened;

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
    var metadata, updateTx;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _context53.next = 2;
            return Metadata.getPDA(editionMint);

          case 2:
            metadata = _context53.sent;
            updateTx = new UpdateMetadata({
              feePayer: wallet.publicKey
            }, {
              metadata: metadata,
              updateAuthority: wallet.publicKey,
              metadataData: newMetadataData,
              newUpdateAuthority: newUpdateAuthority,
              primarySaleHappened: primarySaleHappened
            });
            return _context53.abrupt("return", sendTransaction({
              connection: connection,
              signers: [],
              txs: [updateTx],
              wallet: wallet
            }));

          case 5:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  }));
};

var cancelBid = function cancelBid(_ref29) {
  var connection = _ref29.connection,
      wallet = _ref29.wallet,
      auction = _ref29.auction,
      bidderPotToken = _ref29.bidderPotToken,
      destAccount = _ref29.destAccount;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
    var bidder, auctionManager, manager, _yield$manager$getAuc, tokenMint, auctionTokenMint, vault, auctionExtended, bidderPot, bidderMeta, accountRentExempt, txBatch, txId;

    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            bidder = wallet.publicKey;
            _context54.next = 3;
            return AuctionManager.getPDA(auction);

          case 3:
            auctionManager = _context54.sent;
            _context54.next = 6;
            return AuctionManager.load(connection, auctionManager);

          case 6:
            manager = _context54.sent;
            _context54.next = 9;
            return manager.getAuction(connection);

          case 9:
            _yield$manager$getAuc = _context54.sent;
            tokenMint = _yield$manager$getAuc.data.tokenMint;
            auctionTokenMint = new PublicKey(tokenMint);
            vault = new PublicKey(manager.data.vault);
            _context54.next = 15;
            return AuctionExtended.getPDA(vault);

          case 15:
            auctionExtended = _context54.sent;
            _context54.next = 18;
            return BidderPot.getPDA(auction, bidder);

          case 18:
            bidderPot = _context54.sent;
            _context54.next = 21;
            return BidderMetadata.getPDA(auction, bidder);

          case 21:
            bidderMeta = _context54.sent;
            _context54.next = 24;
            return connection.getMinimumBalanceForRentExemption(AccountLayout.span);

          case 24:
            accountRentExempt = _context54.sent;
            _context54.next = 27;
            return getCancelBidTransactions({
              destAccount: destAccount,
              bidder: bidder,
              accountRentExempt: accountRentExempt,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken,
              bidderMeta: bidderMeta,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionTokenMint: auctionTokenMint,
              vault: vault
            });

          case 27:
            txBatch = _context54.sent;
            _context54.next = 30;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: txBatch.toTransactions(),
              signers: txBatch.signers
            });

          case 30:
            txId = _context54.sent;
            return _context54.abrupt("return", {
              txId: txId
            });

          case 32:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }));
};

var getCancelBidTransactions = function getCancelBidTransactions(_ref30) {
  var destAccount = _ref30.destAccount,
      bidder = _ref30.bidder,
      accountRentExempt = _ref30.accountRentExempt,
      bidderPot = _ref30.bidderPot,
      bidderPotToken = _ref30.bidderPotToken,
      bidderMeta = _ref30.bidderMeta,
      auction = _ref30.auction,
      auctionExtended = _ref30.auctionExtended,
      auctionTokenMint = _ref30.auctionTokenMint,
      vault = _ref30.vault;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
    var txBatch, account, createTokenAccountTransaction, closeTokenAccountInstruction, cancelBidTransaction;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            txBatch = new TransactionsBatch({
              transactions: []
            });

            if (!destAccount) {
              account = Keypair.generate();
              createTokenAccountTransaction = new CreateTokenAccount({
                feePayer: bidder
              }, {
                newAccountPubkey: account.publicKey,
                lamports: accountRentExempt,
                mint: NATIVE_MINT
              });
              closeTokenAccountInstruction = new Transaction().add(Token.createCloseAccountInstruction(TOKEN_PROGRAM_ID, account.publicKey, bidder, bidder, []));
              txBatch.addTransaction(createTokenAccountTransaction);
              txBatch.addAfterTransaction(closeTokenAccountInstruction);
              txBatch.addSigner(account);
              destAccount = account.publicKey;
            }

            cancelBidTransaction = new CancelBid({
              feePayer: bidder
            }, {
              bidder: bidder,
              bidderToken: destAccount,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken,
              bidderMeta: bidderMeta,
              auction: auction,
              auctionExtended: auctionExtended,
              tokenMint: auctionTokenMint,
              resource: vault
            });
            txBatch.addTransaction(cancelBidTransaction);
            return _context55.abrupt("return", txBatch);

          case 5:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55);
  }));
};

var placeBid = function placeBid(_ref31) {
  var connection = _ref31.connection,
      wallet = _ref31.wallet,
      amount = _ref31.amount,
      auction = _ref31.auction,
      bidderPotToken = _ref31.bidderPotToken;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
    var bidder, accountRentExempt, auctionManager, manager, _yield$manager$getAuc2, tokenMint, auctionTokenMint, vault, auctionExtended, bidderPot, bidderMeta, txBatch, account, createBidderPotTransaction, payingAccount, createTokenAccountTransaction, closeTokenAccountTransaction, transferAuthority, createApproveTransaction, createRevokeTransaction, placeBidTransaction, txId;

    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            bidder = wallet.publicKey;
            _context56.next = 3;
            return connection.getMinimumBalanceForRentExemption(AccountLayout.span);

          case 3:
            accountRentExempt = _context56.sent;
            _context56.next = 6;
            return AuctionManager.getPDA(auction);

          case 6:
            auctionManager = _context56.sent;
            _context56.next = 9;
            return AuctionManager.load(connection, auctionManager);

          case 9:
            manager = _context56.sent;
            _context56.next = 12;
            return manager.getAuction(connection);

          case 12:
            _yield$manager$getAuc2 = _context56.sent;
            tokenMint = _yield$manager$getAuc2.data.tokenMint;
            auctionTokenMint = new PublicKey(tokenMint);
            vault = new PublicKey(manager.data.vault);
            _context56.next = 18;
            return AuctionExtended.getPDA(vault);

          case 18:
            auctionExtended = _context56.sent;
            _context56.next = 21;
            return BidderPot.getPDA(auction, bidder);

          case 21:
            bidderPot = _context56.sent;
            _context56.next = 24;
            return BidderMetadata.getPDA(auction, bidder);

          case 24:
            bidderMeta = _context56.sent;
            txBatch = new TransactionsBatch({
              transactions: []
            });

            if (!bidderPotToken) {
              _context56.next = 32;
              break;
            }

            _context56.next = 29;
            return getCancelBidTransactions({
              destAccount: null,
              bidder: bidder,
              accountRentExempt: accountRentExempt,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken,
              bidderMeta: bidderMeta,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionTokenMint: auctionTokenMint,
              vault: vault
            });

          case 29:
            txBatch = _context56.sent;
            _context56.next = 37;
            break;

          case 32:
            account = Keypair.generate();
            createBidderPotTransaction = new CreateTokenAccount({
              feePayer: bidder
            }, {
              newAccountPubkey: account.publicKey,
              lamports: accountRentExempt,
              mint: auctionTokenMint,
              owner: auction
            });
            txBatch.addSigner(account);
            txBatch.addTransaction(createBidderPotTransaction);
            bidderPotToken = account.publicKey;

          case 37:
            payingAccount = Keypair.generate();
            createTokenAccountTransaction = new CreateTokenAccount({
              feePayer: bidder
            }, {
              newAccountPubkey: payingAccount.publicKey,
              lamports: amount.toNumber() + accountRentExempt * 3,
              mint: NATIVE_MINT
            });
            closeTokenAccountTransaction = new Transaction().add(Token.createCloseAccountInstruction(TOKEN_PROGRAM_ID, payingAccount.publicKey, bidder, bidder, []));
            txBatch.addTransaction(createTokenAccountTransaction);
            txBatch.addAfterTransaction(closeTokenAccountTransaction);
            txBatch.addSigner(payingAccount);
            transferAuthority = Keypair.generate();
            createApproveTransaction = new Transaction().add(Token.createApproveInstruction(TOKEN_PROGRAM_ID, payingAccount.publicKey, transferAuthority.publicKey, bidder, [], amount.toNumber()));
            txBatch.addTransaction(createApproveTransaction);
            createRevokeTransaction = new Transaction().add(Token.createRevokeInstruction(TOKEN_PROGRAM_ID, payingAccount.publicKey, bidder, []));
            txBatch.addAfterTransaction(createRevokeTransaction);
            txBatch.addSigner(transferAuthority);
            placeBidTransaction = new PlaceBid({
              feePayer: bidder
            }, {
              bidder: bidder,
              bidderToken: payingAccount.publicKey,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken,
              bidderMeta: bidderMeta,
              auction: auction,
              auctionExtended: auctionExtended,
              tokenMint: auctionTokenMint,
              transferAuthority: transferAuthority.publicKey,
              amount: amount,
              resource: vault
            });
            txBatch.addTransaction(placeBidTransaction);
            _context56.next = 53;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: txBatch.toTransactions(),
              signers: txBatch.signers
            });

          case 53:
            txId = _context56.sent;
            return _context56.abrupt("return", {
              txId: txId,
              bidderPotToken: bidderPotToken,
              bidderMeta: bidderMeta
            });

          case 55:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }));
};

var redeemBid = function redeemBid(_ref32) {
  var connection = _ref32.connection,
      wallet = _ref32.wallet,
      store = _ref32.store,
      auction = _ref32.auction;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
    var bidder, accountRentExempt, auctionManager, manager, vault, fractionMint, auctionExtended, _yield$vault$getSafet, _yield$vault$getSafet2, safetyDepositBox, tokenMint, safetyDepositTokenStore, bidderMeta, bidRedemption, safetyDepositConfig, transferAuthority, metadata, txBatch, txId;

    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            bidder = wallet.publicKey;
            _context57.next = 3;
            return connection.getMinimumBalanceForRentExemption(AccountLayout.span);

          case 3:
            accountRentExempt = _context57.sent;
            _context57.next = 6;
            return AuctionManager.getPDA(auction);

          case 6:
            auctionManager = _context57.sent;
            _context57.next = 9;
            return AuctionManager.load(connection, auctionManager);

          case 9:
            manager = _context57.sent;
            _context57.next = 12;
            return Vault.load(connection, manager.data.vault);

          case 12:
            vault = _context57.sent;
            fractionMint = new PublicKey(vault.data.fractionMint);
            _context57.next = 16;
            return AuctionExtended.getPDA(vault.pubkey);

          case 16:
            auctionExtended = _context57.sent;
            _context57.next = 19;
            return vault.getSafetyDepositBoxes(connection);

          case 19:
            _yield$vault$getSafet = _context57.sent;
            _yield$vault$getSafet2 = _slicedToArray(_yield$vault$getSafet, 1);
            safetyDepositBox = _yield$vault$getSafet2[0];
            tokenMint = new PublicKey(safetyDepositBox.data.tokenMint);
            safetyDepositTokenStore = new PublicKey(safetyDepositBox.data.store);
            _context57.next = 26;
            return BidderMetadata.getPDA(auction, bidder);

          case 26:
            bidderMeta = _context57.sent;
            _context57.next = 29;
            return getBidRedemptionPDA(auction, bidderMeta);

          case 29:
            bidRedemption = _context57.sent;
            _context57.next = 32;
            return SafetyDepositConfig.getPDA(auctionManager, safetyDepositBox.pubkey);

          case 32:
            safetyDepositConfig = _context57.sent;
            _context57.next = 35;
            return Vault.getPDA(vault.pubkey);

          case 35:
            transferAuthority = _context57.sent;
            _context57.next = 38;
            return Metadata.getPDA(tokenMint);

          case 38:
            metadata = _context57.sent;
            _context57.next = 41;
            return getRedeemBidTransactions({
              accountRentExempt: accountRentExempt,
              tokenMint: tokenMint,
              bidder: bidder,
              bidderMeta: bidderMeta,
              store: store,
              vault: vault.pubkey,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionManager: auctionManager,
              fractionMint: fractionMint,
              safetyDepositTokenStore: safetyDepositTokenStore,
              safetyDeposit: safetyDepositBox.pubkey,
              bidRedemption: bidRedemption,
              safetyDepositConfig: safetyDepositConfig,
              transferAuthority: transferAuthority,
              metadata: metadata
            });

          case 41:
            txBatch = _context57.sent;
            _context57.next = 44;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: txBatch.toTransactions(),
              signers: txBatch.signers
            });

          case 44:
            txId = _context57.sent;
            return _context57.abrupt("return", {
              txId: txId
            });

          case 46:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57);
  }));
};

var getRedeemBidTransactions = function getRedeemBidTransactions(_ref33) {
  var accountRentExempt = _ref33.accountRentExempt,
      bidder = _ref33.bidder,
      tokenMint = _ref33.tokenMint,
      store = _ref33.store,
      vault = _ref33.vault,
      auction = _ref33.auction,
      auctionManager = _ref33.auctionManager,
      auctionExtended = _ref33.auctionExtended,
      bidRedemption = _ref33.bidRedemption,
      bidMetadata = _ref33.bidderMeta,
      safetyDepositTokenStore = _ref33.safetyDepositTokenStore,
      safetyDeposit = _ref33.safetyDeposit,
      fractionMint = _ref33.fractionMint,
      safetyDepositConfig = _ref33.safetyDepositConfig,
      transferAuthority = _ref33.transferAuthority,
      metadata = _ref33.metadata;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
    var txBatch, account, createDestinationTransaction, redeemBidTransaction, updatePrimarySaleHappenedViaTokenTransaction;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            txBatch = new TransactionsBatch({
              transactions: []
            });
            account = Keypair.generate();
            createDestinationTransaction = new CreateTokenAccount({
              feePayer: bidder
            }, {
              newAccountPubkey: account.publicKey,
              lamports: accountRentExempt,
              mint: tokenMint
            });
            txBatch.addSigner(account);
            txBatch.addTransaction(createDestinationTransaction);
            redeemBidTransaction = new RedeemFullRightsTransferBid({
              feePayer: bidder
            }, {
              store: store,
              vault: vault,
              auction: auction,
              auctionManager: auctionManager,
              bidRedemption: bidRedemption,
              bidMetadata: bidMetadata,
              safetyDepositTokenStore: safetyDepositTokenStore,
              destination: account.publicKey,
              safetyDeposit: safetyDeposit,
              fractionMint: fractionMint,
              bidder: bidder,
              safetyDepositConfig: safetyDepositConfig,
              auctionExtended: auctionExtended,
              transferAuthority: transferAuthority,
              newAuthority: bidder,
              masterMetadata: metadata
            });
            txBatch.addTransaction(redeemBidTransaction);
            updatePrimarySaleHappenedViaTokenTransaction = new UpdatePrimarySaleHappenedViaToken({
              feePayer: bidder
            }, {
              metadata: metadata,
              owner: bidder,
              tokenAccount: account.publicKey
            });
            txBatch.addTransaction(updatePrimarySaleHappenedViaTokenTransaction);
            return _context58.abrupt("return", txBatch);

          case 10:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58);
  }));
};

var getBidRedemptionPDA = function getBidRedemptionPDA(auction, bidderMeta) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            _context59.next = 2;
            return PublicKey.findProgramAddress([Buffer.from(MetaplexProgram.PREFIX), auction.toBuffer(), bidderMeta.toBuffer()], MetaplexProgram.PUBKEY);

          case 2:
            return _context59.abrupt("return", _context59.sent[0]);

          case 3:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59);
  }));
};

var claimBid = function claimBid(_ref34) {
  var connection = _ref34.connection,
      wallet = _ref34.wallet,
      store = _ref34.store,
      auction = _ref34.auction,
      bidderPotToken = _ref34.bidderPotToken;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
    var bidder, auctionManager, manager, vault, _yield$Auction$load, tokenMint, acceptPayment, auctionExtended, auctionTokenMint, bidderPot, txBatch, txId;

    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            bidder = wallet.publicKey;
            _context60.next = 3;
            return AuctionManager.getPDA(auction);

          case 3:
            auctionManager = _context60.sent;
            _context60.next = 6;
            return AuctionManager.load(connection, auctionManager);

          case 6:
            manager = _context60.sent;
            vault = new PublicKey(manager.data.vault);
            _context60.next = 10;
            return Auction.load(connection, auction);

          case 10:
            _yield$Auction$load = _context60.sent;
            tokenMint = _yield$Auction$load.data.tokenMint;
            acceptPayment = new PublicKey(manager.data.acceptPayment);
            _context60.next = 15;
            return AuctionExtended.getPDA(vault);

          case 15:
            auctionExtended = _context60.sent;
            auctionTokenMint = new PublicKey(tokenMint);
            _context60.next = 19;
            return BidderPot.getPDA(auction, bidder);

          case 19:
            bidderPot = _context60.sent;
            _context60.next = 22;
            return getClaimBidTransactions({
              auctionTokenMint: auctionTokenMint,
              bidder: bidder,
              store: store,
              vault: vault,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionManager: auctionManager,
              acceptPayment: acceptPayment,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken
            });

          case 22:
            txBatch = _context60.sent;
            _context60.next = 25;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: txBatch.toTransactions(),
              signers: txBatch.signers
            });

          case 25:
            txId = _context60.sent;
            return _context60.abrupt("return", {
              txId: txId
            });

          case 27:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60);
  }));
};

var getClaimBidTransactions = function getClaimBidTransactions(_ref35) {
  var bidder = _ref35.bidder,
      auctionTokenMint = _ref35.auctionTokenMint,
      store = _ref35.store,
      vault = _ref35.vault,
      auction = _ref35.auction,
      auctionManager = _ref35.auctionManager,
      auctionExtended = _ref35.auctionExtended,
      acceptPayment = _ref35.acceptPayment,
      bidderPot = _ref35.bidderPot,
      bidderPotToken = _ref35.bidderPotToken;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
    var txBatch, claimBidTransaction;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            txBatch = new TransactionsBatch({
              transactions: []
            });
            claimBidTransaction = new ClaimBid({
              feePayer: bidder
            }, {
              store: store,
              vault: vault,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionManager: auctionManager,
              bidder: bidder,
              tokenMint: auctionTokenMint,
              acceptPayment: acceptPayment,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken
            });
            txBatch.addTransaction(claimBidTransaction);
            return _context61.abrupt("return", txBatch);

          case 4:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61);
  }));
};

var retry$2 = {};

function RetryOperation(timeouts, options) {
  // Compatibility for the old (timeouts, retryForever) signature
  if (typeof options === 'boolean') {
    options = {
      forever: options
    };
  }

  this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
  this._timeouts = timeouts;
  this._options = options || {};
  this._maxRetryTime = options && options.maxRetryTime || Infinity;
  this._fn = null;
  this._errors = [];
  this._attempts = 1;
  this._operationTimeout = null;
  this._operationTimeoutCb = null;
  this._timeout = null;
  this._operationStart = null;
  this._timer = null;

  if (this._options.forever) {
    this._cachedTimeouts = this._timeouts.slice(0);
  }
}

var retry_operation = RetryOperation;

RetryOperation.prototype.reset = function () {
  this._attempts = 1;
  this._timeouts = this._originalTimeouts.slice(0);
};

RetryOperation.prototype.stop = function () {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }

  if (this._timer) {
    clearTimeout(this._timer);
  }

  this._timeouts = [];
  this._cachedTimeouts = null;
};

RetryOperation.prototype.retry = function (err) {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }

  if (!err) {
    return false;
  }

  var currentTime = new Date().getTime();

  if (err && currentTime - this._operationStart >= this._maxRetryTime) {
    this._errors.push(err);

    this._errors.unshift(new Error('RetryOperation timeout occurred'));

    return false;
  }

  this._errors.push(err);

  var timeout = this._timeouts.shift();

  if (timeout === undefined) {
    if (this._cachedTimeouts) {
      // retry forever, only keep last error
      this._errors.splice(0, this._errors.length - 1);

      timeout = this._cachedTimeouts.slice(-1);
    } else {
      return false;
    }
  }

  var self = this;
  this._timer = setTimeout(function () {
    self._attempts++;

    if (self._operationTimeoutCb) {
      self._timeout = setTimeout(function () {
        self._operationTimeoutCb(self._attempts);
      }, self._operationTimeout);

      if (self._options.unref) {
        self._timeout.unref();
      }
    }

    self._fn(self._attempts);
  }, timeout);

  if (this._options.unref) {
    this._timer.unref();
  }

  return true;
};

RetryOperation.prototype.attempt = function (fn, timeoutOps) {
  this._fn = fn;

  if (timeoutOps) {
    if (timeoutOps.timeout) {
      this._operationTimeout = timeoutOps.timeout;
    }

    if (timeoutOps.cb) {
      this._operationTimeoutCb = timeoutOps.cb;
    }
  }

  var self = this;

  if (this._operationTimeoutCb) {
    this._timeout = setTimeout(function () {
      self._operationTimeoutCb();
    }, self._operationTimeout);
  }

  this._operationStart = new Date().getTime();

  this._fn(this._attempts);
};

RetryOperation.prototype.try = function (fn) {
  console.log('Using RetryOperation.try() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = function (fn) {
  console.log('Using RetryOperation.start() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = RetryOperation.prototype.try;

RetryOperation.prototype.errors = function () {
  return this._errors;
};

RetryOperation.prototype.attempts = function () {
  return this._attempts;
};

RetryOperation.prototype.mainError = function () {
  if (this._errors.length === 0) {
    return null;
  }

  var counts = {};
  var mainError = null;
  var mainErrorCount = 0;

  for (var i = 0; i < this._errors.length; i++) {
    var error = this._errors[i];
    var message = error.message;
    var count = (counts[message] || 0) + 1;
    counts[message] = count;

    if (count >= mainErrorCount) {
      mainError = error;
      mainErrorCount = count;
    }
  }

  return mainError;
};

(function (exports) {
  var RetryOperation = retry_operation;

  exports.operation = function (options) {
    var timeouts = exports.timeouts(options);
    return new RetryOperation(timeouts, {
      forever: options && (options.forever || options.retries === Infinity),
      unref: options && options.unref,
      maxRetryTime: options && options.maxRetryTime
    });
  };

  exports.timeouts = function (options) {
    if (options instanceof Array) {
      return [].concat(options);
    }

    var opts = {
      retries: 10,
      factor: 2,
      minTimeout: 1 * 1000,
      maxTimeout: Infinity,
      randomize: false
    };

    for (var key in options) {
      opts[key] = options[key];
    }

    if (opts.minTimeout > opts.maxTimeout) {
      throw new Error('minTimeout is greater than maxTimeout');
    }

    var timeouts = [];

    for (var i = 0; i < opts.retries; i++) {
      timeouts.push(this.createTimeout(i, opts));
    }

    if (options && options.forever && !timeouts.length) {
      timeouts.push(this.createTimeout(i, opts));
    } // sort the array numerically ascending


    timeouts.sort(function (a, b) {
      return a - b;
    });
    return timeouts;
  };

  exports.createTimeout = function (attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
  };

  exports.wrap = function (obj, options, methods) {
    if (options instanceof Array) {
      methods = options;
      options = null;
    }

    if (!methods) {
      methods = [];

      for (var key in obj) {
        if (typeof obj[key] === 'function') {
          methods.push(key);
        }
      }
    }

    for (var i = 0; i < methods.length; i++) {
      var method = methods[i];
      var original = obj[method];

      obj[method] = function retryWrapper(original) {
        var op = exports.operation(options);
        var args = Array.prototype.slice.call(arguments, 1);
        var callback = args.pop();
        args.push(function (err) {
          if (op.retry(err)) {
            return;
          }

          if (err) {
            arguments[0] = op.mainError();
          }

          callback.apply(this, arguments);
        });
        op.attempt(function () {
          original.apply(obj, args);
        });
      }.bind(obj, original);

      obj[method].options = options;
    }
  };
})(retry$2);

var retry$1 = retry$2; // Packages

var retrier = retry$1;

function retry(fn, opts) {
  function run(resolve, reject) {
    var options = opts || {};
    var op; // Default `randomize` to true

    if (!('randomize' in options)) {
      options.randomize = true;
    }

    op = retrier.operation(options); // We allow the user to abort retrying
    // this makes sense in the cases where
    // knowledge is obtained that retrying
    // would be futile (e.g.: auth errors)

    function bail(err) {
      reject(err || new Error('Aborted'));
    }

    function onError(err, num) {
      if (err.bail) {
        bail(err);
        return;
      }

      if (!op.retry(err)) {
        reject(op.mainError());
      } else if (options.onRetry) {
        options.onRetry(err, num);
      }
    }

    function runAttempt(num) {
      var val;

      try {
        val = fn(bail, num);
      } catch (err) {
        onError(err, num);
        return;
      }

      Promise.resolve(val).then(resolve).catch(function catchIt(err) {
        onError(err, num);
      });
    }

    op.attempt(runAttempt);
  }

  return new Promise(run);
}

var lib = retry;

var instantSale = function instantSale(_ref36) {
  var connection = _ref36.connection,
      wallet = _ref36.wallet,
      store = _ref36.store,
      auction = _ref36.auction;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
    var bidder, accountRentExempt, auctionManager, manager, vault, _yield$Auction$load2, tokenMint, auctionExtended, acceptPayment, _yield$AuctionExtende, instantSalePrice, auctionTokenMint, bidderPot, fractionMint, _yield$vault$getSafet3, _yield$vault$getSafet4, safetyDepositBox, metadataTokenMint, safetyDepositTokenStore, safetyDepositConfig, transferAuthority, metadata, _yield$placeBid, bidderPotToken, bidderMeta, bidRedemption, redeemBatch, claimBatch, txs, signers, txId;

    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            bidder = wallet.publicKey;
            _context63.next = 3;
            return connection.getMinimumBalanceForRentExemption(AccountLayout.span);

          case 3:
            accountRentExempt = _context63.sent;
            _context63.next = 6;
            return AuctionManager.getPDA(auction);

          case 6:
            auctionManager = _context63.sent;
            _context63.next = 9;
            return AuctionManager.load(connection, auctionManager);

          case 9:
            manager = _context63.sent;
            _context63.next = 12;
            return Vault.load(connection, manager.data.vault);

          case 12:
            vault = _context63.sent;
            _context63.next = 15;
            return Auction.load(connection, auction);

          case 15:
            _yield$Auction$load2 = _context63.sent;
            tokenMint = _yield$Auction$load2.data.tokenMint;
            _context63.next = 19;
            return AuctionExtended.getPDA(vault.pubkey);

          case 19:
            auctionExtended = _context63.sent;
            acceptPayment = new PublicKey(manager.data.acceptPayment);
            _context63.next = 23;
            return AuctionExtended.load(connection, auctionExtended);

          case 23:
            _yield$AuctionExtende = _context63.sent;
            instantSalePrice = _yield$AuctionExtende.data.instantSalePrice;
            auctionTokenMint = new PublicKey(tokenMint);
            _context63.next = 28;
            return BidderPot.getPDA(auction, bidder);

          case 28:
            bidderPot = _context63.sent;
            fractionMint = new PublicKey(vault.data.fractionMint);
            _context63.next = 32;
            return vault.getSafetyDepositBoxes(connection);

          case 32:
            _yield$vault$getSafet3 = _context63.sent;
            _yield$vault$getSafet4 = _slicedToArray(_yield$vault$getSafet3, 1);
            safetyDepositBox = _yield$vault$getSafet4[0];
            metadataTokenMint = new PublicKey(safetyDepositBox.data.tokenMint);
            safetyDepositTokenStore = new PublicKey(safetyDepositBox.data.store);
            _context63.next = 39;
            return SafetyDepositConfig.getPDA(auctionManager, safetyDepositBox.pubkey);

          case 39:
            safetyDepositConfig = _context63.sent;
            _context63.next = 42;
            return Vault.getPDA(vault.pubkey);

          case 42:
            transferAuthority = _context63.sent;
            _context63.next = 45;
            return Metadata.getPDA(metadataTokenMint);

          case 45:
            metadata = _context63.sent;
            _context63.next = 48;
            return placeBid({
              connection: connection,
              wallet: wallet,
              amount: instantSalePrice,
              auction: auction
            });

          case 48:
            _yield$placeBid = _context63.sent;
            bidderPotToken = _yield$placeBid.bidderPotToken;
            bidderMeta = _yield$placeBid.bidderMeta;
            _context63.next = 53;
            return lib(function (bail) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
                return _regeneratorRuntime.wrap(function _callee62$(_context62) {
                  while (1) {
                    switch (_context62.prev = _context62.next) {
                      case 0:
                        _context62.next = 2;
                        return Account.getInfo(connection, bidderMeta);

                      case 2:
                      case "end":
                        return _context62.stop();
                    }
                  }
                }, _callee62);
              }));
            });

          case 53:
            _context63.next = 55;
            return getBidRedemptionPDA(auction, bidderMeta);

          case 55:
            bidRedemption = _context63.sent;
            _context63.next = 58;
            return getRedeemBidTransactions({
              accountRentExempt: accountRentExempt,
              tokenMint: metadataTokenMint,
              bidder: bidder,
              bidderMeta: bidderMeta,
              store: store,
              vault: vault.pubkey,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionManager: auctionManager,
              fractionMint: fractionMint,
              safetyDepositTokenStore: safetyDepositTokenStore,
              safetyDeposit: safetyDepositBox.pubkey,
              bidRedemption: bidRedemption,
              safetyDepositConfig: safetyDepositConfig,
              transferAuthority: transferAuthority,
              metadata: metadata
            });

          case 58:
            redeemBatch = _context63.sent;
            _context63.next = 61;
            return getClaimBidTransactions({
              auctionTokenMint: auctionTokenMint,
              bidder: bidder,
              store: store,
              vault: vault.pubkey,
              auction: auction,
              auctionExtended: auctionExtended,
              auctionManager: auctionManager,
              acceptPayment: acceptPayment,
              bidderPot: bidderPot,
              bidderPotToken: bidderPotToken
            });

          case 61:
            claimBatch = _context63.sent;
            txs = [].concat(_toConsumableArray(redeemBatch.toTransactions()), _toConsumableArray(claimBatch.toTransactions()));
            signers = [].concat(_toConsumableArray(redeemBatch.signers), _toConsumableArray(claimBatch.signers));
            _context63.next = 66;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: txs,
              signers: signers
            });

          case 66:
            txId = _context63.sent;
            return _context63.abrupt("return", {
              txId: txId
            });

          case 68:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63);
  }));
};

var burnToken = function burnToken(_ref37) {
  var connection = _ref37.connection,
      wallet = _ref37.wallet,
      token = _ref37.token,
      mint = _ref37.mint,
      amount = _ref37.amount,
      owner = _ref37.owner,
      _ref37$close = _ref37.close,
      close = _ref37$close === void 0 ? true : _ref37$close;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
    var tx, txId;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            tx = new Transaction({
              feePayer: wallet.publicKey
            }).add(Token.createBurnInstruction(TOKEN_PROGRAM_ID, mint, token, owner !== null && owner !== void 0 ? owner : wallet.publicKey, [], amount));

            if (close) {
              tx.add(Token.createCloseAccountInstruction(TOKEN_PROGRAM_ID, token, wallet.publicKey, owner !== null && owner !== void 0 ? owner : wallet.publicKey, []));
            }

            _context64.next = 4;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: [tx]
            });

          case 4:
            txId = _context64.sent;
            return _context64.abrupt("return", {
              txId: txId
            });

          case 6:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64);
  }));
};

var sendToken = function sendToken(_ref38) {
  var connection = _ref38.connection,
      wallet = _ref38.wallet,
      source = _ref38.source,
      destination = _ref38.destination,
      mint = _ref38.mint,
      amount = _ref38.amount;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
    var txs, destAta, transactionCtorFields, txId;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            txs = [];
            _context65.next = 3;
            return Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, mint, destination);

          case 3:
            destAta = _context65.sent;
            transactionCtorFields = {
              feePayer: wallet.publicKey
            };
            _context65.prev = 5;
            _context65.next = 8;
            return Account.load(connection, destAta);

          case 8:
            _context65.next = 13;
            break;

          case 10:
            _context65.prev = 10;
            _context65.t0 = _context65["catch"](5);
            txs.push(new CreateAssociatedTokenAccount(transactionCtorFields, {
              associatedTokenAddress: destAta,
              splTokenMintAddress: mint,
              walletAddress: destination
            }));

          case 13:
            txs.push(new Transaction(transactionCtorFields).add(Token.createTransferInstruction(TOKEN_PROGRAM_ID, source, destAta, wallet.publicKey, [], amount)));
            _context65.next = 16;
            return sendTransaction({
              connection: connection,
              wallet: wallet,
              txs: txs
            });

          case 16:
            txId = _context65.sent;
            return _context65.abrupt("return", {
              txId: txId
            });

          case 18:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65, null, [[5, 10]]);
  }));
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sendTransaction: sendTransaction,
  initStore: initStore,
  mintNFT: mintNFT,
  mintEditionFromMaster: mintEditionFromMaster,
  closeVault: closeVault,
  createVault: createVault,
  createExternalPriceAccount: createExternalPriceAccount,
  createMetadata: createMetadata,
  createMasterEdition: createMasterEdition,
  signMetadata: signMetadata,
  updateMetadata: updateMetadata,
  cancelBid: cancelBid,
  getCancelBidTransactions: getCancelBidTransactions,
  placeBid: placeBid,
  redeemBid: redeemBid,
  getRedeemBidTransactions: getRedeemBidTransactions,
  getBidRedemptionPDA: getBidRedemptionPDA,
  claimBid: claimBid,
  getClaimBidTransactions: getClaimBidTransactions,
  instantSale: instantSale,
  burnToken: burnToken,
  sendToken: sendToken,
  prepareTokenAccountAndMintTx: prepareTokenAccountAndMintTx
});
export { Account, ArweaveStorage, ChainId, Coingecko, Connection, Currency, ENV, NodeWallet, index as actions, errors, index$1 as programs, index$6 as utils };